/* (v56) pdf-lib, pdf.js and JSZip are no longer loaded by every page (about
   320 KB compressed that most visitors -- who only read the page -- never
   use): pcLoadPdfLibs() below fetches them on the first file or as soon as
   a visitor points at a drop zone, and every tool awaits it before it
   starts. So this banner is no longer a check at start-up: it is shown when
   such an early load fails (and removed once a later attempt succeeds); the
   tool that needs the libraries also reports the failure in its own status.
   Kept position:fixed (not the page's normal flow): real-world Cloudflare
   Web Analytics data traced a measurable slice of visits' CLS to this
   banner when it used to be prepended into the flow, pushing the whole
   page down well after first paint. A fixed overlay never displaces any
   other element, so it can't register as a layout shift. */
const PC_LIB_BANNER_ID = 'pc-lib-banner';
function pcShowLibBanner(show){
  const old = document.getElementById(PC_LIB_BANNER_ID);
  if(!show){ if(old) old.remove(); return; }
  if(old) return;
  const banner = document.createElement('div');
  banner.id = PC_LIB_BANNER_ID;
  banner.setAttribute('role','alert');
  banner.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:999;background:#FBECE8;color:#A23E2E;padding:14px 20px;text-align:center;font-family:sans-serif;font-size:0.9rem;border-bottom:1px solid #E0B4A8;box-shadow:0 2px 8px rgba(0,0,0,0.12);';
  // (v55) in the page's language (independent of PC_MSG, which may not be set up yet)
  const LIB_MISSING = {
    nl: 'Sommige onderdelen konden niet geladen worden (door een verbindingsprobleem of een adblocker). De tools werken mogelijk pas nadat je de pagina vernieuwt of je verbinding controleert.',
    fr: "Certains éléments n'ont pas pu être chargés (problème de connexion ou bloqueur de publicités). Les outils risquent de ne pas fonctionner tant que vous n'aurez pas actualisé la page ou vérifié votre connexion.",
    de: 'Einige Bestandteile konnten nicht geladen werden (Verbindungsproblem oder Werbeblocker). Die Tools funktionieren möglicherweise erst, wenn Sie die Seite neu laden oder Ihre Verbindung prüfen.',
    es: 'Algunos componentes no se han podido cargar (por un problema de conexión o un bloqueador de anuncios). Es posible que las herramientas no funcionen hasta que actualices la página o compruebes tu conexión.',
    pt: 'Alguns componentes não puderam ser carregados (problema de conexão ou bloqueador de anúncios). As ferramentas podem não funcionar até você atualizar a página ou verificar sua conexão.', it: "Alcuni componenti necessari non sono stati caricati (forse per un problema di connessione o per un blocco degli annunci). Gli strumenti di questa pagina potrebbero non funzionare finché non ricarichi la pagina o controlli la connessione.", pl: "Nie udało się wczytać niektórych potrzebnych składników (może przez problem z połączeniem albo blokadę reklam). Narzędzia na tej stronie mogą nie działać, dopóki nie odświeżysz strony lub nie sprawdzisz połączenia.",
  };
  const lang = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2);
  banner.textContent = LIB_MISSING[lang] || 'Some required components failed to load (possibly due to a connection issue or an ad blocker). The tools on this page may not work until you refresh the page or check your connection.';
  document.body.prepend(banner);
}

/* (v52) The Word and PowerPoint libraries (about 400 KB compressed) are
   loaded only when a conversion needs them -- or as soon as a file is added
   on a page that has those tools -- instead of on every page view. Same
   pinned versions and Subresource Integrity as before; (v55) served by this
   site itself from /vendor/, no longer from cdn.jsdelivr.net. */
/* (v58) this release's suffix ("?v=58"), taken from the address app.js
   itself was loaded with, so our own lazily loaded scripts come from the
   same release (and from the service worker's cache when offline) */
const PC_REL = (document.currentScript && document.currentScript.src) ? new URL(document.currentScript.src).search : '';
/* (v96) The release this file was built for (build.mjs fills it in). A tab
   left open across a release still asks for "app-convert.js?v=<old>", and
   the server answers with the NEW file: old and new code mixed, with odd
   errors. Our own lazily loaded files carry their release too; a mismatch
   asks the visitor to reload instead. */
const PC_BUILD = '164';
const PC_LAZY_LIBS = {
  // (v58) our own Word/PowerPoint conversion code (app-convert.js, ~570 KB
  // readable): only needed when a visitor converts, so no longer part of
  // every page view. Same site, same release: no integrity hash needed.
  convert: { global: 'convertOneFileToWord', src: '/app-convert.js' + PC_REL, build: 'PC_CONVERT_BUILD' },
  // (v62) page previews to pick pages (Split, Rotate, Delete, Extract)
  thumbs: { global: 'PCThumbs', src: '/pc-thumbs.js' + PC_REL, build: 'PC_THUMBS_BUILD' },
  docx: { global: 'docx', src: '/vendor/docx-9.15.1/index.iife.js', integrity: 'sha384-ud8085E8t6iW4uUom5nN5cpzTZ4OdsNKB/AKWfOsI62tzsoV2X7r7/o4KWESO8rq' },
  pptx: { global: 'PptxGenJS', src: '/vendor/pptxgenjs-4.0.1/pptxgen.bundle.js', integrity: 'sha384-qb0Xhi7LLYpvW1HCK6oMrmDLSY9sy7vwm6ZlV6KjtrlL9yg30+YN4neTwnmX+Kp8' },
  // (v56) the three libraries every tool uses, formerly <script defer> in each page's <head>
  pdflib: { global: 'PDFLib', src: '/vendor/pdf-lib-1.17.1/pdf-lib.min.js', integrity: 'sha384-weMABwrltA6jWR8DDe9Jp5blk+tZQh7ugpCsF3JwSA53WZM9/14PjS5LAJNHNjAI' },
  // (v60) pdf.js 4.10.38, the standard (modern) build (fixes CVE-2024-4367); an ES module
  pdfjs: { global: 'pdfjsLib', src: '/vendor/pdfjs-4.10.38/pdf.min.mjs', integrity: 'sha384-z/XbAtvhBXJoK+yvYimnFuTCF6/2wTCDSIFD09/HtIfwFtvDKOMdAe5Z3wOChkmW', module: true },
  jszip: { global: 'JSZip', src: '/vendor/jszip-3.10.2/jszip.min.js', integrity: 'sha384-DdGlNq+wVXAn83gXqwyeFHB7iyXy6L0rLrNzgDmhKWPjiJLg9vj6qosYmZmkMfQ+' },
  // (v147) OCR (tool-ocr.js): tesseract.js starts its own worker from /vendor/tesseract-7.0.0/ (see OCR_PATHS there)
  tesseract: { global: 'Tesseract', src: '/vendor/tesseract-7.0.0/tesseract.min.js', integrity: 'sha384-2BQ3U3OdKOb0Uczxqr41I9UvZkzr4V9Hv8uSzMMZAlmhsFClvdZX5wi5fDCzG+tM' },
};
const pcLibLoads = {};
function pcLoadLib(key){
  const lib = PC_LAZY_LIBS[key];
  const stale = () => !!lib.build && window[lib.build] !== PC_BUILD;
  // (v96) a copy of another release that was loaded earlier (a prefetch) stays refused
  if(window[lib.global]) return stale() ? Promise.reject(Object.assign(new Error(pcT('staleRelease')), { userFacing: true })) : Promise.resolve();
  if(!pcLibLoads[key]) pcLibLoads[key] = new Promise((resolve, reject) => {
    const sc = document.createElement('script');
    if(lib.module) sc.type = 'module'; // (v60) pdf.js 4 is an ES module (it still sets window.pdfjsLib)
    sc.src = lib.src;
    if(lib.integrity) sc.integrity = lib.integrity;
    const fail = msgKey => { delete pcLibLoads[key]; sc.remove(); reject(Object.assign(new Error(pcT(msgKey || 'libLoadFailed')), { userFacing: true })); };
    sc.onload = () => {
      if(!window[lib.global]) return fail();
      if(stale()) return fail('staleRelease');
      resolve();
    };
    sc.onerror = () => fail();
    document.head.appendChild(sc);
  });
  return pcLibLoads[key];
}

/* (v56) pdf-lib + pdf.js + JSZip, loaded once for the whole page. Every
   tool awaits this before it touches them (a failure rejects with the
   translated libLoadFailed message, shown in that tool's status). pdf.js's
   worker and getDocument() defaults can only be set once pdf.js is there. */
/* (v60) pdf.js 4 needs a browser from about 2022 on (Safari/iOS 16.4,
   Chrome 98, Firefox 94). An older browser skips it: the tools that don't
   use pdf.js (merge, compress, split, rotate, ...) keep working there, and
   the three that do (PDF to Word, PowerPoint, JPG) say why they can't. The
   probe uses features of exactly that generation: RegExp look-behind
   (Safari 16.4) and structuredClone (Chrome 98, Firefox 94, Safari 15.4). */
/* Firefox 94-113 pass this probe but can't start a module worker: pdf.js then
   runs its worker code on the page itself (slower on big files, but it
   works). Those versions are from 2021-2023; Firefox ESR has module workers. */
function pcPdfJsSupported(){
  if(typeof structuredClone !== 'function') return false;
  try{ new RegExp('(?<=a)b'); return true; }catch(e){ return false; }
}
function pcCoreLibKeys(){ return PC_CORE_LIBS.filter(k => k !== 'pdfjs' || pcPdfJsSupported()); }
/* For the tools that need pdf.js: a translated "browser too old" message
   instead of a TypeError on an unsupported browser. */
function pcRequirePdfJs(){
  if(typeof pdfjsLib === 'undefined' || !pdfjsLib.getDocument) throw Object.assign(new Error(pcT('oldBrowser')), { userFacing: true });
}
const PC_CORE_LIBS = ['pdflib', 'pdfjs', 'jszip'];
let pcCoreLibsReady = null;
function pcLoadPdfLibs(){
  if(!pcCoreLibsReady){
    pcCoreLibsReady = Promise.all(pcCoreLibKeys().map(pcLoadLib)).then(() => {
      if(typeof pdfjsLib !== 'undefined') pcSetupPdfJs();
      pcShowLibBanner(false);
    }, err => {
      pcCoreLibsReady = null; // the next attempt (e.g. pressing the button) tries again
      throw err;
    });
  }
  return pcCoreLibsReady;
}
/* Early start (first file, pointer or focus on a drop zone or tab), so the
   tool rarely has to wait. A failure here shows the page banner; the tool
   itself retries and reports in its status when it is started. */
function pcPreloadPdfLibs(){ pcLoadPdfLibs().catch(() => pcShowLibBanner(true)); }
const PC_PRELOAD_TARGETS = '.dropzone, .tab, .panel .btn.full, input[type="file"]';
const PC_PRELOAD_EVENTS = ['pointerover', 'pointerdown', 'focusin', 'dragenter'];
function pcPreloadOnIntent(e){
  const wantsFiles = e.type === 'dragenter' || (e.target && e.target.closest && e.target.closest(PC_PRELOAD_TARGETS));
  if(!wantsFiles) return;
  PC_PRELOAD_EVENTS.forEach(ev => document.removeEventListener(ev, pcPreloadOnIntent, true));
  pcPreloadPdfLibs();
}
PC_PRELOAD_EVENTS.forEach(ev => document.addEventListener(ev, pcPreloadOnIntent, { capture: true, passive: true }));
/* (v56) ...and quietly once the page has finished loading and the browser
   is idle, so a tool page that has been open for a moment also works with
   the connection gone -- even without a service worker (a private window,
   the first seconds of a first visit), as the "check it yourself" pages
   promise. Only after "load", so first paint and the page's own scripts
   never wait for these 320 KB. Not with Data Saver on: then the libraries
   still come on the first file or the first pointer/focus on a tool.
   (v58) Only DOWNLOADED here, into the browser's cache (they are served
   with a one-year "immutable" cache time from /vendor/): running them costs
   about half a second of main-thread time on a phone, which made the page
   sluggish right after loading for visitors who only read it. They run on
   the first file or the first pointer/focus on a tool (pcPreloadOnIntent
   above), straight from the cache -- also with the connection gone. The
   same-origin GET requests carry no data of the visitor. */
const PC_IDLE_PRELOAD_TIMEOUT_MS = 3000; // requestIdleCallback: start by then even on a busy page
const PC_IDLE_PRELOAD_FALLBACK_MS = 1000; // browsers without requestIdleCallback (Safari)
function pcPrefetchPdfLibs(){
  // already loaded (a file or a pointer came first): nothing left to fetch
  if(pcCoreLibsReady) return;
  const urls = pcCoreLibKeys().map(k => PC_LAZY_LIBS[k].src).concat(pcPdfJsSupported() ? [PC_PDFJS_BASE + 'pdf.worker.min.mjs'] : []);
  // (v58) the conversion code too, on a page with a Word/PowerPoint tool
  // (v94) only when that tool is the one shown: every tool page carries all panels
  if(document.querySelector('#panel-word.active, #panel-ppt.active, #panel-excel.active')) urls.push(PC_LAZY_LIBS.convert.src);
  urls.forEach(url => {
    // the response body is read to the end, so the whole file lands in the cache
    fetch(url, { credentials: 'same-origin' })
      .then(r => { if(!r.ok) throw new Error('HTTP ' + r.status); return r.arrayBuffer(); })
      // Not an error for the visitor: this is only a head start. The real load
      // on first use fetches again and reports a failure in the tool's own
      // status (and the page banner), so no alert is shown for a background
      // fetch that nobody may ever need.
      .catch(() => { /* reported on first use, see above */ });
  });
}
function pcPreloadWhenIdle(){
  const conn = navigator.connection;
  // (v111) no head start on a slow connection either (only data saver before): ±2.4 MB a reader may never use
  if(conn && (conn.saveData || (conn.effectiveType && conn.effectiveType !== '4g'))) return;
  if(!document.querySelector('.dropzone')) return;
  if(window.requestIdleCallback) requestIdleCallback(pcPrefetchPdfLibs, { timeout: PC_IDLE_PRELOAD_TIMEOUT_MS });
  else setTimeout(pcPrefetchPdfLibs, PC_IDLE_PRELOAD_FALLBACK_MS);
}
if(document.readyState === 'complete') pcPreloadWhenIdle();
else window.addEventListener('load', pcPreloadWhenIdle, { once: true });

/* Warns if someone tries to close or leave the page while a file is
   still being processed — otherwise you'd lose all progress on a large
   file with no warning. */
let isProcessing = false;
/* (v55) While one tool runs, the start buttons of the others are marked
   unavailable (and their click is ignored): two tools at once shared one
   cancel flag, one "busy" flag and the page-image cache, so finishing or
   cancelling one broke the other. */
let pcLastRunTool = null; // e.g. 'compress': the tool that ran last (see pcHideStaleResult)
document.addEventListener('click', e => {
  const b = e.target.closest && e.target.closest('button.btn.full[id^="btn-"]');
  if(b && !isProcessing && !b.disabled) pcLastRunTool = b.id.slice(4);
}, true);
/* (v95) While a tool works the screen stays on (a phone that goes dark
   pauses the tab, and the job with it) and the tab title shows the
   progress: a visitor in another tab sees "(42%) …" and then "✓ Done – …". */
const PC_BASE_TITLE = document.title;
let pcWakeLock = null;
function pcKeepAwake(on){
  if(!on){
    if(pcWakeLock) pcWakeLock.release().catch(pcLogUnexpected);
    pcWakeLock = null;
    return;
  }
  if(pcWakeLock || !navigator.wakeLock || document.hidden) return;
  navigator.wakeLock.request('screen').then(lock => {
    if(isProcessing && !pcWakeLock) pcWakeLock = lock;
    else lock.release().catch(pcLogUnexpected); // the job ended while the request was pending
  }, err => {
    // refused (battery saver, policy): the job simply runs without it
    if(!err || err.name !== 'NotAllowedError') pcLogUnexpected(err);
  });
}
function pcTitleProgress(percent){
  if(isProcessing) document.title = '(' + percent + '%) ' + PC_BASE_TITLE;
}
function pcTitleOutcome(){
  const st = pcLastRunTool && document.getElementById('status-' + pcLastRunTool);
  const ok = st && st.classList.contains('done');
  const failed = st && st.classList.contains('error');
  if(!document.hidden || (!ok && !failed)){ document.title = PC_BASE_TITLE; return; }
  document.title = (ok ? '✓ ' + pcT('tabDone') : '⚠ ' + pcT('tabFailed')) + ' – ' + PC_BASE_TITLE;
}
document.addEventListener('visibilitychange', () => {
  if(document.hidden) return;
  if(isProcessing) pcKeepAwake(true); // the browser drops the lock while the tab is hidden
  else document.title = PC_BASE_TITLE;
});
function pcSetProcessing(on){
  isProcessing = on;
  if(on) pcPdfJsMissed = false; // (v157) checked by offerResults
  pcKeepAwake(on);
  if(!on) pcTitleOutcome();
  // (v62) the page previews let go of their copy of the PDF while a tool works
  if(on && window.PCThumbs) window.PCThumbs.suspend();
  document.querySelectorAll('button.btn.full[id^="btn-"]').forEach(b => {
    if(on && !b.disabled) b.setAttribute('aria-disabled', 'true');
    else b.removeAttribute('aria-disabled');
  });
}
window.addEventListener('beforeunload', e=>{
  if(isProcessing){
    e.preventDefault();
    e.returnValue = '';
  }
});

/* (v116) The panels of the other tools wait in a <template> until their tab
   is opened: a search engine then reads one tool per page instead of 22
   near-identical ones. pcOnPanel(name, init) runs a tool's setup at once
   when its panel is in the page, or when the panel is made from its
   template (pcMaterializePanel, on the tab's click). Code that prepares
   every panel (status boxes, the privacy meter, ...) also listens to the
   'pc-panel' event, which carries the new panel. */
const pcPanelInits = new Map();
function pcPanelTemplate(name){ return document.querySelector('template[data-pc-panel="' + name + '"]'); }
function pcOnPanel(name, init){
  if(document.getElementById('panel-' + name)){ init(); return; }
  if(!pcPanelTemplate(name)) return; // this page doesn't have that tool
  pcPanelInits.set(name, (pcPanelInits.get(name) || []).concat([init]));
}
function pcMaterializePanel(name){
  const tpl = pcPanelTemplate(name);
  if(!tpl) return document.getElementById('panel-' + name);
  tpl.replaceWith(document.importNode(tpl.content, true));
  const panel = document.getElementById('panel-' + name);
  const tab = document.getElementById('tab-' + name);
  if(tab) tab.setAttribute('aria-controls', 'panel-' + name); // left out while the panel did not exist
  document.dispatchEvent(new CustomEvent('pc-panel', { detail: panel }));
  const inits = pcPanelInits.get(name) || [];
  pcPanelInits.delete(name);
  // one broken tool must not stop the tab from opening, but it must say so instead of looking ready
  inits.forEach(init => { try{ init(); }catch(e){ pcLogUnexpected(e); pcPanelBroken(name); } });
  if(isProcessing){ const b = document.getElementById('btn-' + name); if(b && !b.disabled) b.setAttribute('aria-disabled', 'true'); } // as pcSetProcessing does
  return panel;
}
function pcPanelBroken(name){
  const st = document.getElementById('status-' + name), text = document.getElementById('status-' + name + '-text'), btn = document.getElementById('btn-' + name);
  if(btn) btn.disabled = true;
  if(st && text){ st.classList.add('show', 'error'); text.textContent = pcT('libLoadFailed'); }
}
/* Every panel in the page now and every one made later: fn(panel). */
function pcEachPanel(fn){
  document.querySelectorAll('.panel').forEach(fn);
  document.addEventListener('pc-panel', e => fn(e.detail));
}
document.querySelectorAll('.tab').forEach(tab=>{
  tab.addEventListener('click',()=>{
    const panel = pcMaterializePanel(tab.dataset.tab);
    document.querySelectorAll('.tab').forEach(t=>{ t.classList.remove('active'); t.setAttribute('aria-selected','false'); t.tabIndex = -1; });
    document.querySelectorAll('.panel').forEach(p=>p.classList.remove('active'));
    tab.classList.add('active');
    tab.setAttribute('aria-selected','true');
    tab.tabIndex = 0;
    if(panel) panel.classList.add('active');
  });
});
/* (v49) Keyboard pattern of ARIA tabs: only the active tab is in the Tab
   order (roving tabindex); Left/Right arrow, Home and End move to another
   tab and open it, exactly as a click does. Hidden tabs are skipped. */
const PC_TAB_KEYS = { ArrowLeft: -1, ArrowRight: 1, Home: 'first', End: 'last' };
document.querySelectorAll('[role="tablist"]').forEach(list=>{
  const tabs = [...list.querySelectorAll(':scope > [role="tab"]')];
  if(!tabs.length) return;
  const current = tabs.find(t=>t.classList.contains('active')) || tabs[0];
  tabs.forEach(t=>{ t.tabIndex = t === current ? 0 : -1; });
  list.addEventListener('keydown', e=>{
    const step = PC_TAB_KEYS[e.key];
    if(step === undefined || e.altKey || e.ctrlKey || e.metaKey) return;
    const shown = tabs.filter(t=>!t.hidden && getComputedStyle(t).display !== 'none');
    const i = shown.indexOf(document.activeElement);
    if(i < 0) return;
    e.preventDefault();
    const j = step === 'first' ? 0 : step === 'last' ? shown.length - 1 : (i + step + shown.length) % shown.length;
    shown[j].focus();
    shown[j].click();
  });
});

/* (v55) On a phone the tabs are one row that scrolls sideways (style.css):
   the active tab, and a tab reached with the arrow keys, is scrolled into
   view of that row only (scrollIntoView could also move the page). */
(function(){
  const EDGE_PX = 24;
  function pcRevealTab(tab, smooth){
    const list = tab && tab.parentElement;
    if(!list || list.scrollWidth <= list.clientWidth) return;
    const t = tab.getBoundingClientRect(), l = list.getBoundingClientRect();
    let dx = 0;
    if(t.left < l.left + EDGE_PX) dx = t.left - (l.left + EDGE_PX);
    else if(t.right > l.right - EDGE_PX) dx = t.right - (l.right - EDGE_PX);
    const calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(dx) list.scrollBy({ left: dx, behavior: smooth && !calm ? 'smooth' : 'auto' });
  }
  document.querySelectorAll('.tool-card [role="tablist"]').forEach(list => { // (v148) also inside .pc-tabrow
    pcRevealTab(list.querySelector('.tab.active'), false);
    list.addEventListener('focusin', e => { if(e.target.getAttribute('role') === 'tab') pcRevealTab(e.target, false); });
    list.addEventListener('click', e => { const t = e.target.closest('[role="tab"]'); if(t) pcRevealTab(t, true); });
  });
  const revealActive = () => {
    document.querySelectorAll('.tool-card [role="tablist"] > .tab.active').forEach(t => pcRevealTab(t, false));
  };
  window.addEventListener('resize', revealActive);
  // (v67) the web fonts are wider than the fallback font, so the row is
  // measured again once they have loaded (the active tab could end up
  // a few pixels outside the row)
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(revealActive);
})();
/* v39: tabs-raster. Meet het langste label (vet, want de actieve tab is
   vet) en kies zoveel kolommen als er passen zonder dat woorden overlappen
   of midden in een woord afbreken. Nooit één eenzame tab op de laatste rij
   (4 tabs = 4 of 2 per rij). Herberekend bij draaien/resize en zodra de
   webfont geladen is. */
(function(){
  function measure(el,tabs){
    const probe=document.createElement('span');
    probe.style.cssText='position:absolute;visibility:hidden;white-space:nowrap;font-weight:600;left:-9999px;top:0';
    tabs[0].appendChild(probe);
    let widest=0;
    tabs.forEach(t=>{ const s=t.querySelector(':scope > span'); if(!s) return; probe.textContent=s.textContent.replace(/­/g,''); widest=Math.max(widest,probe.getBoundingClientRect().width); });
    probe.remove();
    const tcs=getComputedStyle(tabs[0]);
    return Math.ceil(widest)+parseFloat(tcs.paddingLeft)+parseFloat(tcs.paddingRight)+2;
  }
  function layout(el){
    const tabs=[...el.querySelectorAll(':scope > .tab')].filter(t=>getComputedStyle(t).display!=='none'); const n=tabs.length; if(!n) return;
    delete el.dataset.small; delete el.dataset.tight;
    const cs=getComputedStyle(el);
    /* (v140) the exact (fractional) width, like the CSS first guess (TABNEED); clientWidth is rounded */
    const box=parseFloat(cs.width); if(!(box>0)) return;
    const avail=box-parseFloat(cs.paddingLeft)-parseFloat(cs.paddingRight)-parseFloat(cs.borderLeftWidth)-parseFloat(cs.borderRightWidth);
    const gap=parseFloat(cs.columnGap)||0;
    const fit=need=>Math.max(1,Math.min(n,Math.floor((avail+gap)/(need+gap))));
    /* (v140) data-need = widest label in Plex 600, measured beforehand (src/tabneed.mjs). Before
       Plex 600 is there that value is used as is: measured with a fallback font (Android has no
       Arial) the count changed when Plex arrived and the grid jumped. Once Plex is there, a label
       wider than data-need (stale value) still wins, so no label ever overflows. */
    const pre=Number(el.dataset.need)||0;
    let need=pre && !plexReady() ? pre : Math.max(pre, measure(el,tabs)), c=fit(need);
    /* Past zelfs 2 per rij niet (smal scherm, breed lettertype)? Dan eerst
       kleiner lettertype; lukt het dan nog niet, dan mag een label op twee
       regels. Nooit 1 tab per rij. */
    if(c<2 && n>1){ el.dataset.small=''; need=measure(el,tabs); c=Math.max(2,fit(need)); }
    if(c>2 && n%c===1 && n%(c-1)!==1) c--;
    /* (v88) 13 tabs: in 2, 3 or 4 columns one tab is always left over. That
       last tab then takes the whole row, so it doesn't look forgotten. */
    tabs.forEach(t=>{ t.style.gridColumn=''; });
    if(c>1 && n%c===1) tabs[n-1].style.gridColumn='1 / -1';
    el.style.setProperty('--tab-cols',c);
    el.dataset.cols=c;
    if(need*c+gap*(c-1)>avail+1) el.dataset.tight='';
  }
  function all(){ document.querySelectorAll('.tabs').forEach(layout); }
  // (v65) Measured with the page's own font only: measured with the fallback
  // font (wider), the grid got fewer columns and jumped back once the font
  // arrived. Until then the CSS default grid (auto-fit) stands (v140: a tab row with data-need is laid out
  // at once, see layout). A font that
  // fails to load still gets the grid measured (with the fallback font).
  const TAB_FACE = "600 16px 'IBM Plex Sans'";
  function plexReady(){ return !document.fonts || !document.fonts.check || document.fonts.check(TAB_FACE); }
  document.querySelectorAll('.tabs[data-need]').forEach(layout);
  if(plexReady()) all();
  else document.fonts.load(TAB_FACE).then(all, all);
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(all);
  if(document.fonts&&document.fonts.addEventListener) document.fonts.addEventListener('loadingdone',all);
  let raf=0; window.addEventListener('resize',()=>{ cancelAnimationFrame(raf); raf=requestAnimationFrame(all); });
  document.addEventListener('pc-tabs-changed',all); // (v148) pc-picker.js showed another tab
})();

/* Elke download-link krijgt een blob-URL die de browser in het geheugen
   houdt tot die expliciet vrijgegeven wordt. Zonder dat op te ruimen blijft
   elk eerder resultaat in dezelfde sessie hangen, ook nadat je iets nieuws
   hebt omgezet. Deze helper geeft de vorige URL netjes vrij voor er een
   nieuwe wordt aangemaakt. */
function setDownloadHref(anchorEl, blob){
  if(anchorEl.href && anchorEl.href.startsWith('blob:')){
    URL.revokeObjectURL(anchorEl.href);
  }
  anchorEl.href = URL.createObjectURL(blob);
}

/* Bestandsnamen komen rechtstreeks van de gebruiker (je kan een bestand om het
   even hoe noemen) en worden op verschillende plekken in de pagina getoond.
   Zonder dit zou een bestand met een naam als "<img onerror=...>.pdf" die
   code gewoon laten uitvoeren zodra het bestand in de lijst verschijnt. Elke
   tekst die van de gebruiker komt en in innerHTML terechtkomt, moet hier
   eerst doorheen. */
function escapeHtml(str){
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

// (v57) French writes file sizes in octets (Ko, Mo, Go), every other
// language on the site uses B, KB, MB, GB
const PC_SIZE_UNITS_FR = ['o', 'Ko', 'Mo', 'Go'];
const PC_SIZE_UNITS = ['B', 'KB', 'MB', 'GB'];
function fmtSize(bytes){
  // (v52) "1,1 MB" on the non-English pages, as the rest of their text
  const lang = (document.documentElement.lang || 'en').slice(0, 2);
  const dec = t => lang === 'en' ? t : t.replace('.', ',');
  const u = lang === 'fr' ? PC_SIZE_UNITS_FR : PC_SIZE_UNITS;
  if(bytes < 1024) return bytes + ' ' + u[0];
  if(bytes < 1024*1024) return (bytes/1024).toFixed(0) + ' ' + u[1];
  if(bytes < 1024*1024*1024) return dec((bytes/(1024*1024)).toFixed(1)) + ' ' + u[2];
  return dec((bytes/(1024*1024*1024)).toFixed(2)) + ' ' + u[3];
}

/* Warns (non-blocking) when the chosen files together are quite large.
   Processing happens entirely in the browser's own memory, so on a
   weaker device (especially mobile) this can become slow or unresponsive
   — better to mention that upfront than let the user guess why it's
   taking a while. */
const LARGE_FILES_THRESHOLD = 50 * 1024 * 1024; // 50 MB
// (v94) here, before updateLargeFileWarning runs while app.js is still loading
const PC_MB = 1024 * 1024;
const PC_MEM_FACTOR = { word: 8, ppt: 8, excel: 8, compress: 4, merge: 3, split: 3, delete: 3, extract: 3, nup: 3, sign: 3, watermark: 3, crop: 3, imgs: 4, meta: 3, org: 3, fill: 3, flatten: 3, redact: 4, compare: 3, ocr: 4 };
const PC_MEM_FACTOR_DEFAULT = 2; // rotate, page numbers, protect, unlock, JPG
const PC_PHONE_MEM_WARN = 300 * PC_MB;
const PC_PHONE_MEM_STOP = 1024 * PC_MB;
/* (v67) Also called while app.js is still loading (fileHub.register, with no
   files yet): pcT/PC_MSG are only reached when there is something to warn
   about, so keep the size check before any message. */
function updateLargeFileWarning(warningEl, files){
  if(!warningEl) return;
  const total = files.reduce((s,f)=>s+f.size, 0);
  if(total > LARGE_FILES_THRESHOLD){
    const text = pcT('largeFiles', fmtSize(total));
    if(warningEl.textContent !== text || warningEl.style.display !== 'block') pcAnnounce(text); // (v111) read out, not only shown
    warningEl.textContent = text;
    warningEl.style.display = 'block';
  }else{
    warningEl.style.display = 'none';
  }
  pcMobileMemoryWarning(warningEl, files);
}

/* (v95) A merge is named after its first file ("report-merged.pdf"), not
   "merged.pdf", which piled up as "merged (3).pdf" in the downloads folder. */
function pcMergedName(firstName, ext){
  return firstName.replace(/\.(pdf|docx|pptx)$/i, '') + '-merged.' + ext;
}
/* (v95) A zip of several results from ONE file is named after that file. */
function pcZipName(sourceFiles, fallback){
  return sourceFiles && sourceFiles.length === 1 ? baseFileName(sourceFiles[0].name) + '-' + fallback : fallback;
}

/* (v55) An input the user must correct (a page list): marked invalid and
   linked to the message that says why, until it is edited again. */
function pcMarkField(input, messageEl, invalid){
  if(!input) return;
  const ids = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter(x => x && x !== (messageEl && messageEl.id));
  if(invalid && messageEl && messageEl.id) ids.push(messageEl.id);
  if(ids.length) input.setAttribute('aria-describedby', ids.join(' ')); else input.removeAttribute('aria-describedby');
  if(invalid){
    input.setAttribute('aria-invalid', 'true');
    input.addEventListener('input', () => pcMarkField(input, messageEl, false), { once: true });
  }else input.removeAttribute('aria-invalid');
}
/* (v55) An error whose message is written for the user (shown as it is). */
function pcUserError(msg){ return Object.assign(new Error(msg), { userFacing: true }); }
/* Translates technical errors into an understandable message. */
const PC_INVALID_KEY = { 'PDF': 'errInvalidPdf', 'Word document': 'errInvalidWord', 'PowerPoint file': 'errInvalidPpt' };
function friendlyPdfError(err, fileTypeLabel){
  const label = fileTypeLabel || 'PDF';
  pcNotePassword(err); // (v119) the status box then asks for the password
  if(err && err.name === 'PcCancelled') return err.message;
  if(err && err.userFacing && err.message) return err.message;
  if(err && err.name === 'PasswordException'){
    return pcT('errPwUse');
  }
  const readFail = pcReadFailureMessage(err); // (v73, v89) a full memory or a file that is gone is not a broken file
  if(readFail) return readFail;
  return pcT(PC_INVALID_KEY[label] || 'errInvalidPdf');
}
// (v113) pcIsFileGone, pcReadFailureMessage, pcThrowIfOutOfMemory, baseFileName, pcFieldError,
// pcNormDashes and pcCheckPageExists live in pc-pdfcore.js (the worker uses them too)
const PC_PHASE_FINISHING = 'finishing';
const PC_PHASE_ANALYZING = 'analyzing'; // (v57) Word's look at every page before converting
const PC_ANALYZE_SHARE = 0.05;          // ...shown as the first 5% of the progress bar
const PC_PHASE_SCANNING = 'scanning';   // (v57) ...its first part: running headers and page numbers, on sample pages
const PC_SCAN_SHARE = 0.4;              // ...that part's share of the analysis on the bar
/* Only real faults go to the console: a cancel, a password or a message the
   user already sees is expected, not a bug. */
function pcLogUnexpected(err){
  // (v141) a preview render stopped because a newer one started (RenderingCancelledException) is no fault
  // (v111) "not a readable PDF" because our own code failed on it: its cause still reaches the console
  if(err && err.name === 'InvalidPDFException' && err.cause instanceof Error && /^(TypeError|ReferenceError)$/.test(err.cause.name)){ console.error(err.cause); return; }
  if(err && (err.userFacing || /^(PcCancelled|PasswordException|InvalidPDFException|MissingPDFException|UnexpectedResponseException|NotFoundError|InvalidOfficeFile|RenderingCancelledException)$/.test(err.name || ''))) return;
  console.error(err);
}
/* (v52) One file of a batch that can't be processed is skipped and named,
   like the other tools do, instead of throwing the good files away. A lone
   file, or a cancel, still stops with its own message. Returns the reason
   to list, or rethrows. */
function pcSkipOrThrow(err, file, batchSize, fileTypeLabel){
  if(err && err.name === 'PcCancelled') throw err;
  if(batchSize <= 1) throw err;
  pcLogUnexpected(err); // (v90) a skipped file's real fault still reaches the console
  return file.name + ' (' + friendlyPdfError(err, fileTypeLabel) + ')';
}
function pcAllSkipped(key, skipped){
  return Object.assign(new Error(pcT(key, skipped.join(', '))), { userFacing: true });
}

/* ---------- SHARED FILE LIST (v36) ----------
   One ordered list of chosen files for the whole page. Every tool sees
   the files that fit it: a PDF dropped into Merge also shows up in
   Compress, Split, PDF to JPG, ...; an image only in JPG to PDF. Removing
   or reordering a file anywhere changes it everywhere. Files stay in this
   browser tab's memory only - nothing is uploaded. When the visitor clicks
   a link to another page of this site, the list is handed over through the
   browser's own local storage (IndexedDB) and deleted again as soon as the
   next page has picked it up. */
const PDFC_LANG = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2);
const FILELIST_LABELS = {
  en: { remove: 'Remove', up: 'Move up', down: 'Move down', drag: 'Drag to change the order',
        added1: '1 file added', addedN: '{0} files added', removed: '{0} removed', moved: '{0} moved to position {1} of {2}' },
  nl: { remove: 'Verwijder', up: 'Naar boven', down: 'Naar beneden', drag: 'Sleep om de volgorde te wijzigen',
        added1: '1 bestand toegevoegd', addedN: '{0} bestanden toegevoegd', removed: '{0} verwijderd', moved: '{0} verplaatst naar positie {1} van {2}' },
  fr: { remove: 'Retirer', up: 'Monter', down: 'Descendre', drag: "Faites glisser pour changer l'ordre",
        added1: '1 fichier ajouté', addedN: '{0} fichiers ajoutés', removed: '{0} retiré', moved: '{0} déplacé en position {1} sur {2}' },
  de: { remove: 'Entfernen', up: 'Nach oben', down: 'Nach unten', drag: 'Ziehen, um die Reihenfolge zu ändern',
        added1: '1 Datei hinzugefügt', addedN: '{0} Dateien hinzugefügt', removed: '{0} entfernt', moved: '{0} an Position {1} von {2} verschoben' },
  es: { remove: 'Quitar', up: 'Subir', down: 'Bajar', drag: 'Arrastra para cambiar el orden',
        added1: '1 archivo añadido', addedN: '{0} archivos añadidos', removed: '{0} quitado', moved: '{0} movido a la posición {1} de {2}' },
  pt: { remove: 'Remover', up: 'Mover para cima', down: 'Mover para baixo', drag: 'Arraste para mudar a ordem',
        added1: '1 arquivo adicionado', addedN: '{0} arquivos adicionados', removed: '{0} removido', moved: '{0} movido para a posição {1} de {2}' }, it: { remove: "Rimuovi", up: "Sposta su", down: "Sposta giù", drag: "Trascina per cambiare l'ordine",
        added1: "1 file aggiunto", addedN: "{0} file aggiunti", removed: "{0} rimosso", moved: "{0} spostato in posizione {1} di {2}" }, pl: { remove: "Usuń", up: "Przesuń w górę", down: "Przesuń w dół", drag: "Przeciągnij, aby zmienić kolejność",
        added1: "Dodano 1 plik", addedN: "Dodano {0} {0#plik|pliki|plików}", removed: "Usunięto: {0}", moved: "Przeniesiono {0} na pozycję {1} z {2}" },
}[PDFC_LANG] || { remove: 'Remove', up: 'Move up', down: 'Move down', drag: 'Drag to change the order',
        added1: '1 file added', addedN: '{0} files added', removed: '{0} removed', moved: '{0} moved to position {1} of {2}' };
/* (v49) fills {0}, {1}, ... in a FILELIST_LABELS text */
/* (v98) one pass: a value that itself contains "{1}" (a file name) is not filled in again */
function pcFill(tpl){
  const args = arguments;
  return pcPluralForms(String(tpl), Array.prototype.slice.call(args, 1)).replace(/\{(\d+)\}/g, (m, i) => (+i + 1 < args.length ? String(args[+i + 1]) : m));
}
/* (v49) One persistent, visually hidden live region per politeness level,
   created as soon as this script runs (a region created together with its
   first message is often not read). The text is set a moment later, after
   clearing, so the same message twice in a row is read again. */
function pcLiveRegion(assertive){
  const id = assertive ? 'pc-live-alert' : 'pc-live';
  let el = document.getElementById(id);
  if(!el){
    el = document.createElement('div');
    el.id = id;
    el.className = 'pc-sr-only';
    el.setAttribute('role', assertive ? 'alert' : 'status');
    el.setAttribute('aria-live', assertive ? 'assertive' : 'polite');
    el.setAttribute('aria-atomic', 'true');
    document.body.appendChild(el);
  }
  return el;
}
const PC_ANNOUNCE_DELAY_MS = 60;
function pcAnnounce(text, assertive){
  const el = pcLiveRegion(!!assertive);
  el.textContent = '';
  clearTimeout(el._pcTimer);
  if(!text) return;
  el._pcTimer = setTimeout(() => { el.textContent = text; }, PC_ANNOUNCE_DELAY_MS);
}
pcLiveRegion(false);
pcLiveRegion(true);
/* (v49) A tool's status box is a polite live region, but not while the tool
   is working (every "page 3 of 50" update would be queued for reading) and
   not in its error state (the error is already read out, assertively, by
   the alert region): only the start, the end result and cancellations
   reach the screen reader from here. */
function pcSyncStatusLive(el){
  // (v55) "done" too: the finished message is read once, together with the
  // result (see the result watcher), instead of "Done!" and then again
  // "Done - 1 file created" from a second region
  const quiet = el.classList.contains('working') || el.classList.contains('error') || el.classList.contains('done');
  const want = quiet ? 'off' : 'polite';
  if(el.getAttribute('aria-live') !== want) el.setAttribute('aria-live', want);
}
(function watchStatusBoxes(){
  if(typeof MutationObserver === 'undefined') return;
  const mo = new MutationObserver(list => list.forEach(m => pcSyncStatusLive(m.target)));
  pcEachPanel(panel => panel.querySelectorAll('.status').forEach(el => { pcSyncStatusLive(el); mo.observe(el, { attributes: true, attributeFilter: ['class'] }); })); // (v116) also panels made later
})();

const isPdfFile = f => f.type === 'application/pdf' || /\.pdf$/i.test(f.name);
/* (v55) see fileHub.notify: true while lists are redrawn right after a run */
let pcKeepShownResults = false;
function pcKeepsResult(el){ return pcKeepShownResults && !!el && el.id === 'result-' + pcLastRunTool; }
function pcHideStaleResult(el){ if(el && !pcKeepsResult(el)) el.classList.remove('show'); }
const isOfficeOrPdfFile = f => isPdfFile(f) || /\.(docx|pptx)$/i.test(f.name);

const fileHub = (function(){
  let files = [];
  const tools = [];
  let pending = null;
  const same = (a, b) => a === b || (a.name === b.name && a.size === b.size && a.lastModified === b.lastModified);
  /* v47: choosing the same file again adds it again (merging A + A, e.g. a
     repeated cover page, used to be impossible). Only the very same File
     object is ignored, which is what a double event or a page hand-over
     produces. Tools that treat files one by one skip the repeats. */
  const identical = (a, b) => a === b;
  const sameList = (a, b) => a && a.length === b.length && a.every((f, i) => f === b[i]);
  function notify(afterRun){
    // While a tool is working, its list must not change under it: apply
    // the new list as soon as processing has finished.
    if(typeof isProcessing !== 'undefined' && isProcessing){
      clearTimeout(pending);
      pending = setTimeout(() => notify(true), 250);
      return;
    }
    // (v55) only tools whose own list changed are redrawn (adding a picture
    // used to hide the result of the PDF tool next to it), and the result
    // of the tool that just ran stays when files were added while it was
    // made (any other tool's older result is hidden as before)
    pcKeepShownResults = !!afterRun;
    try{
      tools.forEach(t => {
        const list = files.filter(t.accept);
        if(sameList(t.last, list)) return;
        t.last = list;
        try{ t.onChange(list); }catch(e){ pcLogUnexpected(e); }
      });
    }finally{ pcKeepShownResults = false; }
  }
  return {
    /* returns a function that removes this listener again (v62) */
    register(accept, onChange){
      const t = { accept, onChange, last: files.filter(accept) };
      tools.push(t);
      onChange(t.last);
      return () => { const i = tools.indexOf(t); if(i >= 0) tools.splice(i, 1); };
    },
    add(newFiles, accept){
      let added = 0;
      Array.from(newFiles || []).forEach(f => {
        if(accept && !accept(f)) return;
        if(!files.some(x => identical(x, f))){ files.push(f); added++; }
      });
      notify();
      if(added) pcPreloadPdfLibs(); // (v56) the tools need them now (pasted, handed over or chosen files)
      if(added) pcAnnounce(added === 1 ? FILELIST_LABELS.added1 : pcFill(FILELIST_LABELS.addedN, added));
      return added;
    },
    remove(f){ files = files.filter(x => x !== f); notify(); pcAnnounce(pcFill(FILELIST_LABELS.removed, f.name)); },
    /* Moves `f` one place up (-1) or down (+1) among the files that fit the
       calling tool, so files of other types in between don't count. */
    move(f, dir, accept){
      const visible = files.filter(accept);
      const i = visible.indexOf(f), j = i + dir;
      if(i < 0 || j < 0 || j >= visible.length) return;
      const a = files.indexOf(f), b = files.indexOf(visible[j]);
      files[a] = visible[j]; files[b] = f;
      notify();
      pcAnnounce(pcFill(FILELIST_LABELS.moved, f.name, j + 1, visible.length));
    },
    /* Drag and drop: puts `f` at the position of `target`. */
    moveTo(f, target, accept){
      if(f === target) return;
      const visible = files.filter(accept);
      const from = visible.indexOf(f), to = visible.indexOf(target);
      if(from < 0 || to < 0) return;
      visible.splice(from, 1);
      visible.splice(to, 0, f);
      let k = 0;
      files = files.map(x => accept(x) ? visible[k++] : x);
      notify();
      pcAnnounce(pcFill(FILELIST_LABELS.moved, f.name, to + 1, visible.length));
    },
    all(){ return files.slice(); },
    /* (v62) "What next?" on this page: the result of the last step becomes
       the only chosen file (see pcContinueHere) */
    replace(newFiles){
      files = Array.from(newFiles || []);
      notify();
      if(files.length) pcPreloadPdfLibs();
    },
    /* one entry per distinct file (same name, size and date), for tools
       that make one result per file */
    unique(list){ const out = []; (list || files).forEach(f => { if(!out.some(x => same(x, f))) out.push(f); }); return out; },
  };
})();
window.PDFC_FILES = fileHub;

/* (v62) Page previews (pc-thumbs.js) on the tools that ask for page
   numbers, loaded with the first PDF. Only an extra next to the text field:
   if they can't be loaded, the field still works, and the tool itself
   reports a missing library when it is started. */
const PC_THUMB_FIELDS = '#split-points, #delete-pages, #extract-pages, #rotate-options, #pdfjpg-pages';
let pcThumbsStarted = false;
function pcStartThumbs(list){
  if(pcThumbsStarted || !list.length || !pcPdfJsSupported() || !document.querySelector(PC_THUMB_FIELDS)) return;
  pcThumbsStarted = true;
  pcLoadPdfLibs().then(() => pcLoadLib('thumbs')).then(() => { pcThumbsNote(false); window.PCThumbs.start(); }, err => {
    pcThumbsStarted = false; // the next file tries again
    pcLogUnexpected(err);
    pcThumbsNote(true); // only the previews are missing: said at the fields, not in the page banner
  });
}
/* "Page previews can't be shown" under each field that would have them. */
function pcThumbsNote(show){
  pcThumbsFailed = show;
  document.querySelectorAll('.pc-thumbs-failed').forEach(n => n.remove());
  if(!show) return;
  document.querySelectorAll(PC_THUMB_FIELDS).forEach(field => {
    const n = document.createElement('p');
    n.className = 'field-hint pc-thumbs-failed';
    n.textContent = pcT('thumbsFailed');
    (document.getElementById(field.id + '-hint') || field).insertAdjacentElement('afterend', n);
  });
}
fileHub.register(isPdfFile, pcStartThumbs);
let pcThumbsFailed = false;
// (v116) an Extract panel opened after the failure; (v140) or the first panel with a page field (Split, Delete, Rotate
// and Extract can all wait in a <template>), opened with files already chosen
document.addEventListener('pc-panel', () => { if(pcThumbsFailed) pcThumbsNote(true); else pcStartThumbs(fileHub.all().filter(isPdfFile)); });

/* Draws one tool's file list: name, size, optional up/down buttons and
   drag handle (for tools where the order matters), and a remove button. */
function renderFileList(ul, list, accept, reorder, thumbs){
  if(!ul) return;
  ul.innerHTML = '';
  ul.classList.toggle('reorderable', !!reorder && list.length > 1);
  list.forEach((f, i) => {
    const li = document.createElement('li');
    if(reorder && list.length > 1){
      li.draggable = true;
      li.title = FILELIST_LABELS.drag;
      li.innerHTML = '<span class="fgrip" aria-hidden="true">⋮⋮</span>';
    }
    if(thumbs) li.appendChild(pcFileThumb(f)); // (v123)
    li.insertAdjacentHTML('beforeend', `<span class="fname">${escapeHtml(f.name)}</span><span class="fsize">${fmtSize(f.size)}</span>`);
    if(reorder && list.length > 1){
      [['up', '↑', -1], ['down', '↓', 1]].forEach(([k, sym, dir]) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fmove';
        b.textContent = sym;
        b.setAttribute('aria-label', FILELIST_LABELS[k] + ': ' + f.name);
        b.disabled = (dir < 0 && i === 0) || (dir > 0 && i === list.length - 1);
        b.addEventListener('click', () => {
          fileHub.move(f, dir, accept);
          // keep keyboard focus on the same file's button after the redraw
          setTimeout(() => {
            const again = ul.querySelectorAll('li')[i + dir];
            if(!again) return;
            // (v52) at the top/bottom that button is disabled: the other
            // one, else the remove button (focus used to drop to <body>)
            const moves = [...again.querySelectorAll('.fmove')];
            const same = moves[dir < 0 ? 0 : 1];
            const target = (same && !same.disabled) ? same : (moves.find(m => !m.disabled) || again.querySelector('.fremove'));
            if(target) target.focus();
          }, 0);
        });
        li.appendChild(b);
      });
      li.addEventListener('dragstart', e => {
        ul._dragFile = f;
        li.classList.add('dragging');
        try{ e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', f.name); }catch(err){ /* some browsers refuse setData here; dragging still works */ }
      });
      li.addEventListener('dragend', () => {
        ul._dragFile = null;
        li.classList.remove('dragging');
        ul.querySelectorAll('.drag-over').forEach(x => x.classList.remove('drag-over'));
      });
      li.addEventListener('dragover', e => {
        if(!ul._dragFile) return;
        e.preventDefault();
        e.stopPropagation();
        ul.querySelectorAll('.drag-over').forEach(x => { if(x !== li) x.classList.remove('drag-over'); });
        li.classList.add('drag-over');
      });
      li.addEventListener('dragleave', () => li.classList.remove('drag-over'));
      li.addEventListener('drop', e => {
        if(!ul._dragFile) return;
        e.preventDefault();
        e.stopPropagation();
        const moving = ul._dragFile;
        ul._dragFile = null;
        fileHub.moveTo(moving, f, accept);
      });
    }
    const rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'fremove';
    rm.textContent = '×';
    rm.setAttribute('aria-label', FILELIST_LABELS.remove + ' ' + f.name);
    rm.addEventListener('click', () => {
      fileHub.remove(f);
      // (v49) the list is drawn again: keep keyboard focus in it (the next
      // file's remove button, else the previous one, else the drop zone)
      setTimeout(() => pcFocusAfterRemove(ul, i), 0);
    });
    li.appendChild(rm);
    ul.appendChild(li);
  });
}

/* (v123) Merge list: a small picture of each PDF's first page, so the order
   can be checked at a glance. Word/PowerPoint files and files without a
   preview (too big for this device, a password, unreadable) get a plain
   sheet with their type; the file itself is never changed by this. */
function pcFileThumb(f){
  const box = document.createElement('span');
  box.className = 'fthumb';
  box.setAttribute('aria-hidden', 'true'); // the name next to it says which file it is
  const kind = pcFileKind(f);
  if(kind !== 'pdf'){ box.classList.add('fthumb--doc'); box.textContent = (kind || '').toUpperCase(); return box; }
  const ready = window.PCThumbs && window.PCThumbs.firstPageReady(f);
  if(ready){ pcThumbImg(box, ready); return box; }
  pcThumbWhenSeen(box, () => pcLoadPdfLibs().then(() => pcLoadLib('thumbs')).then(() => window.PCThumbs.firstPage(f)).then(
    url => { if(box.isConnected) pcThumbImg(box, url); }, // a redrawn list gets the same (cached) preview in its new row
    err => {
      box.classList.add('fthumb--doc'); box.textContent = 'PDF'; // no preview for this file: a plain sheet with its type
      if(!(window.PCThumbs && window.PCThumbs.isCancelled(err))) pcLogUnexpected(err); // removed, or too big here: expected
    }));
  return box;
}
/* Only a row that is on screen opens its file: not in a hidden panel (the
   Merge list is also kept on the other tool pages), not far down a long list. */
const PC_THUMB_MARGIN = '200px';
let pcThumbObserver = null;
function pcThumbWhenSeen(box, start){
  if(!('IntersectionObserver' in window)){ start(); return; }
  if(!pcThumbObserver) pcThumbObserver = new IntersectionObserver(entries => entries.forEach(e => {
    if(!e.isIntersecting) return;
    pcThumbObserver.unobserve(e.target);
    const go = e.target.__pcStart; e.target.__pcStart = null;
    if(go) go();
  }), { rootMargin: PC_THUMB_MARGIN });
  box.__pcStart = start;
  pcThumbObserver.observe(box);
}
function pcThumbImg(box, url){
  const img = document.createElement('img');
  img.src = url; img.alt = ''; img.decoding = 'async';
  box.replaceChildren(img);
}

function pcFocusAfterRemove(ul, index){
  const a = document.activeElement;
  if(a && a !== document.body && a.isConnected) return; // focus is still somewhere sensible
  const buttons = ul.querySelectorAll('.fremove');
  const next = buttons[index] || buttons[index - 1];
  if(next){ next.focus(); return; }
  const dz = document.getElementById(ul.id.replace(/^filelist-/, 'dropzone-'));
  if(dz) dz.focus();
}

/* Hand-over of the chosen files to the next page of this site.
   (v62) Also carries the result of a "What next?" step (pcOfferNextSteps):
   that record has step: true, holds only the result, and the next page
   says so above its file list. */
/* (v90) What a browser that won't keep data for this site throws (private
   mode, blocked or full storage, no IndexedDB): expected, not a bug. */
const PC_STORAGE_ERRORS = /^(InvalidStateError|UnknownError|SecurityError|QuotaExceededError|AbortError|NotFoundError|VersionError)$/;
function pcIsStorageRefusal(err){ return !err || PC_STORAGE_ERRORS.test(err.name || '') || err.message === 'no indexedDB'; }
const pcHandoff = (function fileHandoff(){
  const DB = 'pdfcommunity', STORE = 'handoff', MAX_AGE = 2 * 60 * 1000;
  // (v137) one key per copy (record: ts, from, to, files, step). A new tab
  // that has not opened its copy after NEWTAB_GRACE_MS is taken to have failed.
  const NEWTAB_GRACE_MS = 15 * 1000;
  const pagePath = u => new URL(u, location.href).pathname.replace(/index\.html$/, '');
  // (v117) existing: only open a database that is already there. Arriving on a page
  // used to create an empty one on every visit (no data in it, but a trace all the same).
  function openDb(existing){
    return new Promise((resolve, reject) => {
      if(!window.indexedDB) return reject(new Error('no indexedDB'));
      const req = indexedDB.open(DB, 1);
      req.onupgradeneeded = () => { if(existing) req.transaction.abort(); else req.result.createObjectStore(STORE); }; // the abort rejects with AbortError: "nothing handed over"
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
  }
  function tx(db, mode, fn){
    return new Promise((resolve, reject) => {
      const t = db.transaction(STORE, mode);
      const r = fn(t.objectStore(STORE));
      t.oncomplete = () => resolve(r && r.result);
      t.onerror = () => reject(t.error);
      t.onabort = () => reject(t.error);
    });
  }
  // (v98) A copy no page took (a new tab that failed to load, a navigation
  // broken off and come back to with Back) is removed by the page that
  // stored it once the hand-over window is over, instead of waiting for the
  // next visit. (v137) Each copy has its own key, so only that copy goes.
  function dropKeys(keys){
    return openDb(true).then(db => tx(db, 'readwrite', s => { keys.forEach(k => s.delete(k)); }).finally(() => db.close()));
  }
  function logStorageError(err){ if(!pcIsStorageRefusal(err)) pcLogUnexpected(err); }
  const newTabCopies = new Map(); // key -> ts of the copies this page stored for a new tab
  // (v137) The connection used for a new-tab copy stays open, so 'pagehide'
  // can start its delete at once: a tab being closed gets no time for an open().
  let held = null;
  function hold(db){
    if(held && held !== db) held.close();
    held = db;
    db.onversionchange = () => { db.close(); if(held === db) held = null; };
  }
  function saveHandoff(files, step, to, newTab){
    const ts = Date.now(), key = 'c' + ts + '-' + Math.random().toString(36).slice(2, 8);
    const rec = { ts, from: location.href, to: pagePath(to), files, step: !!step };
    return openDb().then(db => tx(db, 'readwrite', s => s.put(rec, key))
      .then(() => { if(newTab) hold(db); else db.close(); }, err => { db.close(); throw err; }))
      .then(() => {
        if(newTab) newTabCopies.set(key, ts);
        setTimeout(() => { newTabCopies.delete(key); dropKeys([key]).catch(logStorageError); }, MAX_AGE);
        return ts;
      });
  }
  // (v137) Closing or leaving this page: its new-tab copies that no tab took
  // within NEWTAB_GRACE_MS are deleted now. The copy for the page being
  // opened in this tab is never touched here (it is about to be taken; the
  // v98 race). ponytail: a new-tab copy younger than the grace period at that
  // moment stays until the next visit's sweep, as the privacy policy says.
  addEventListener('pagehide', () => {
    const now = Date.now(), stale = [...newTabCopies].filter(([, ts]) => now - ts > NEWTAB_GRACE_MS).map(([k]) => k);
    if(!stale.length || !held) return;
    stale.forEach(k => newTabCopies.delete(k));
    try{
      const store = held.transaction(STORE, 'readwrite').objectStore(STORE);
      stale.forEach(k => store.delete(k));
    }catch(err){ logStorageError(err); } // connection already closed: the sweep removes them
  });
  // Arriving: take over the files from the previous page, then delete the
  // stored copy straight away (also when it is too old to use). Every page
  // that runs the tools does this on load, so a stored copy never outlives
  // the next visit to one of them.
  // (v137) The page takes the newest fresh copy meant for it (copies from
  // v136 and older have no 'to': taken as before). It deletes that copy,
  // older copies meant for it (they would come back on a reload), expired
  // copies and copies for another page that no tab took within
  // NEWTAB_GRACE_MS (the rule pages without the tools already use).
  function takeMine(s, done){
    const now = Date.now(), here = pagePath(location.href);
    let best = null, bestKey;
    const c = s.openCursor();
    c.onsuccess = () => {
      const cur = c.result;
      if(!cur){ if(best) s.delete(bestKey); done(best); return; }
      const v = cur.value, age = v ? now - v.ts : NaN; // a negative age (clock set back) counts as expired
      const mine = v && v.from !== location.href && (!v.to || v.to === here);
      if(!(age >= 0 && age < MAX_AGE) || (!mine && age > NEWTAB_GRACE_MS)) cur.delete();
      else if(mine){
        if(best && v.ts > best.ts){ s.delete(bestKey); best = v; bestKey = cur.primaryKey; }
        else if(best) cur.delete();
        else { best = v; bestKey = cur.primaryKey; }
      }
      cur.continue();
    };
  }
  openDb(true).then(db => {
    let got = null;
    return tx(db, 'readwrite', s => takeMine(s, v => { got = v; }))
      .finally(() => db.close())
      .then(() => {
        const rec = got;
        if(rec && Array.isArray(rec.files)){
          fileHub.add(rec.files);
          if(rec.step && rec.files.length){ pcStepArrived = true; pcShowStepNote(pcT('nextFromStep', rec.files[0].name), rec.files[0]); }
        }
      });
  }).catch(err => {
    // storage unavailable (private mode) or nothing handed over: the page
    // simply starts empty; (v90) anything else is a fault of ours and logged
    if(!pcIsStorageRefusal(err)) pcLogUnexpected(err);
  });

  // Leaving via a link to another page of this site: store the list first.
  // (v48) Ctrl/Cmd-click, Shift-click or a middle click opens the link in a
  // new tab or window: this page stays as it is, and the new page picks the
  // list up the same way (it deletes the stored copy on arrival).
  // (v55) Only a page that runs the tools gets the list: an allow-list of
  // those pages (the pages that load app.js). The deny-list it replaces
  // missed the six "verify it yourself" pages, so a click there left the
  // files' contents in the browser's storage.
  // Keep in sync with the pages that load app.js (the release check tests it).
  const TOOL_PAGES = new Set(["/", "/compare-pdf.html", "/compress-pdf.html", "/crop-pdf.html", "/de/", "/de/bilder-aus-pdf-extrahieren.html", "/de/dsgvo-pdf-tools.html", "/de/jpg-in-pdf.html", "/de/mehrere-seiten-pro-blatt-pdf.html", "/de/pdf-abflachen.html", "/de/pdf-ausfuellen.html", "/de/pdf-drehen.html", "/de/pdf-entsperren.html", "/de/pdf-in-excel.html", "/de/pdf-in-jpg.html", "/de/pdf-in-powerpoint.html", "/de/pdf-in-text.html", "/de/pdf-in-word.html", "/de/pdf-komprimieren.html", "/de/pdf-metadaten.html", "/de/pdf-ocr-texterkennung.html", "/de/pdf-organisieren.html", "/de/pdf-schuetzen.html", "/de/pdf-schwaerzen.html", "/de/pdf-seiten-extrahieren.html", "/de/pdf-seiten-loeschen.html", "/de/pdf-teilen.html", "/de/pdf-unterschreiben.html", "/de/pdf-vergleichen.html", "/de/pdf-wasserzeichen.html", "/de/pdf-zusammenfuegen.html", "/de/pdf-zuschneiden.html", "/de/png-in-pdf.html", "/de/seitenzahlen-pdf.html", "/de/weitere-pdf-tools.html", "/delete-pages-pdf.html", "/es/", "/es/aplanar-pdf.html", "/es/censurar-pdf.html", "/es/comparar-pdf.html", "/es/comprimir-pdf.html", "/es/desbloquear-pdf.html", "/es/dividir-pdf.html", "/es/eliminar-paginas-pdf.html", "/es/extraer-imagenes-pdf.html", "/es/extraer-paginas-pdf.html", "/es/firmar-pdf.html", "/es/herramientas-pdf-extra.html", "/es/herramientas-pdf-rgpd.html", "/es/jpg-a-pdf.html", "/es/marca-de-agua-pdf.html", "/es/metadatos-pdf.html", "/es/numerar-paginas-pdf.html", "/es/ocr-pdf.html", "/es/organizar-pdf.html", "/es/pdf-a-excel.html", "/es/pdf-a-jpg.html", "/es/pdf-a-powerpoint.html", "/es/pdf-a-texto.html", "/es/pdf-a-word.html", "/es/png-a-pdf.html", "/es/proteger-pdf.html", "/es/recortar-pdf.html", "/es/rellenar-pdf.html", "/es/rotar-pdf.html", "/es/unir-pdf.html", "/es/varias-paginas-por-hoja-pdf.html", "/extra-tools.html", "/extract-images-pdf.html", "/extract-pages-pdf.html", "/fill-pdf.html", "/flatten-pdf.html", "/fr/", "/fr/aplatir-pdf.html", "/fr/caviarder-pdf.html", "/fr/comparer-pdf.html", "/fr/compresser-pdf.html", "/fr/deverrouiller-pdf.html", "/fr/diviser-pdf.html", "/fr/extraire-images-pdf.html", "/fr/extraire-pages-pdf.html", "/fr/filigrane-pdf.html", "/fr/fusionner-pdf.html", "/fr/jpg-en-pdf.html", "/fr/metadonnees-pdf.html", "/fr/numeroter-pages-pdf.html", "/fr/ocr-pdf.html", "/fr/organiser-pdf.html", "/fr/outils-pdf-rgpd.html", "/fr/outils-pdf-supplementaires.html", "/fr/pdf-en-excel.html", "/fr/pdf-en-jpg.html", "/fr/pdf-en-powerpoint.html", "/fr/pdf-en-texte.html", "/fr/pdf-en-word.html", "/fr/pivoter-pdf.html", "/fr/plusieurs-pages-par-feuille-pdf.html", "/fr/png-en-pdf.html", "/fr/proteger-pdf.html", "/fr/remplir-pdf.html", "/fr/rogner-pdf.html", "/fr/signer-pdf.html", "/fr/supprimer-pages-pdf.html", "/gdpr-pdf-tools.html", "/it/", "/it/altri-strumenti-pdf.html", "/it/appiattire-pdf.html", "/it/compilare-pdf.html", "/it/comprimere-pdf.html", "/it/confrontare-pdf.html", "/it/dividere-pdf.html", "/it/eliminare-pagine-pdf.html", "/it/estrarre-immagini-pdf.html", "/it/estrarre-pagine-pdf.html", "/it/filigrana-pdf.html", "/it/firmare-pdf.html", "/it/jpg-in-pdf.html", "/it/metadati-pdf.html", "/it/numerare-pagine-pdf.html", "/it/ocr-pdf.html", "/it/organizzare-pdf.html", "/it/oscurare-pdf.html", "/it/pdf-in-excel.html", "/it/pdf-in-jpg.html", "/it/pdf-in-powerpoint.html", "/it/pdf-in-testo.html", "/it/pdf-in-word.html", "/it/piu-pagine-per-foglio-pdf.html", "/it/png-in-pdf.html", "/it/proteggere-pdf.html", "/it/ritagliare-pdf.html", "/it/ruotare-pdf.html", "/it/sbloccare-pdf.html", "/it/strumenti-pdf-gdpr.html", "/it/unire-pdf.html", "/jpg-to-pdf.html", "/merge-pdf.html", "/nl/", "/nl/afbeeldingen-uit-pdf-halen.html", "/nl/avg-pdf-tools.html", "/nl/extra-pdf-tools.html", "/nl/jpg-naar-pdf.html", "/nl/meerdere-paginas-per-blad-pdf.html", "/nl/paginanummers-toevoegen-pdf.html", "/nl/paginas-extraheren-pdf.html", "/nl/paginas-verwijderen-pdf.html", "/nl/pdf-afvlakken.html", "/nl/pdf-beveiligen.html", "/nl/pdf-bijsnijden.html", "/nl/pdf-comprimeren.html", "/nl/pdf-draaien.html", "/nl/pdf-invullen.html", "/nl/pdf-metadata-wissen.html", "/nl/pdf-naar-excel.html", "/nl/pdf-naar-jpg.html", "/nl/pdf-naar-powerpoint.html", "/nl/pdf-naar-tekst.html", "/nl/pdf-naar-word.html", "/nl/pdf-ocr-tekst-herkennen.html", "/nl/pdf-ondertekenen.html", "/nl/pdf-ontgrendelen.html", "/nl/pdf-ordenen.html", "/nl/pdf-samenvoegen.html", "/nl/pdf-splitsen.html", "/nl/pdf-vergelijken.html", "/nl/pdf-zwartlakken.html", "/nl/png-naar-pdf.html", "/nl/watermerk-toevoegen-pdf.html", "/ocr-pdf.html", "/organize-pdf.html", "/page-numbers-pdf.html", "/pages-per-sheet-pdf.html", "/pdf-metadata.html", "/pdf-to-excel.html", "/pdf-to-jpg.html", "/pdf-to-powerpoint.html", "/pdf-to-text.html", "/pdf-to-word.html", "/pl/", "/pl/jpg-na-pdf.html", "/pl/kilka-stron-na-arkuszu-pdf.html", "/pl/kompresuj-pdf.html", "/pl/metadane-pdf.html", "/pl/narzedzia-pdf-rodo.html", "/pl/narzedzia-pdf.html", "/pl/numeracja-stron-pdf.html", "/pl/obroc-pdf.html", "/pl/ocr-pdf.html", "/pl/odblokuj-pdf.html", "/pl/organizuj-pdf.html", "/pl/pdf-na-excel.html", "/pl/pdf-na-jpg.html", "/pl/pdf-na-powerpoint.html", "/pl/pdf-na-tekst.html", "/pl/pdf-na-word.html", "/pl/png-na-pdf.html", "/pl/podpisz-pdf.html", "/pl/podziel-pdf.html", "/pl/polacz-pdf.html", "/pl/porownaj-pdf.html", "/pl/przytnij-pdf.html", "/pl/splaszcz-pdf.html", "/pl/usun-strony-z-pdf.html", "/pl/wyodrebnij-obrazy-z-pdf.html", "/pl/wyodrebnij-strony-z-pdf.html", "/pl/wypelnij-pdf.html", "/pl/zabezpiecz-pdf-haslem.html", "/pl/zaczernij-pdf.html", "/pl/znak-wodny-pdf.html", "/png-to-pdf.html", "/protect-pdf.html", "/pt/", "/pt/achatar-pdf.html", "/pt/assinar-pdf.html", "/pt/comparar-pdf.html", "/pt/comprimir-pdf.html", "/pt/desbloquear-pdf.html", "/pt/dividir-pdf.html", "/pt/excluir-paginas-pdf.html", "/pt/extrair-imagens-pdf.html", "/pt/extrair-paginas-pdf.html", "/pt/ferramentas-pdf-extras.html", "/pt/ferramentas-pdf-rgpd.html", "/pt/girar-pdf.html", "/pt/jpg-para-pdf.html", "/pt/juntar-pdf.html", "/pt/marca-dagua-pdf.html", "/pt/metadados-pdf.html", "/pt/numerar-paginas-pdf.html", "/pt/ocr-pdf.html", "/pt/organizar-pdf.html", "/pt/pdf-para-excel.html", "/pt/pdf-para-jpg.html", "/pt/pdf-para-powerpoint.html", "/pt/pdf-para-texto.html", "/pt/pdf-para-word.html", "/pt/png-para-pdf.html", "/pt/preencher-pdf.html", "/pt/proteger-pdf.html", "/pt/recortar-pdf.html", "/pt/tarjar-pdf.html", "/pt/varias-paginas-por-folha-pdf.html", "/redact-pdf.html", "/rotate-pdf.html", "/sign-pdf.html", "/split-pdf.html", "/unlock-pdf.html", "/watermark-pdf.html"]);
  const usesFiles = url => TOOL_PAGES.has(url.pathname.replace(/index\.html$/, ''));
  // (v85) the link checks both hand-over paths share: a link to another
  // tool page of this site while there are files to carry, else null
  const handoffUrl = a => {
    if(!a || a.hasAttribute('download') || a.classList.contains('next-step')) return null;
    let url;
    try{ url = new URL(a.getAttribute('href'), location.href); }catch(err){ return null; }
    if(url.origin !== location.origin) return null;
    if(url.pathname === location.pathname && url.search === location.search) return null; // in-page link
    if(!usesFiles(url) || !fileHub.all().length) return null;
    return url;
  };
  const handOffToNewTab = e => {
    if(e.defaultPrevented || e.altKey) return;
    const a = e.target.closest && e.target.closest('a[href]');
    const newTab = (e.type === 'click' && e.button === 0 && (e.metaKey || e.ctrlKey || e.shiftKey || (a && a.target === '_blank'))) || (e.type === 'auxclick' && e.button === 1);
    if(!newTab || !handoffUrl(a)) return;
    // storage unavailable: the new tab opens empty (it can't be told: it is
    // already loading), this page keeps its files
    saveHandoff(fileHub.all(), false, a.href, true).catch(logStorageError);
  };
  document.addEventListener('click', handOffToNewTab);
  document.addEventListener('auxclick', handOffToNewTab);
  document.addEventListener('click', e => {
    if(e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest && e.target.closest('a[href]');
    if(!a || a.target) return;
    const url = handoffUrl(a);
    if(!url) return;
    e.preventDefault();
    let done = false;
    const go = noFile => {
      if(done) return;
      done = true;
      // (v90) the files did not come along: the next page says so (#pc-nofile)
      if(noFile) url.hash = PC_NEXT_NOFILE_HASH.slice(1);
      location.href = url.href;
    };
    // storing took too long (leaving now breaks it off): said on the next page
    setTimeout(() => go(true), PC_NEXT_HANDOFF_TIMEOUT_MS);
    saveHandoff(fileHub.all(), false, url.href).then(() => go(false), err => {
      if(!pcIsStorageRefusal(err)) pcLogUnexpected(err);
      go(true); // storage unavailable (private mode, full): said on the next page
    });
  });
  return { save: saveHandoff };
})();


/* ---------- (v62) "What next?": continue with the result in another tool ----------
   Under a finished PDF result: 2-3 links to tools that make sense next. The
   result itself goes along, only inside this browser: straight into the other
   tab when that tool is on this page, else through the hand-over store above
   (IndexedDB of this site, taken and deleted by the next page on arrival).
   Nothing is uploaded. Only for ONE PDF result: Word/PowerPoint/Excel/JPG
   output and zips of several files get no block. When the browser refuses the
   store (e.g. a private window), the link still opens the tool, which then
   asks to choose the file again (#pc-nofile). */
const PC_NEXT_STEPS = {
  merge: ['org', 'compress', 'redact', 'nup'], // (v112) organize the merged pages first
  compress: ['sign', 'protect', 'merge'],
  split: ['compress', 'word', 'sign'],
  rotate: ['compress', 'numbers', 'sign'],
  numbers: ['sign', 'compress', 'protect'],
  delete: ['numbers', 'compress', 'merge'],
  extract: ['merge', 'compress', 'word'],
  watermark: ['flatten', 'protect', 'compress', 'sign'],
  jpgpdf: ['ocr', 'compress', 'merge', 'sign'],
  unlock: ['compress', 'word', 'merge'],
  sign: ['flatten', 'protect', 'fill', 'redact', 'compress'],
  nup: ['numbers', 'compress', 'merge'],
  crop: ['compress', 'merge', 'numbers'], // (v110)
  meta: ['protect', 'compress', 'sign'],
  org: ['compress', 'numbers', 'redact', 'sign'],
  fill: ['sign', 'flatten', 'protect', 'compress', 'merge'],
  flatten: ['sign', 'protect', 'compress', 'merge'],
  redact: ['meta', 'protect', 'compress'],
  ocr: ['txt', 'word', 'compress']
  // protect: none (the result needs its password first); word, ppt, excel,
  // pdfjpg: no PDF comes out
};
const PC_TOOL_URLS = {
  merge: { en: '/merge-pdf.html', nl: '/nl/pdf-samenvoegen.html', fr: '/fr/fusionner-pdf.html', de: '/de/pdf-zusammenfuegen.html', es: '/es/unir-pdf.html', pt: '/pt/juntar-pdf.html', it: "/it/unire-pdf.html", pl: "/pl/polacz-pdf.html" },
  compress: { en: '/compress-pdf.html', nl: '/nl/pdf-comprimeren.html', fr: '/fr/compresser-pdf.html', de: '/de/pdf-komprimieren.html', es: '/es/comprimir-pdf.html', pt: '/pt/comprimir-pdf.html', it: "/it/comprimere-pdf.html", pl: "/pl/kompresuj-pdf.html" },
  word: { en: '/pdf-to-word.html', nl: '/nl/pdf-naar-word.html', fr: '/fr/pdf-en-word.html', de: '/de/pdf-in-word.html', es: '/es/pdf-a-word.html', pt: '/pt/pdf-para-word.html', it: "/it/pdf-in-word.html", pl: "/pl/pdf-na-word.html" },
  sign: { en: '/sign-pdf.html', nl: '/nl/pdf-ondertekenen.html', fr: '/fr/signer-pdf.html', de: '/de/pdf-unterschreiben.html', es: '/es/firmar-pdf.html', pt: '/pt/assinar-pdf.html', it: "/it/firmare-pdf.html", pl: "/pl/podpisz-pdf.html" },
  protect: { en: '/protect-pdf.html', nl: '/nl/pdf-beveiligen.html', fr: '/fr/proteger-pdf.html', de: '/de/pdf-schuetzen.html', es: '/es/proteger-pdf.html', pt: '/pt/proteger-pdf.html', it: "/it/proteggere-pdf.html", pl: "/pl/zabezpiecz-pdf-haslem.html" },
  numbers: { en: '/page-numbers-pdf.html', nl: '/nl/paginanummers-toevoegen-pdf.html', fr: '/fr/numeroter-pages-pdf.html', de: '/de/seitenzahlen-pdf.html', es: '/es/numerar-paginas-pdf.html', pt: '/pt/numerar-paginas-pdf.html', it: "/it/numerare-pagine-pdf.html", pl: "/pl/numeracja-stron-pdf.html" },
  org: { en: '/organize-pdf.html', nl: '/nl/pdf-ordenen.html', fr: '/fr/organiser-pdf.html', de: '/de/pdf-organisieren.html', es: '/es/organizar-pdf.html', pt: '/pt/organizar-pdf.html', it: "/it/organizzare-pdf.html", pl: "/pl/organizuj-pdf.html" },
  nup: { en: '/pages-per-sheet-pdf.html', nl: '/nl/meerdere-paginas-per-blad-pdf.html', fr: '/fr/plusieurs-pages-par-feuille-pdf.html', de: '/de/mehrere-seiten-pro-blatt-pdf.html', es: '/es/varias-paginas-por-hoja-pdf.html', pt: '/pt/varias-paginas-por-folha-pdf.html', it: "/it/piu-pagine-per-foglio-pdf.html", pl: "/pl/kilka-stron-na-arkuszu-pdf.html" },
  meta: { en: '/pdf-metadata.html', nl: '/nl/pdf-metadata-wissen.html', fr: '/fr/metadonnees-pdf.html', de: '/de/pdf-metadaten.html', es: '/es/metadatos-pdf.html', pt: '/pt/metadados-pdf.html', it: '/it/metadati-pdf.html', pl: "/pl/metadane-pdf.html" },
  txt: { en: '/pdf-to-text.html', nl: '/nl/pdf-naar-tekst.html', fr: '/fr/pdf-en-texte.html', de: '/de/pdf-in-text.html', es: '/es/pdf-a-texto.html', pt: '/pt/pdf-para-texto.html', it: '/it/pdf-in-testo.html', pl: "/pl/pdf-na-tekst.html" },
  fill: { en: '/fill-pdf.html', nl: '/nl/pdf-invullen.html', fr: '/fr/remplir-pdf.html', de: '/de/pdf-ausfuellen.html', es: '/es/rellenar-pdf.html', pt: '/pt/preencher-pdf.html', it: '/it/compilare-pdf.html', pl: "/pl/wypelnij-pdf.html" },
  flatten: { en: '/flatten-pdf.html', nl: '/nl/pdf-afvlakken.html', fr: '/fr/aplatir-pdf.html', de: '/de/pdf-abflachen.html', es: '/es/aplanar-pdf.html', pt: '/pt/achatar-pdf.html', it: '/it/appiattire-pdf.html', pl: "/pl/splaszcz-pdf.html" },
  redact: { en: '/redact-pdf.html', nl: '/nl/pdf-zwartlakken.html', fr: '/fr/caviarder-pdf.html', de: '/de/pdf-schwaerzen.html', es: '/es/censurar-pdf.html', pt: '/pt/tarjar-pdf.html', it: '/it/oscurare-pdf.html', pl: "/pl/zaczernij-pdf.html" },
  ocr: { en: '/ocr-pdf.html', nl: '/nl/pdf-ocr-tekst-herkennen.html', fr: '/fr/ocr-pdf.html', de: '/de/pdf-ocr-texterkennung.html', es: '/es/ocr-pdf.html', pt: '/pt/ocr-pdf.html', it: '/it/ocr-pdf.html', pl: "/pl/ocr-pdf.html" }
};
const PC_NEXT_NOFILE_HASH = '#pc-nofile';
const PC_NEXT_HANDOFF_TIMEOUT_MS = 4000; // storing takes milliseconds; never keep the visitor waiting on a stuck store
const pcNextResults = new Map(); // tool -> File of its shown result (released with that result)

function pcToolUrl(tool){ const u = PC_TOOL_URLS[tool]; return u[PDFC_LANG] || u.en; }
function pcNextStepsBlock(tool, targets, filename){
  const wrap = document.createElement('div');
  wrap.className = 'next-steps';
  wrap.id = 'next-steps-' + tool;
  wrap.setAttribute('role', 'group');
  wrap.setAttribute('aria-labelledby', wrap.id + '-title');
  const title = document.createElement('p');
  title.className = 'next-steps-title';
  title.id = wrap.id + '-title';
  title.textContent = pcT('nextTitle');
  const sub = document.createElement('p');
  sub.className = 'next-steps-sub';
  sub.textContent = pcT('nextSub', filename);
  const ul = document.createElement('ul');
  ul.className = 'next-steps-list';
  targets.forEach(target => {
    const a = document.createElement('a');
    a.className = 'next-step';
    a.href = pcToolUrl(target);
    a.dataset.from = tool;
    a.dataset.to = target;
    a.textContent = pcT('nextTool_' + target);
    const li = document.createElement('li');
    li.appendChild(a);
    ul.appendChild(li);
  });
  wrap.append(title, sub, ul);
  return wrap;
}
function pcForgetNextSteps(tool){
  pcNextResults.delete(tool);
  const old = document.getElementById('next-steps-' + tool);
  if(old) old.remove();
  pcForgetShare(tool); // (v73) every place that clears a result clears its share button too
}

/* (v73, q16) A zip is awkward on a phone: iOS puts it in the Files app,
   where it has to be opened before the files can be used. When a tool gives
   a few files and the browser can share files (iOS 15+, Android), a second
   button under the zip opens the device's own share menu with the files
   themselves ("Save to Files", "Save Images" for PDF to JPG). Nothing is
   sent anywhere by this: the menu is the device's, and the visitor chooses.
   The zip stays the normal download, so nothing changes elsewhere. */
const PC_SHARE_MAX_FILES = 10;
const PC_SHARE_MAX_BYTES = 200 * 1024 * 1024; // share sheets copy the files: keep it to what a phone can hold
const PC_SHARE_TYPES = { pdf: 'application/pdf', jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' };
function pcForgetShare(tool){
  const old = document.getElementById('share-files-' + tool);
  if(old) old.remove();
}
function pcShareFilesOf(results){
  // (v111) one result too in the installed app on iOS, where a blob download opens without a way to save
  const minFiles = navigator.standalone === true ? 1 : 2;
  if(results.length < minFiles || results.length > PC_SHARE_MAX_FILES || typeof File !== 'function') return null;
  if(!pcIsPhone() || !navigator.share || !navigator.canShare) return null;
  if(results.reduce((s, r) => s + r.blob.size, 0) > PC_SHARE_MAX_BYTES) return null;
  const names = pcUniqueFilenames(results.map(r => pcSafeZipName(r.filename)));
  const files = results.map((r, i) => {
    const ext = (names[i].match(/\.([A-Za-z0-9]+)$/) || [])[1] || '';
    return new File([r.blob], names[i], { type: r.blob.type || PC_SHARE_TYPES[ext.toLowerCase()] || 'application/octet-stream' });
  });
  try{ return navigator.canShare({ files }) ? files : null; }
  catch(e){ return null; } // canShare itself refusing means: no share button, the zip still works
}
function pcShareBlock(tool, files){
  const wrap = document.createElement('div');
  wrap.className = 'share-files';
  wrap.id = 'share-files-' + tool;
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'btn share-files-btn';
  btn.textContent = pcT('shareFiles', files.length);
  const hint = document.createElement('p');
  hint.className = 'share-files-hint';
  hint.id = wrap.id + '-hint';
  hint.textContent = pcT('shareHint');
  btn.setAttribute('aria-describedby', hint.id);
  btn.addEventListener('click', () => {
    navigator.share({ files }).catch(err => {
      if(err && err.name === 'AbortError') return; // the visitor closed the share menu: not an error
      pcAnnounce(pcT('shareFailed'), true);
      hint.textContent = pcT('shareFailed');
      hint.classList.add('share-files-error');
    });
  });
  wrap.append(btn, hint);
  return wrap;
}
function pcOfferShare(downloadEl, results){
  const tool = downloadEl.id.replace(/^download-/, '');
  pcForgetShare(tool);
  const box = document.getElementById('result-' + tool);
  const files = box && pcShareFilesOf(results);
  if(files) box.appendChild(pcShareBlock(tool, files));
}
/* Called wherever a tool puts its result on the download button. */
function pcOfferNextSteps(downloadEl, blob, filename){
  const tool = (downloadEl && downloadEl.id || '').replace(/^download-/, '');
  pcForgetNextSteps(tool);
  const targets = PC_NEXT_STEPS[tool];
  const box = document.getElementById('result-' + tool);
  if(!targets || !box || !blob || !/\.pdf$/i.test(filename || '') || typeof File !== 'function') return;
  pcNextResults.set(tool, new File([blob], filename, { type: 'application/pdf', lastModified: Date.now() }));
  box.appendChild(pcNextStepsBlock(tool, targets, filename));
}

/* The note above the file list of the open tool ("File from the previous
   step: x.pdf", or that it could not come along). It goes away when that
   file is removed. */
let pcStepNoteOff = null; // removes the listener of the note shown now (it holds that File)
let pcStepArrived = false;  // a step's result came in: no "could not come along" note
function pcHideStepNote(){
  if(pcStepNoteOff){ pcStepNoteOff(); pcStepNoteOff = null; }
  const old = document.getElementById('pc-step-note');
  if(old) old.remove();
}
function pcShowStepNote(text, file){
  const panel = document.querySelector('.tool-card .panel.active');
  const list = panel && panel.querySelector('.filelist');
  pcHideStepNote();
  if(!list) return;
  const note = document.createElement('p');
  note.id = 'pc-step-note';
  note.className = 'pc-step-note';
  note.textContent = text;
  list.insertAdjacentElement('beforebegin', note);
  pcAnnounce(text);
  // with the file: gone once it is removed; without (it didn't come along):
  // gone once the visitor has chosen a file
  const off = file
    ? fileHub.register(f => f === file, l => { if(!l.length) pcHideStepNote(); })
    : fileHub.register(() => true, l => { if(l.length) pcHideStepNote(); });
  if(note.isConnected) pcStepNoteOff = off; else off(); // (register may already have hidden it)
}
function pcTabShown(tab){ return !!tab && !tab.hidden && getComputedStyle(tab).display !== 'none'; }
function pcContinueHere(tab, file){
  const othersCleared = fileHub.all().some(f => f !== file);
  fileHub.replace([file]);
  tab.click();
  tab.focus();
  // the list now holds only the result: say so when other files were in it
  pcShowStepNote(pcT('nextFromStep', file.name) + (othersCleared ? '. ' + pcT('nextOthersCleared') : ''), file);
}
function pcContinueOnPage(url, file){
  let done = false;
  const go = hash => { if(!done){ done = true; location.href = url + (hash || ''); } };
  // storing took too long: the next page says the file didn't come along
  // (should it still arrive, its "file from the previous step" note replaces that)
  setTimeout(() => go(PC_NEXT_NOFILE_HASH), PC_NEXT_HANDOFF_TIMEOUT_MS);
  pcHandoff.save([file], true, url).then(() => go(), () => go(PC_NEXT_NOFILE_HASH));
}
function pcNextStepClick(e){
  const a = e.target.closest && e.target.closest('a.next-step');
  if(!a || e.defaultPrevented) return;
  const file = pcNextResults.get(a.dataset.from);
  if(!file) return; // result already released: an ordinary link
  // A new tab or window (Ctrl/Cmd/Shift/middle click) is an ordinary link:
  // it could load before the file is stored, so it opens without it.
  if(e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  e.preventDefault();
  const tab = document.getElementById('tab-' + a.dataset.to);
  if(pcTabShown(tab)) pcContinueHere(tab, file);
  else pcContinueOnPage(a.href, file);
}
document.addEventListener('click', pcNextStepClick);
/* The previous page could not store its result: say so, once. Run when the
   page is ready (the messages, PC_MSG, are defined further down this file). */
function pcNextNoFileNote(){
  if(location.hash !== PC_NEXT_NOFILE_HASH) return;
  history.replaceState(null, '', location.pathname + location.search);
  if(!pcStepArrived) pcShowStepNote(pcT('nextNoFile'));
}
if(document.readyState === 'complete') pcNextNoFileNote(); else document.addEventListener('DOMContentLoaded', pcNextNoFileNote);

/* ---------- MERGE ---------- */
function setupDropzone(dz, input, onFiles, acceptFilter){
  const filterFn = acceptFilter || (f => f.type==='application/pdf' || f.name.toLowerCase().endsWith('.pdf'));
  dz.addEventListener('click', ()=> input.click());
  dz.addEventListener('keydown', e=>{ if(e.key==='Enter' || e.key===' '){ e.preventDefault(); input.click(); } });
  dz.addEventListener('dragover', e=>{ e.preventDefault(); dz.classList.add('dragover'); });
  dz.addEventListener('dragleave', ()=> dz.classList.remove('dragover'));
  dz.addEventListener('drop', e=>{
    e.preventDefault();
    dz.classList.remove('dragover');
    onFiles(pcTakeUsable(Array.from(e.dataTransfer.files), filterFn, dz));
  });
  input.addEventListener('change', ()=> onFiles(pcTakeUsable(Array.from(input.files), filterFn, dz)));
}
/* (v89) A file the tool can't use (wrong type, or empty) used to vanish
   without a word when dropped on the drop zone or picked via "All files".
   The visitor is now told which file was left out, and why. */
const PC_NAMES_SHOWN = 3;
function pcNameList(files){
  const names = files.slice(0, PC_NAMES_SHOWN).map(f => f.name);
  return names.join(', ') + (files.length > PC_NAMES_SHOWN ? ' (+' + (files.length - PC_NAMES_SHOWN) + ')' : '');
}
function pcTakeUsable(files, filterFn, dz){
  const wrong = files.filter(f => !filterFn(f));
  const empty = files.filter(f => filterFn(f) && f.size === 0);
  const msgs = [];
  if(wrong.length) msgs.push(pcT('wrongType', pcNameList(wrong)));
  if(empty.length) msgs.push(pcT('emptyFile', pcNameList(empty)));
  pcReportNotAdded(dz, msgs, false);
  return files.filter(f => filterFn(f) && f.size > 0);
}
/* (v90) The toast passes after 5 s, too fast for some visitors (WCAG 2.2.1,
   3.3.1): the message also stays under the tool's drop zone until the next
   files are added there (no message: the old one goes). With `append` it is
   added to what is already there (pc-interact.js: files of a mixed drop that
   no tool took). */
function pcNoteText(anchorEl){
  const n = anchorEl && anchorEl.parentNode && anchorEl.parentNode.querySelector(':scope > .pc-note[data-for="' + anchorEl.id + '"]');
  return n ? n.textContent : '';
}
function pcReportNotAdded(dz, msgs, append){
  const text = [append ? pcNoteText(dz) : ''].concat(msgs).filter(Boolean).join(' ');
  if(dz && dz.id) pcShowNote(dz, text);
  if(msgs.length && window.PDFC_TOAST) window.PDFC_TOAST(text);
}
// for pc-interact.js (drop anywhere, paste)
window.PDFC_NOTES = {
  show(dz, text){ pcReportNotAdded(dz, [text], false); },
  notAdded(dz, files){ pcReportNotAdded(dz, [pcT('wrongType', pcNameList(files))], true); },
};

function getFileExt(name){
  const m = name.toLowerCase().match(/\.(pdf|docx|pptx)$/);
  return m ? m[1] : null;
}
/* (v55) A PDF without ".pdf" in its name (Android downloads) counts as a
   PDF by its type; it used to make the merge list look "mixed". */
function pcFileKind(f){ return getFileExt(f.name) || (isPdfFile(f) ? 'pdf' : null); }

/* Merges multiple Word files (.docx) into one file, preserving each
   file's own page size/margins (via a real section break, the same way
   Word itself uses between document parts).
   v47: every later file now keeps its own headers/footers (with their
   pictures), hyperlinks, list numbering (its own format, not continuing
   the first file's list), footnotes, endnotes and comments, and styles that
   only exist in that file. Before v47 only the pictures in the body were
   carried over: file 2's headers, links and footnotes pointed at file 1's
   (showing file 1's header, footnote text or link target) and its lists
   continued file 1's numbering. When two files define a style with the
   same name, the first file's version is used - what Word itself does
   when text is inserted from another file. */
/* (v89) Where the body's own section properties start: the <w:sectPr> that
   closes the body, as a whole element (a section change inside it holds a
   nested one). -1 when the body has none: that element is optional, and
   the body used to be cut at a section break inside a paragraph instead,
   which gave a broken document under a green "Done". */
const PC_EMPTY_SECT = '<w:sectPr></w:sectPr>';
function pcBodySectStart(xml, bodyStart, bodyEnd){
  const tail = xml.slice(bodyStart, bodyEnd).replace(/\s+$/, '');
  const selfClosed = tail.match(/<w:sectPr\b[^>]*\/>$/);
  if(selfClosed) return bodyStart + selfClosed.index;
  if(!tail.endsWith('</w:sectPr>')) return -1;
  const tokens = [...tail.matchAll(/<w:sectPr\b[^>]*?(\/?)>|<\/w:sectPr>/g)];
  let depth = 0;
  for(let i = tokens.length - 1; i >= 0; i--){
    const t = tokens[i];
    if(t[0] === '</w:sectPr>') depth++;
    else if(!t[1]) depth--;
    if(depth === 0) return bodyStart + t.index;
  }
  return -1;
}
/* (v94) A .rels file may use single quotes or <Relationship ...></Relationship>:
   the Word/PowerPoint merge reads them with simple patterns that expected
   double quotes and self-closing elements, so images and links of such a
   file disappeared silently. Every .rels file is read in that one form. */
function pcNormRels(xml){
  return xml.replace(/<Relationship\b([^>]*?)\s*(?:\/>|>\s*<\/Relationship\s*>)/g, (m, attrs) => {
    const list = [...attrs.matchAll(/([\w:]+)\s*=\s*(?:"([^"]*)"|'([^']*)')/g)]
      .map(a => a[1] + '="' + (a[2] !== undefined ? a[2] : a[3].replace(/"/g, '&quot;')) + '"');
    return '<Relationship ' + list.join(' ') + '/>';
  });
}
async function pcReadZipText(zip, path){
  const f = zip.file(path);
  if(!f) return null;
  const text = await f.async('string');
  return path.endsWith('.rels') ? pcNormRels(text) : text;
}
async function mergeDocxFiles(files){
  const buffers = await Promise.all(files.map(f=>f.arrayBuffer()));
  const zips = await pcOpenOfficeZips(buffers); // (v90) refuses a zip bomb before anything is unpacked
  const base = zips[0];
  const outZip = new JSZip();
  for(const [path, file] of Object.entries(base.files)){
    if(file.dir) continue;
    outZip.file(path, await file.async('uint8array'));
  }
  const rd = pcReadZipText;
  const esc = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const dirOf = p => p.includes('/') ? p.slice(0, p.lastIndexOf('/')) : '';
  const baseName = p => p.slice(p.lastIndexOf('/') + 1);
  const norm = p => { const out = []; p.split('/').forEach(seg => { if(seg === '..') out.pop(); else if(seg && seg !== '.') out.push(seg); }); return out.join('/'); };
  const relTo = (fromDir, target) => {
    const a = fromDir ? fromDir.split('/') : [], b = target.split('/');
    let i = 0; while(i < a.length && i < b.length - 1 && a[i] === b[i]) i++;
    return '../'.repeat(a.length - i) + b.slice(i).join('/');
  };
  const parseRels = xml => [...(xml || '').matchAll(/<Relationship\b[^>]*\/>/g)].map(m => {
    const t = m[0], at = n => { const r = t.match(new RegExp('\\b' + n + '="([^"]*)"')); return r ? r[1] : null; };
    return { Id: at('Id'), Type: at('Type'), Target: at('Target'), TargetMode: at('TargetMode') };
  });
  const relsPathOf = part => (dirOf(part) ? dirOf(part) + '/' : '') + '_rels/' + baseName(part) + '.rels';
  let ctXml = await rd(base, '[Content_Types].xml');
  const ensureContentType = async (srcZip, srcPath, newPath) => {
    const srcCt = await rd(srcZip, '[Content_Types].xml') || '';
    const ov = srcCt.match(new RegExp('<Override\\b[^>]*PartName="/' + esc(srcPath) + '"[^>]*ContentType="([^"]+)"')) ||
               srcCt.match(new RegExp('<Override\\b[^>]*ContentType="([^"]+)"[^>]*PartName="/' + esc(srcPath) + '"'));
    if(ov){
      if(!ctXml.includes('PartName="/' + newPath + '"')) ctXml = ctXml.replace('</Types>', () => '<Override PartName="/' + newPath + '" ContentType="' + ov[1] + '"/></Types>');
      return;
    }
    const ext = (newPath.split('.').pop() || '').toLowerCase();
    if(new RegExp('<Default\\b[^>]*Extension="' + esc(ext) + '"', 'i').test(ctXml)) return;
    const df = srcCt.match(new RegExp('<Default\\b[^>]*Extension="' + esc(ext) + '"[^>]*ContentType="([^"]+)"', 'i'));
    if(df) ctXml = ctXml.replace('</Types>', () => '<Default Extension="' + ext + '" ContentType="' + df[1] + '"/></Types>');
  };
  // Copies a part (and whatever IT refers to) from a later file under a new
  // name, so it can never overwrite a part of the first file.
  const copied = new Map();
  const copyPart = async (srcZip, z, srcPath) => {
    const key = z + ':' + srcPath;
    if(copied.has(key)) return copied.get(key);
    const f = srcZip.file(srcPath);
    if(!f) return null;
    let newPath = dirOf(srcPath) + '/m' + z + '_' + baseName(srcPath);
    let n = 2; while(outZip.file(newPath)){ newPath = dirOf(srcPath) + '/m' + z + '_' + (n++) + '_' + baseName(srcPath); }
    copied.set(key, newPath);
    outZip.file(newPath, await f.async('uint8array'));
    await ensureContentType(srcZip, srcPath, newPath);
    const relsXml = await rd(srcZip, relsPathOf(srcPath));
    if(relsXml){
      let out = relsXml;
      for(const r of parseRels(relsXml)){
        if(r.TargetMode === 'External' || !r.Target) continue;
        const target = norm(dirOf(srcPath) + '/' + r.Target);
        const np = await copyPart(srcZip, z, target);
        if(np) out = out.replace(new RegExp('(<Relationship\\b[^>]*Id="' + esc(r.Id) + '"[^>]*Target=")' + esc(r.Target) + '"'), (m, a) => a + relTo(dirOf(newPath), np) + '"');
      }
      outZip.file(relsPathOf(newPath), out);
    }
    return newPath;
  };
  const DOC_REL = 'word/_rels/document.xml.rels';
  let baseRelsXml = await rd(base, DOC_REL);
  let maxRid = 0;
  [...baseRelsXml.matchAll(/Id="rId(\d+)"/g)].forEach(m=> maxRid = Math.max(maxRid, parseInt(m[1],10)));
  const addDocRel = (type, target, external) => {
    maxRid++;
    const id = 'rId' + maxRid;
    baseRelsXml = baseRelsXml.replace('</Relationships>', () => '<Relationship Id="' + id + '" Type="' + type + '" Target="' + target + '"' + (external ? ' TargetMode="External"' : '') + '/></Relationships>');
    return id;
  };
  const relTarget = type => { const r = parseRels(baseRelsXml).find(x => x.Type && x.Type.endsWith('/' + type)); return r ? norm('word/' + r.Target) : null; };
  // parts that are merged instead of copied
  const SINGLE = new Set(['styles','numbering','settings','webSettings','fontTable','theme','footnotes','endnotes','comments','commentsExtended','commentsIds','commentsExtensible','people','customXml','glossaryDocument','stylesWithEffects']);
  const REL_NS = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/';
  // running id counters for things that must be unique in one document
  let stylesXml = relTarget('styles') ? await rd(outZip, relTarget('styles')) : null;
  let numberingPath = relTarget('numbering'), numberingXml = numberingPath ? await rd(outZip, numberingPath) : null;
  const notes = {};
  for(const kind of ['footnotes', 'endnotes', 'comments']){
    const path = relTarget(kind);
    notes[kind] = { path, xml: path ? await rd(outZip, path) : null };
  }
  const maxAttr = (xml, re) => { let m = 0; for(const x of (xml || '').matchAll(re)) m = Math.max(m, parseInt(x[1], 10)); return m; };
  let docPrId = 0, bookmarkId = 0;
  const emptyHF = {};
  const firstDoc = await rd(base, 'word/document.xml');
  const origRoot = firstDoc.slice(0, firstDoc.indexOf('<w:body>'));
  docPrId = maxAttr(firstDoc, /<wp:docPr\b[^>]*\bid="(\d+)"/g);
  bookmarkId = maxAttr(firstDoc, /<w:bookmarkStart\b[^>]*w:id="(\d+)"/g);

  const parts = [];
  for(let z=0; z<zips.length; z++){
    pcCheckCancel();
    const zip = zips[z];
    let docXml = await zip.file('word/document.xml').async('string');
    const bIdx = docXml.indexOf('<w:body>') + '<w:body>'.length;
    const eIdx = docXml.lastIndexOf('</w:body>');
    // (v89) the body's own (last) section; it is optional in Word files
    const sIdx = pcBodySectStart(docXml, bIdx, eIdx);
    let bodyContent = docXml.slice(bIdx, sIdx < 0 ? eIdx : sIdx);
    let sectPr = sIdx < 0 ? PC_EMPTY_SECT : docXml.slice(sIdx, eIdx).trim().replace(/^<w:sectPr\b([^>]*?)\/>$/, '<w:sectPr$1></w:sectPr>'); // written out in full, so headers can go inside

    if(z > 0){
      const relsXml = await rd(zip, DOC_REL) || '';
      const ridMap = {};
      for(const r of parseRels(relsXml)){
        const short = (r.Type || '').split('/').pop();
        if(r.TargetMode === 'External'){ ridMap[r.Id] = addDocRel(r.Type, r.Target, true); continue; }
        if(SINGLE.has(short) || !r.Target) continue;
        const np = await copyPart(zip, z, norm('word/' + r.Target));
        if(np) ridMap[r.Id] = addDocRel(r.Type, relTo('word', np), false);
      }
      const mapRids = x => x.replace(/(\br:[A-Za-z]+=")(rId\d+)"/g, (m, a, id) => ridMap[id] ? a + ridMap[id] + '"' : m);
      bodyContent = mapRids(bodyContent);
      sectPr = mapRids(sectPr);
      // A section without its own header/footer shows the PREVIOUS section's
      // in Word. This file's first section gets empty ones for every type it
      // doesn't define, so it never shows the previous file's header.
      const fillHF = sp => {
        let out = sp;
        for(const [kind, tag, root] of [['header', 'headerReference', 'hdr'], ['footer', 'footerReference', 'ftr']]){
          const missing = ['default', 'first', 'even'].filter(t => !new RegExp('<w:' + tag + '\\b[^>]*w:type="' + t + '"').test(out));
          if(!missing.length) continue;
          if(!emptyHF[kind]){
            const path = 'word/pc_empty_' + kind + '.xml';
            outZip.file(path, '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><w:' + root + ' xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main"><w:p/></w:' + root + '>');
            ctXml = ctXml.replace('</Types>', () => '<Override PartName="/' + path + '" ContentType="application/vnd.openxmlformats-officedocument.wordprocessingml.' + kind + '+xml"/></Types>');
            emptyHF[kind] = addDocRel(REL_NS + kind, baseName(path), false);
          }
          const refs = missing.map(t => '<w:' + tag + ' w:type="' + t + '" r:id="' + emptyHF[kind] + '"/>').join('');
          out = out.replace(/<w:sectPr\b[^>]*>/, m => m + refs);
        }
        if(!/xmlns:r=/.test(out) && !/xmlns:r=/.test(origRoot)) out = out.replace(/<w:sectPr\b/, '<w:sectPr xmlns:r="' + REL_NS.slice(0, -1).replace(/\/relationships$/, '/relationships') + '"');
        return out;
      };
      const firstSect = bodyContent.search(/<w:sectPr\b/);
      if(firstSect >= 0){
        const end = bodyContent.indexOf('</w:sectPr>', firstSect) + '</w:sectPr>'.length;
        bodyContent = bodyContent.slice(0, firstSect) + fillHF(bodyContent.slice(firstSect, end)) + bodyContent.slice(end);
      }else{
        sectPr = fillHF(sectPr);
      }
      // unique drawing ids and bookmark ids; paragraph ids are optional
      bodyContent = bodyContent.replace(/(<wp:docPr\b[^>]*\bid=")(\d+)"/g, (m, a) => a + (++docPrId) + '"');
      const bmMap = {};
      bodyContent = bodyContent.replace(/(<w:bookmark(?:Start|End)\b[^>]*w:id=")(\d+)"/g, (m, a, id) => { if(!(id in bmMap)) bmMap[id] = ++bookmarkId; return a + bmMap[id] + '"'; });
      bodyContent = bodyContent.replace(/\sw14:(?:paraId|textId)="[0-9A-Fa-f]+"/g, '');
      // lists: this file's own numbering definitions under new ids
      const srcNumPath = (() => { const r = parseRels(relsXml).find(x => (x.Type || '').endsWith('/numbering')); return r ? norm('word/' + r.Target) : null; })();
      const srcNum = srcNumPath ? await rd(zip, srcNumPath) : null;
      const numMap = {};
      if(srcNum){
        if(!numberingXml){
          numberingPath = 'word/numbering.xml';
          numberingXml = srcNum;
          addDocRel(REL_NS + 'numbering', 'numbering.xml', false);
          if(!ctXml.includes('PartName="/word/numbering.xml"')) ctXml = ctXml.replace('</Types>', '<Override PartName="/word/numbering.xml" ContentType="application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml"/></Types>');
        }else{
          const absOff = maxAttr(numberingXml, /w:abstractNumId="(\d+)"/g) + 1;
          const numOff = maxAttr(numberingXml, /<w:num\b[^>]*w:numId="(\d+)"/g);
          const rnd = () => Math.floor(Math.random() * 0xffffffff).toString(16).toUpperCase().padStart(8, '0');
          const abs = [...srcNum.matchAll(/<w:abstractNum\b[\s\S]*?<\/w:abstractNum>/g)].map(m => m[0]
            .replace(/(<w:abstractNum\b[^>]*w:abstractNumId=")(\d+)"/, (x, a, id) => a + (parseInt(id,10) + absOff) + '"')
            .replace(/(<w:nsid w:val=")[0-9A-Fa-f]+"/, (x, a) => a + rnd() + '"'));
          const nums = [...srcNum.matchAll(/<w:num\b[^>]*w:numId="(\d+)"[^>]*>[\s\S]*?<\/w:num>/g)].map(m => {
            numMap[m[1]] = parseInt(m[1],10) + numOff;
            return m[0].replace(/(<w:num\b[^>]*w:numId=")(\d+)"/, (x, a, id) => a + (parseInt(id,10) + numOff) + '"')
                       .replace(/(<w:abstractNumId w:val=")(\d+)"/, (x, a, id) => a + (parseInt(id,10) + absOff) + '"');
          });
          const firstNum = numberingXml.search(/<w:num\b/);
          numberingXml = firstNum >= 0 ? numberingXml.slice(0, firstNum) + abs.join('') + numberingXml.slice(firstNum) : numberingXml.replace('</w:numbering>', () => abs.join('') + '</w:numbering>');
          numberingXml = numberingXml.replace('</w:numbering>', () => nums.join('') + '</w:numbering>');
        }
      }
      const mapNums = x => x.replace(/(<w:numId w:val=")(\d+)"/g, (m, a, id) => id !== '0' && numMap[id] ? a + numMap[id] + '"' : m);
      bodyContent = mapNums(bodyContent);
      // styles that only this file has
      const srcStylesPath = (() => { const r = parseRels(relsXml).find(x => (x.Type || '').endsWith('/styles')); return r ? norm('word/' + r.Target) : null; })();
      const srcStyles = srcStylesPath ? await rd(zip, srcStylesPath) : null;
      if(srcStyles && stylesXml){
        const have = new Set([...stylesXml.matchAll(/<w:style\b[^>]*w:styleId="([^"]+)"/g)].map(m => m[1]));
        const add = [...srcStyles.matchAll(/<w:style\b[\s\S]*?<\/w:style>/g)].map(m => m[0]).filter(st => { const id = (st.match(/w:styleId="([^"]+)"/) || [])[1]; return id && !have.has(id); });
        if(add.length) stylesXml = stylesXml.replace('</w:styles>', () => mapNums(add.join('')) + '</w:styles>');
      }
      // footnotes, endnotes, comments: this file's own, under new ids
      for(const [kind, tag, refRe] of [
        ['footnotes', 'footnote', /(<w:footnoteReference\b[^>]*w:id=")(\d+)"/g],
        ['endnotes', 'endnote', /(<w:endnoteReference\b[^>]*w:id=")(\d+)"/g],
        ['comments', 'comment', /(<w:comment(?:RangeStart|RangeEnd|Reference)\b[^>]*w:id=")(\d+)"/g],
      ]){
        const r = parseRels(relsXml).find(x => (x.Type || '').endsWith('/' + kind));
        const srcPath = r ? norm('word/' + r.Target) : null;
        const srcXml = srcPath ? await rd(zip, srcPath) : null;
        if(!srcXml) continue;
        const target = notes[kind];
        // pictures/links inside the notes: copied and re-pointed
        const srcNoteRels = await rd(zip, relsPathOf(srcPath));
        const noteRidMap = {};
        let targetRelsPath = null, targetRels = null;
        if(!target.xml){
          target.path = 'word/' + (kind === 'comments' ? 'comments.xml' : kind + '.xml');
          let wrapper = srcXml.replace(new RegExp('<w:' + tag + '\\b(?![^>]*w:type=")[\\s\\S]*?</w:' + tag + '>', 'g'), '');
          target.xml = wrapper;
          addDocRel(r.Type, baseName(target.path), false);
          await ensureContentType(zip, srcPath, target.path);
        }
        targetRelsPath = relsPathOf(target.path);
        targetRels = (await rd(outZip, targetRelsPath)) || '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"></Relationships>';
        let maxNoteRid = maxAttr(targetRels, /Id="rId(\d+)"/g);
        for(const nr of parseRels(srcNoteRels)){
          maxNoteRid++;
          const id = 'rId' + maxNoteRid;
          if(nr.TargetMode === 'External'){
            targetRels = targetRels.replace('</Relationships>', () => '<Relationship Id="' + id + '" Type="' + nr.Type + '" Target="' + nr.Target + '" TargetMode="External"/></Relationships>');
          }else{
            const np = await copyPart(zip, z, norm(dirOf(srcPath) + '/' + nr.Target));
            if(!np) continue;
            targetRels = targetRels.replace('</Relationships>', () => '<Relationship Id="' + id + '" Type="' + nr.Type + '" Target="' + relTo(dirOf(target.path), np) + '"/></Relationships>');
          }
          noteRidMap[nr.Id] = id;
        }
        outZip.file(targetRelsPath, targetRels);
        let next = maxAttr(target.xml, new RegExp('<w:' + tag + '\\b[^>]*w:id="(\\d+)"', 'g'));
        const idMap = {};
        const items = [...srcXml.matchAll(new RegExp('<w:' + tag + '\\b[^>]*>[\\s\\S]*?</w:' + tag + '>', 'g'))].map(m => m[0])
          .filter(x => !/w:type="(separator|continuationSeparator|continuationNotice)"/.test(x.slice(0, x.indexOf('>'))))
          .map(x => x.replace(new RegExp('(<w:' + tag + '\\b[^>]*w:id=")(\\d+)"'), (m, a, id) => { idMap[id] = ++next; return a + next + '"'; })
                     .replace(/(\br:[A-Za-z]+=")(rId\d+)"/g, (m, a, id) => noteRidMap[id] ? a + noteRidMap[id] + '"' : m)
                     .replace(/\sw14:(?:paraId|textId)="[0-9A-Fa-f]+"/g, ''));
        target.xml = target.xml.replace(new RegExp('</w:' + kind + '>'), () => items.join('') + '</w:' + kind + '>');
        bodyContent = bodyContent.replace(refRe, (m, a, id) => idMap[id] ? a + idMap[id] + '"' : m);
      }
    }
    parts.push({ bodyContent, sectPr });
  }

  let mergedBody = '';
  parts.forEach((part,i)=>{
    mergedBody += part.bodyContent;
    if(i < parts.length-1) mergedBody += `<w:p><w:pPr>${part.sectPr}</w:pPr></w:p>`;
  });
  mergedBody += parts[parts.length-1].sectPr;

  const origDocXml = await base.file('word/document.xml').async('string');
  const bodyOpenIdx = origDocXml.indexOf('<w:body>') + '<w:body>'.length;
  const mergedDocXml = origDocXml.slice(0, bodyOpenIdx) + mergedBody + '</w:body></w:document>';
  outZip.file('word/document.xml', mergedDocXml);
  outZip.file(DOC_REL, baseRelsXml);
  outZip.file('[Content_Types].xml', ctXml);
  if(stylesXml && relTarget('styles')) outZip.file(relTarget('styles'), stylesXml);
  if(numberingXml && numberingPath) outZip.file(numberingPath, numberingXml);
  for(const kind of ['footnotes', 'endnotes', 'comments']) if(notes[kind].xml && notes[kind].path) outZip.file(notes[kind].path, notes[kind].xml);

  return outZip.generateAsync({type:'blob', compression:'DEFLATE', compressionOptions:{level:6}});
}

/* Merges multiple PowerPoint files (.pptx) into one file, keeping every
   slide from every file.
   v47: slides from the 2nd, 3rd ... file keep their OWN look (slide
   master, layout and theme are copied along, like PowerPoint's "keep
   source formatting"), their charts, pictures, embedded files and speaker
   notes. Before v47 they were given the first file's master, their notes
   showed the first file's notes, and a chart pointed at a part that
   didn't exist in the result (PowerPoint then offers to "repair" it). */
/* (v89) A presentation without slides has no slide list; the slides of the
   other files were then copied but never listed (they did not show).
   The list goes right before the slide size, as the file format orders it. */
function pcWithSlideList(xml){
  if(/<\/p:sldIdLst>|<p:sldIdLst\s*\/>/.test(xml)) return xml.replace(/<p:sldIdLst\s*\/>/, '<p:sldIdLst></p:sldIdLst>');
  if(/<p:sldSz\b/.test(xml)) return xml.replace(/<p:sldSz\b/, '<p:sldIdLst></p:sldIdLst><p:sldSz');
  const after = ['</p:handoutMasterIdLst>', '</p:notesMasterIdLst>', '</p:sldMasterIdLst>'].find(t => xml.includes(t));
  return after ? xml.replace(after, after + '<p:sldIdLst></p:sldIdLst>') : xml.replace(/(<p:presentation\b[^>]*>)/, '$1<p:sldIdLst></p:sldIdLst>');
}
async function mergePptxFiles(files){
  const buffers = await Promise.all(files.map(f=>f.arrayBuffer()));
  const zips = await pcOpenOfficeZips(buffers); // (v90) refuses a zip bomb before anything is unpacked
  const base = zips[0];
  const outZip = new JSZip();
  for(const [path, file] of Object.entries(base.files)){
    if(file.dir) continue;
    outZip.file(path, await file.async('uint8array'));
  }
  const rd = pcReadZipText;
  const esc = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const dirOf = p => p.includes('/') ? p.slice(0, p.lastIndexOf('/')) : '';
  const baseName = p => p.slice(p.lastIndexOf('/') + 1);
  const norm = p => { const out = []; p.replace(/^\//, '').split('/').forEach(seg => { if(seg === '..') out.pop(); else if(seg && seg !== '.') out.push(seg); }); return out.join('/'); };
  const resolve = (fromPart, target) => target.startsWith('/') ? norm(target) : norm(dirOf(fromPart) + '/' + target);
  const relTo = (fromDir, target) => {
    const a = fromDir ? fromDir.split('/') : [], b = target.split('/');
    let i = 0; while(i < a.length && i < b.length - 1 && a[i] === b[i]) i++;
    return '../'.repeat(a.length - i) + b.slice(i).join('/');
  };
  const parseRels = xml => [...(xml || '').matchAll(/<Relationship\b[^>]*\/>/g)].map(m => {
    const t = m[0], at = n => { const r = t.match(new RegExp('\\b' + n + '="([^"]*)"')); return r ? r[1] : null; };
    return { raw: t, Id: at('Id'), Type: at('Type') || '', Target: at('Target'), TargetMode: at('TargetMode') };
  });
  const relsPathOf = part => (dirOf(part) ? dirOf(part) + '/' : '') + '_rels/' + baseName(part) + '.rels';
  const typeOf = r => r.Type.split('/').pop();

  let presentationXml = await rd(base, 'ppt/presentation.xml');
  let presRelsXml = await rd(base, 'ppt/_rels/presentation.xml.rels');
  let ctXml = await rd(base, '[Content_Types].xml');
  let maxPresRid = 0;
  [...presRelsXml.matchAll(/Id="rId(\d+)"/g)].forEach(m => maxPresRid = Math.max(maxPresRid, parseInt(m[1],10)));
  const addPresRel = (type, target) => { maxPresRid++; const id = 'rId' + maxPresRid; presRelsXml = presRelsXml.replace('</Relationships>', () => '<Relationship Id="' + id + '" Type="' + type + '" Target="' + target + '"/></Relationships>'); return id; };
  let maxSlideId = 255;
  [...presentationXml.matchAll(/<p:sldId\b[^>]*\bid="(\d+)"/g)].forEach(m => maxSlideId = Math.max(maxSlideId, parseInt(m[1],10)));
  // master and layout ids share one number space, starting at 2147483648
  let maxMasterId = 2147483647;
  const bumpIds = xml => [...(xml || '').matchAll(/<p:(?:sldMasterId|sldLayoutId)\b[^>]*\bid="(\d+)"/g)].forEach(m => maxMasterId = Math.max(maxMasterId, parseInt(m[1],10)));
  bumpIds(presentationXml);
  for(const p of Object.keys(base.files).filter(p => /^ppt\/slideMasters\/slideMaster\d+\.xml$/.test(p))) bumpIds(await rd(base, p));
  const baseNotesMaster = (() => { const r = parseRels(presRelsXml).find(x => typeOf(x) === 'notesMaster'); return r ? resolve('ppt/presentation.xml', r.Target) : null; })();

  const ensureContentType = async (srcZip, srcPath, newPath) => {
    const srcCt = await rd(srcZip, '[Content_Types].xml') || '';
    const ov = srcCt.match(new RegExp('<Override\\b[^>]*PartName="/' + esc(srcPath) + '"[^>]*ContentType="([^"]+)"')) ||
               srcCt.match(new RegExp('<Override\\b[^>]*ContentType="([^"]+)"[^>]*PartName="/' + esc(srcPath) + '"'));
    if(ov){
      if(!ctXml.includes('PartName="/' + newPath + '"')) ctXml = ctXml.replace('</Types>', () => '<Override PartName="/' + newPath + '" ContentType="' + ov[1] + '"/></Types>');
      return;
    }
    const ext = (newPath.split('.').pop() || '').toLowerCase();
    if(new RegExp('<Default\\b[^>]*Extension="' + esc(ext) + '"', 'i').test(ctXml)) return;
    const df = srcCt.match(new RegExp('<Default\\b[^>]*Extension="' + esc(ext) + '"[^>]*ContentType="([^"]+)"', 'i'));
    if(df) ctXml = ctXml.replace('</Types>', () => '<Default Extension="' + ext + '" ContentType="' + df[1] + '"/></Types>');
  };
  const freeName = (dir, name) => {
    const m = name.match(/^(.*?)(\d*)(\.[^.]+)$/);
    let stem = m ? m[1] : name, ext = m ? m[3] : '';
    let n = 1, p = dir + '/' + name;
    while(outZip.file(p)){ n++; p = dir + '/' + stem + 'm' + n + ext; }
    return p;
  };
  const copied = new Map();
  const newMasters = [];
  let slideMap = null; // per source file: old slide path -> new slide path
  let curNewSlide = null;
  // Copies a part and what it refers to; special cases for slide masters
  // (registered in the presentation), notes (pointed at the right slide and
  // the file's notes master) and links to other slides.
  const copyPart = async (srcZip, z, srcPath) => {
    const key = z + ':' + srcPath;
    if(copied.has(key)) return copied.get(key);
    const f = srcZip.file(srcPath);
    if(!f) return null;
    const newPath = freeName(dirOf(srcPath), baseName(srcPath));
    copied.set(key, newPath);
    outZip.file(newPath, await f.async('uint8array'));
    await ensureContentType(srcZip, srcPath, newPath);
    const isMaster = /\/slideMasters\//.test(srcPath);
    if(isMaster) newMasters.push(newPath);
    const relsXml = await rd(srcZip, relsPathOf(srcPath));
    if(relsXml){
      let out = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">';
      for(const r of parseRels(relsXml)){
        if(r.TargetMode === 'External' || !r.Target){ out += r.raw; continue; }
        const t = typeOf(r), target = resolve(srcPath, r.Target);
        let np = null;
        if(t === 'slide'){
          np = (slideMap && slideMap[target]) || (/notesSlides\//.test(srcPath) ? curNewSlide : null);
          if(!np) continue;
        }else if(t === 'notesMaster'){
          np = baseNotesMaster;
          if(!np) continue;
        }else{
          np = await copyPart(srcZip, z, target);
          if(!np) continue;
        }
        out += r.raw.replace(/Target="[^"]*"/, () => 'Target="' + relTo(dirOf(newPath), np) + '"');
      }
      outZip.file(relsPathOf(newPath), out + '</Relationships>');
    }
    if(isMaster){
      let mx = await rd(outZip, newPath);
      mx = mx.replace(/(<p:sldLayoutId\b[^>]*\bid=")(\d+)"/g, (m, a) => a + (++maxMasterId) + '"');
      outZip.file(newPath, mx);
    }
    return newPath;
  };

  for(let z=1; z<zips.length; z++){
    pcCheckCancel();
    const zip = zips[z];
    const srcPres = await rd(zip, 'ppt/presentation.xml') || '';
    const srcPresRels = await rd(zip, 'ppt/_rels/presentation.xml.rels') || '';
    const relById = {};
    parseRels(srcPresRels).forEach(r => relById[r.Id] = r);
    // slides in presentation order
    const order = [...srcPres.matchAll(/<p:sldId\b[^>]*r:id="([^"]+)"/g)].map(m => relById[m[1]]).filter(Boolean).map(r => resolve('ppt/presentation.xml', r.Target));
    slideMap = {};
    let maxSlideNum = 0;
    Object.keys(outZip.files).forEach(p => { const m = p.match(/^ppt\/slides\/slide(\d+)\.xml$/); if(m) maxSlideNum = Math.max(maxSlideNum, parseInt(m[1],10)); });
    order.forEach(sp => { slideMap[sp] = 'ppt/slides/slide' + (++maxSlideNum) + '.xml'; });
    for(const sp of order){
      const newSlide = slideMap[sp];
      curNewSlide = newSlide;
      copied.set(z + ':' + sp, newSlide);
      const data = await zip.file(sp).async('uint8array');
      outZip.file(newSlide, data);
      if(!ctXml.includes('PartName="/' + newSlide + '"')) ctXml = ctXml.replace('</Types>', () => '<Override PartName="/' + newSlide + '" ContentType="application/vnd.openxmlformats-officedocument.presentationml.slide+xml"/></Types>');
      const relsXml = await rd(zip, relsPathOf(sp));
      if(relsXml){
        let out = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">';
        for(const r of parseRels(relsXml)){
          if(r.TargetMode === 'External' || !r.Target){ out += r.raw; continue; }
          const t = typeOf(r), target = resolve(sp, r.Target);
          let np = null;
          if(t === 'slide') np = slideMap[target] || null;
          else if(t === 'notesSlide'){ np = baseNotesMaster ? await copyPart(zip, z, target) : null; }
          else np = await copyPart(zip, z, target);
          if(!np) continue;
          out += r.raw.replace(/Target="[^"]*"/, () => 'Target="' + relTo('ppt/slides', np) + '"');
        }
        outZip.file(relsPathOf(newSlide), out + '</Relationships>');
      }
      const rid = addPresRel('http://schemas.openxmlformats.org/officeDocument/2006/relationships/slide', 'slides/' + baseName(newSlide));
      maxSlideId++;
      presentationXml = pcWithSlideList(presentationXml).replace('</p:sldIdLst>', () => `<p:sldId id="${maxSlideId}" r:id="${rid}"/></p:sldIdLst>`);
    }
    curNewSlide = null;
  }
  // register the copied slide masters
  for(const mp of newMasters){
    const rid = addPresRel('http://schemas.openxmlformats.org/officeDocument/2006/relationships/slideMaster', relTo('ppt', mp));
    const entry = `<p:sldMasterId id="${++maxMasterId}" r:id="${rid}"/>`;
    presentationXml = /<\/p:sldMasterIdLst>/.test(presentationXml)
      ? presentationXml.replace('</p:sldMasterIdLst>', () => entry + '</p:sldMasterIdLst>')
      : presentationXml.replace(/(<p:presentation\b[^>]*>)/, m => m + '<p:sldMasterIdLst>' + entry + '</p:sldMasterIdLst>');
  }

  outZip.file('ppt/presentation.xml', presentationXml);
  outZip.file('ppt/_rels/presentation.xml.rels', presRelsXml);
  outZip.file('[Content_Types].xml', ctXml);

  return outZip.generateAsync({type:'blob', compression:'DEFLATE', compressionOptions:{level:6}});
}

/* Controleert vooraf welke Word/PowerPoint-bestanden effectief geopend
   kunnen worden als zip-pakket, zodat één beschadigd bestand niet de
   volledige samenvoeging laat mislukken — net zoals bij PDF's al gebeurde,
   waar een kapot bestand gewoon overgeslagen wordt in plaats van alles te
   blokkeren. */
/* (v55) A zip that isn't a Word/PowerPoint document (an .xlsx or .pptx
   renamed to .docx) is skipped with a reason; it used to pass and then
   stop the merge with a raw "Cannot read properties of null" message. */
const PC_OFFICE_MAIN_PART = { docx: ['word/document.xml', 'Word', 'errInvalidWord'], pptx: ['ppt/presentation.xml', 'PowerPoint', 'errInvalidPpt'] }; // (v140) + the message for a broken file of that kind
/* (v90) The merge unpacks every file into one result, so the unpacked sizes
   together must stay within this device's limit (pcOpenOfficeZip). */
async function pcOpenOfficeZips(buffers){
  const zips = [];
  let left = pcOfficeUnzipLimit();
  for(const buf of buffers){
    const { zip, unzipped } = await pcOpenOfficeZip(buf, left);
    left -= unzipped;
    zips.push(zip);
  }
  return zips;
}
async function splitValidOfficeFiles(files){
  const valid = [];
  const skipped = [];
  let left = pcOfficeUnzipLimit(); // (v90) a file that would not fit any more is skipped with the reason
  for(const f of files){
    const [mainPart, label, invalidKey] = PC_OFFICE_MAIN_PART[getFileExt(f.name)] || [null, 'Office', 'errInvalidPdf'];
    try{
      const buf = await f.arrayBuffer();
      if(buf.byteLength === 0) throw Object.assign(new Error('empty file'), { name: 'InvalidOfficeFile' });
      const { zip, unzipped } = await pcOpenOfficeZip(buf, left);
      if(mainPart && !zip.file(mainPart)) throw Object.assign(new Error(pcT('officeWrongKind', label)), { userFacing: true });
      left -= unzipped;
      valid.push(f);
    }catch(e){
      pcLogUnexpected(e); // (v90) a real fault is not just "couldn't be opened"
      const why = e && e.userFacing ? e.message : pcReadFailureMessage(e); // (v89) say why when we know it
      skipped.push(f.name + ' (' + (why || pcT(invalidKey)) + ')'); // (v111) never a bare name; (v140) a broken .docx is not "a valid PDF?"
    }
  }
  return { valid, skipped };
}

pcOnPanel('merge', function(){ // (v140) only once its panel is in the page (live, or made from its <template>); not re-indented, to keep the diff small
let mergeFiles = [];
const dzMerge = document.getElementById('dropzone-merge');
const inputMerge = document.getElementById('input-merge');
const listMerge = document.getElementById('filelist-merge');
const btnMerge = document.getElementById('btn-merge');
const statusMerge = document.getElementById('status-merge');
const statusMergeText = document.getElementById('status-merge-text');
const progressMerge = document.getElementById('progress-merge');
const resultMerge = document.getElementById('result-merge');
const resultMergeInfo = document.getElementById('result-merge-info');
const downloadMerge = document.getElementById('download-merge');

function renderMergeList(){
  // Order matters for merging: up/down buttons and drag and drop (v36).
  if(window.PCThumbs) window.PCThumbs.forgetFirsts(mergeFiles); // (v123) previews of removed files are freed
  if(pcThumbObserver && listMerge) listMerge.querySelectorAll('.fthumb').forEach(b => pcThumbObserver.unobserve(b)); // the old rows go
  renderFileList(listMerge, mergeFiles, isOfficeOrPdfFile, true, true);
  const exts = new Set(mergeFiles.map(pcFileKind));
  const mixed = exts.size > 1;
  const mixedEl = document.getElementById('merge-mixed-warning');
  if(mixed && mixedEl.style.display !== 'block') pcAnnounce(mixedEl.textContent); // (v111) why Merge stays disabled
  mixedEl.style.display = mixed ? 'block' : 'none';
  updateLargeFileWarning(document.getElementById('merge-large-warning'), mergeFiles);
  btnMerge.disabled = mergeFiles.length < 2 || mixed;
  pcHideStaleResult(resultMerge);
}

setupDropzone(dzMerge, inputMerge, files=>{
  fileHub.add(files, isOfficeOrPdfFile);
  inputMerge.value = '';
}, isOfficeOrPdfFile);
fileHub.register(isOfficeOrPdfFile, list=>{ mergeFiles = list; renderMergeList(); });

btnMerge.addEventListener('click', async ()=>{
  if(isProcessing) return; // (v55) one tool at a time: they share the cancel flag and page caches
  if(mergeFiles.length < 2) return;
  pcSetProcessing(true);
  btnMerge.disabled = true;
  statusMerge.classList.add('show','working');
  statusMerge.classList.remove('done','error');
  resultMerge.classList.remove('show');
  statusMergeText.textContent = pcT('stMerging');
  progressMerge.style.width='0%';

  const ext = pcFileKind(mergeFiles[0]);

  try{
    pcCheckPhoneMemory('merge', mergeFiles); // (v94) refused up front on a phone instead of a closed tab
    await pcLoadPdfLibs(); // (v56) pdf-lib/pdf.js/JSZip are loaded on demand
    if(ext === 'docx'){
      const { valid, skipped } = await splitValidOfficeFiles(mergeFiles);
      if(valid.length < 2) throw pcUserError(skipped.length ? pcT('errMergeOpen', skipped.join(', ')) : pcT('errMergeOpenAll'));
      const blob = await mergeDocxFiles(valid);
      setDownloadHref(downloadMerge, blob);
      downloadMerge.download = pcMergedName(valid[0].name, 'docx');
      pcForgetNextSteps('merge');
      progressMerge.style.width = '100%';
      statusMerge.classList.remove('working');
      statusMerge.classList.add('done');
      statusMergeText.textContent = skipped.length ? pcT('stDoneSkippedOpen', skipped.join(', ')) : pcT('stDone');
      resultMergeInfo.textContent = pcT('infoMerged', valid.length, fmtSize(blob.size));
      pcShowNote(resultMergeInfo, '');
      resultMerge.classList.add('show');
    }else if(ext === 'pptx'){
      const { valid, skipped } = await splitValidOfficeFiles(mergeFiles);
      if(valid.length < 2) throw pcUserError(skipped.length ? pcT('errMergeOpen', skipped.join(', ')) : pcT('errMergeOpenAll'));
      const blob = await mergePptxFiles(valid);
      setDownloadHref(downloadMerge, blob);
      downloadMerge.download = pcMergedName(valid[0].name, 'pptx');
      pcForgetNextSteps('merge');
      progressMerge.style.width = '100%';
      statusMerge.classList.remove('working');
      statusMerge.classList.add('done');
      statusMergeText.textContent = skipped.length ? pcT('stDoneSkippedOpen', skipped.join(', ')) : pcT('stDone');
      resultMergeInfo.textContent = pcT('infoMerged', valid.length, fmtSize(blob.size));
      pcShowNote(resultMergeInfo, '');
      resultMerge.classList.add('show');
    }else{
    /* v47: pages are assembled by pcAssemble(), which keeps bookmarks, form
       fields, internal links, layers and attachments; files with only an
       owner password are decrypted first. (v113) In the worker when the
       browser has one (pcMergePdfFiles, pc-pdfcore.js), else on the page. */
    const worker = pcWorkerSession();
    let r;
    try{ r = await worker.run('mergePdf', mergeFiles, {}, v => { progressMerge.style.width = Math.round(v * 100) + '%'; }); }
    finally{ worker.close(); }
    pcCheckCancel();
    progressMerge.style.width = '100%';
    const blob = new Blob([r.bytes], {type:'application/pdf'});
    setDownloadHref(downloadMerge, blob);
    downloadMerge.download = pcMergedName(r.firstName, 'pdf');
    pcOfferNextSteps(downloadMerge, blob, downloadMerge.download); // (v62) "What next?"

    statusMerge.classList.remove('working');
    statusMerge.classList.add('done');
    statusMergeText.textContent = r.skipped.length
      ? pcT('stDoneSkippedOpen', r.skipped.join(', '))
      : pcT('stDone');
    const formNote = pcAssembleNotes({ __pcFormInfo: r.formInfo }, name => name);
    // (v96) a merged copy breaks the certificate signatures of its files (as Split, Rotate, ... say)
    pcShowNote(resultMergeInfo, [r.decrypted.length ? pcT('ownerNote', r.decrypted.join(', ')) : '',
      r.certNames.length ? pcT('certBroke', r.certNames.join(', ')) : '', formNote].filter(Boolean).join(' '));
    resultMergeInfo.textContent = r.pages === 1 ? pcT('infoPages1', fmtSize(r.bytes.length)) : pcT('infoPagesN', r.pages, fmtSize(r.bytes.length));
    resultMerge.classList.add('show');
    }
  }catch(err){
    statusMerge.classList.remove('working');
    statusMerge.classList.add('error');
    // (v55) an unexpected fault (e.g. "Cannot read properties of null")
    // gets the normal translated message instead of its raw English text
    statusMergeText.textContent = friendlyPdfError(err, ext === 'docx' ? 'Word document' : ext === 'pptx' ? 'PowerPoint file' : 'PDF');
    pcLogUnexpected(err);
  }finally{
    pcSetProcessing(false);
    btnMerge.disabled = mergeFiles.length < 2;
  }
});
}); // merge panel

/* ---------- COMPRESS / WORD / POWERPOINT file lists ----------
   Since v36 every tool gets its files from the shared list above
   (fileHub): Compress takes PDF, Word and PowerPoint files, Word and
   PowerPoint conversion only PDFs. (v140) Compress has its own list in pcSetupTool. */
const multiFilePanels = {};

function registerMultiFilePanel(name, {list, btn, status, result}, accept){
  const p = multiFilePanels[name] = {list, btn, status, result, files: [], accept: accept || isPdfFile};
  fileHub.register(p.accept, files=>{
    p.files = files;
    fillMultiFilePanel(name, files);
  });
}

function fillMultiFilePanel(name, files){
  const p = multiFilePanels[name];
  if(!p) return;
  renderFileList(p.list, files, p.accept, false);
  p.btn.disabled = files.length === 0;
  updateLargeFileWarning(document.getElementById(name+'-large-warning'), files);
  if(p.status && !pcKeepsResult(p.result)) p.status.classList.remove('show','done','error','working');
  pcHideStaleResult(p.result);
}

/* Newly chosen/dropped files are added to the list, not replacing it;
   the exact same file isn't added twice. */
function addSharedFiles(newFiles, accept){
  fileHub.add(newFiles, accept);
}

/* ---------- COMPRESS ---------- */
let selectedQuality = 0.6;

// (v56) pdf.js's worker is set in pcSetupPdfJs(), once pdf.js has been loaded (pcLoadPdfLibs)

/* Packs multiple result files into one zip for download; with exactly
   one file, that single file is offered directly (no unnecessary zip
   for a single file). */
/* (v55) Two input files with the same name (e.g. two "scan.pdf" from
   different folders) give results with the same name; JSZip would silently
   keep only the last one. "scan-rotated.pdf" becomes "scan-rotated (2).pdf". */
/* (v59) A name inside a zip must also be a safe file name when the zip is
   unpacked: no folders ("../" would let an entry land outside the target
   folder), none of the characters Windows refuses (<>:"|?* and control
   characters), no trailing dot or space, no reserved device name (CON,
   NUL, COM1...) and not so long that Windows can't create it. The names
   come from the visitor's own files, so this is about files that won't
   unpack, not an attack; the download of a single file is sanitised by the
   browser itself. */
const PC_ZIP_NAME_MAX = 150; // characters before the extension
const PC_WIN_RESERVED = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])$/i;
function pcSafeZipName(name){
  const n = String(name).replace(/[\\/]/g, '_').replace(/[<>:"|?*\u0000-\u001f\u007f\u2028\u2029]/g, '_');
  const m = n.match(/^([\s\S]*?)(\.[A-Za-z0-9]{1,5})?$/);
  let base = m[1], ext = m[2] || '';
  base = base.replace(/^[.\s]+|[.\s]+$/g, '');
  if(!base) base = 'file';
  if(PC_WIN_RESERVED.test(base.split('.')[0])) base = '_' + base; // "con.tar" too
  if(base.length > PC_ZIP_NAME_MAX){
    // cut on whole characters (an emoji is two UTF-16 units) within the limit
    let cut = '';
    for(const ch of base){ if(cut.length + ch.length > PC_ZIP_NAME_MAX) break; cut += ch; }
    base = cut.replace(/[.\s]+$/, '') || 'file';
  }
  return base + ext;
}
/* (v90) "é" can be one character (NFC, Windows) or e + accent (NFD, a Mac):
   the same name on macOS, which unpacks one file over the other. Names are
   compared, and written, in NFC. */
function pcUniqueFilenames(names){
  const seen = new Set();
  const key = n => n.toLowerCase();
  return names.map(raw => {
    const original = raw.normalize('NFC');
    let name = original;
    for(let n = 2; seen.has(key(name)); n++){
      name = original.replace(/(\.[^.]+)?$/, ext => ' (' + n + ')' + (ext || ''));
    }
    seen.add(key(name));
    return name;
  });
}
const PC_ZIP_WORKER_MIN = 20; // (v113) from this many files the zip is made in the worker
async function offerResults(downloadEl, results, zipBaseName, session){
  pcCheckCancel();
  if(pcPdfJsMissed) throw pcUserError(pcT('pdfjsDataMissing')); // (v157) text would be missing
  if(results.length === 1){
    setDownloadHref(downloadEl, results[0].blob);
    downloadEl.download = results[0].filename;
    pcOfferNextSteps(downloadEl, results[0].blob, results[0].filename); // (v62) "What next?"
    return;
  }
  pcForgetNextSteps(downloadEl.id.replace(/^download-/, '')); // (v62) several files: no hand-over
  const names = pcUniqueFilenames(results.map(r => pcSafeZipName(r.filename)));
  // (v113) zipped in the worker when there is one, so the page doesn't freeze on hundreds of parts
  const list = names.map((name, i) => ({ name, blob: results[i].blob }));
  let zipped;
  if(list.length < PC_ZIP_WORKER_MIN) zipped = await pcZipFiles(list); // a few files: quicker than starting a worker
  else if(session) zipped = await session.run('zipFiles', list, {}); // (v113) the tool's own worker, already started
  else{
    const worker = pcWorkerSession();
    try{ zipped = await worker.run('zipFiles', list, {}); }
    finally{ worker.close(); }
  }
  pcCheckCancel(); // "Cancel" pressed while the zip was being built
  const zipBlob = new Blob([zipped.bytes], { type: 'application/zip' });
  setDownloadHref(downloadEl, zipBlob);
  downloadEl.download = zipBaseName + '.zip';
  pcOfferShare(downloadEl, results); // (v73, q16) on phones: the files themselves via the share menu
}

/* (v140) pcSetupTool: the wiring every per-file tool shares (dropzone, file
   list, Start button, status box, progress, result with offerResults and
   "What next?", field marks). Split, Rotate, Numbers, Delete (tools-extra.js)
   and Compress use it, the tools in tools-more.js through their setupTool().
   See src/README.md "(v140) setupTool". opts: accept, working() (the status text; a function, as Compress
   is set up before PC_MSG exists),
   zipName, run(list, option, ctx) -> { results, skipped, info, note, fieldHit },
   reason(err) (the message for a failed run), and optional optionsId,
   fieldId, minFiles, reorder, onFiles. */
function pcToolEls(name){
  const $ = id => document.getElementById(id);
  return {
    dz: $('dropzone-' + name), input: $('input-' + name), list: $('filelist-' + name),
    btn: $('btn-' + name), status: $('status-' + name), statusText: $('status-' + name + '-text'),
    progress: $('progress-' + name), result: $('result-' + name), resultInfo: $('result-' + name + '-info'),
    download: $('download-' + name), warning: $(name + '-large-warning')
  };
}
function pcToolOptions(optionsId, state){
  if(!optionsId) return;
  const optEls = document.querySelectorAll('#' + optionsId + ' .quality-opt');
  optEls.forEach(o => {
    if(o.classList.contains('selected')) state.option = o.dataset.value;
    o.addEventListener('click', () => {
      optEls.forEach(x => x.classList.remove('selected'));
      o.classList.add('selected');
      state.option = o.dataset.value;
    });
  });
}
/* (v55) a page list to correct is marked on the field itself; (v60) err.fieldId picks one field when a tool has several */
function pcToolMarkFields(opts, msgEl, err){
  [].concat(opts.fieldId || []).forEach(id => pcMarkField(document.getElementById(id), msgEl,
    !!(err && err.field) && (!err.fieldId || [].concat(err.fieldId).indexOf(id) >= 0)));
}
function pcToolCtx(el, worker){
  return {
    worker, bar: el.progress,
    setStatus: s => { el.statusText.textContent = s; },
    // (v90) a warning found while working (e.g. the expected memory use), shown above the files
    warn: msg => {
      if(!el.warning) return;
      el.warning.textContent = msg;
      el.warning.style.display = 'block';
      pcAnnounce(msg);
    },
    setProgress: frac => { el.progress.style.width = Math.round(Math.max(0, Math.min(1, frac)) * 100) + '%'; }
  };
}
function pcToolStart(el, opts, files){
  pcSetProcessing(true);
  el.btn.disabled = true;
  el.status.classList.add('show', 'working');
  el.status.classList.remove('done', 'error');
  el.result.classList.remove('show');
  el.progress.style.width = '0%';
  el.statusText.textContent = opts.working();
  updateLargeFileWarning(el.warning, files); // (v90) drops a memory warning left by the previous run
}
async function pcToolRun(name, el, opts, files){
  const worker = pcWorkerSession(); // (v113) one worker for all files of this run (started only when a job needs it)
  try{
    pcCheckPhoneMemory(name, files); // (v94)
    await pcLoadPdfLibs(); // (v56) pdf-lib/pdf.js/JSZip are loaded on demand
    const list = opts.reorder ? files.slice() : fileHub.unique(files);
    const out = await opts.run(list, opts.state.option, pcToolCtx(el, worker));
    // (v56) same-named results are numbered by offerResults (pcUniqueFilenames)
    el.statusText.textContent = out.results.length > 1 ? pcT('stZip', out.results.length) : pcT('stLast');
    await offerResults(el.download, out.results, pcZipName(list, opts.zipName), worker); // (v113) its own worker zips too
    el.progress.style.width = '100%';
    el.status.classList.remove('working');
    el.status.classList.add('done');
    el.statusText.textContent = out.skipped && out.skipped.length ? pcT('stDoneSkipped', out.skipped.join(', ')) : pcT('stDone');
    el.resultInfo.textContent = out.info;
    pcShowNote(el.resultInfo, out.note || '');
    el.result.classList.add('show');
    pcToolMarkFields(opts, el.statusText, { field: !!out.fieldHit }); // a file skipped for its page list still marks the field
  }catch(err){
    el.status.classList.remove('working');
    el.status.classList.add('error');
    el.statusText.textContent = opts.reason(err);
    pcLogUnexpected(err); // (v89) only real faults: not a password, a cancel or a file that is gone
    pcToolMarkFields(opts, el.statusText, err);
  }finally{
    worker.close();
    pcSetProcessing(false);
    el.btn.disabled = !opts.ready();
  }
}
function pcSetupTool(name, opts){
  const el = pcToolEls(name);
  if(!el.dz || !el.input || !el.btn) return null;
  const state = { files: [], option: null };
  const minFiles = opts.minFiles || 1;
  const ready = () => state.files.length >= minFiles;
  pcToolOptions(opts.optionsId, state);
  function render(){
    // (v36) the shared file list: the order can be changed where it matters
    renderFileList(el.list, state.files, opts.accept, !!opts.reorder);
    updateLargeFileWarning(el.warning, state.files);
    el.btn.disabled = !ready();
    pcHideStaleResult(el.result); // (v55) keeps a result made while files were added
    if(opts.onFiles) opts.onFiles(state.files); // (v61) e.g. the signature preview
  }
  setupDropzone(el.dz, el.input, files => {
    fileHub.add(files, opts.accept);
    el.input.value = '';
  }, opts.accept);
  fileHub.register(opts.accept, list => { state.files = list; render(); });
  el.btn.addEventListener('click', async () => {
    if(isProcessing) return; // (v55) one tool at a time: they share the cancel flag and page caches
    if(!ready()) return;
    pcToolStart(el, opts, state.files);
    await pcToolRun(name, el, Object.assign({ state, ready }, opts, { run: pcRunWithPickerPassword(opts.run) }), state.files);
  });
  return state;
}
/* (v147) A password typed at a page picker (pc-thumbs.js) is used for the run
   when every file of the run has that same one, as a preview's password is
   (v143, tools-more.js), and forgotten after a run that worked, after Cancel
   and after a wrong password: a protected file nobody typed a password for
   is asked for in the status box, never tried with another file's. */
function pcPickerPassword(list){
  const pws = window.PCThumbs ? list.map(f => window.PCThumbs.password(f)) : [];
  return pws.length && pws.every(p => p && p === pws[0]) ? pws[0] : '';
}
function pcForgetPickerPasswords(list){
  if(window.PCThumbs) list.forEach(f => window.PCThumbs.setPassword(f, ''));
}
function pcRunWithPickerPassword(run){
  return async (list, option, ctx) => {
    const pw = pcHostPassword() ? '' : pcPickerPassword(list);
    if(pw) pcSetTypedPassword(pw);
    let out;
    try{ out = await run(list, option, ctx); }
    catch(e){
      // a check before the work (a page field) keeps it
      if(pcIsCancel(e) || (e && (e.pw || e.name === 'PasswordException'))) pcForgetPickerPasswords(list);
      throw e;
    }
    pcForgetPickerPasswords(list);
    return out;
  };
}

/* v47: images inside the PDF are recompressed (pcCompressPdf, pc-pdfcore.js)
   instead of every page being turned into a picture. Before v47 this made
   every page 1.5x larger, removed the text layer, links, bookmarks and
   forms, and made text-only PDFs up to 175x bigger. The original file is
   handed back unchanged when nothing can be saved.
   (v68) `run` does the work in the background worker (pcWorkerSession). */
/* (v90) "Already well optimized" only when that is true: when the file has
   images this tool could not shrink at all (CMYK, indexed colours, a picture
   the browser can't decode...), it says so instead. */
/* (v117) Several files: the total too ("5 files: 48 MB → 21 MB, 56% smaller"), not only the count. */
function pcCompressTotalText(results){
  const before = results.reduce((n, r) => n + r.before, 0), after = results.reduce((n, r) => n + r.blob.size, 0);
  const pct = before ? Math.round((1 - after / before) * 100) : 0;
  return pct > 0 ? pcT('infoZipCompressedTotal', results.length, fmtSize(before), fmtSize(after), pct) : pcT('infoZipCompressed', results.length);
}
function pcKeptText(r, size){
  return pcT(r.imagesUnsupported ? 'compressImagesUnsupported' : 'compressKept', fmtSize(size));
}
async function compressOnePdf(file, run){
  const r = await run('compressPdf', file, selectedQuality);
  const kept = !r.bytes;
  const reduction = Math.round((1 - (r.size/file.size)) * 100);
  return {
    blob: new Blob([kept ? file : r.bytes], {type:'application/pdf'}),
    filename: baseFileName(file.name) + (kept ? '.pdf' : '-compressed.pdf'),
    // (v157) a repaired copy can be a little larger than the damaged original: then only its size, no "-10% smaller"
    infoText: kept ? pcKeptText(r, r.size) : reduction > 0 ? pcT('compressInfo', fmtSize(r.size), reduction) : fmtSize(r.size),
    decrypted: r.decrypted,
    certSigned: r.certSigned, // (v96) see pcCompressPdf
    kept: kept,
    name: file.name,
    noImages: r.noImages, // (v86) the note under the result says the strength changes nothing
    cmyk: !kept && r.cmyk > 0, // (v119) print colours became screen colours
    repaired: !!r.repaired, // (v157) pcOriginalIntact: the damaged original was not handed back
  };
}

/* A Word or PowerPoint file with its JPEG photos re-encoded
   (pcCompressOfficeFile, pc-pdfcore.js). */
async function compressOfficeFile(file, ext, run){
  const r = await run('compressOffice', file, { quality: selectedQuality, unzipLimit: pcOfficeUnzipLimit() });
  // (v55) never hand back a bigger file (the PDF route already kept the
  // original); the note says why nothing changed
  if(!r.bytes){
    return {
      blob: new Blob([file], { type: file.type || 'application/octet-stream' }),
      filename: file.name, kept: true,
      infoText: pcKeptText(r, file.size),
    };
  }
  const reduction = Math.round((1 - (r.size/file.size)) * 100);
  return {
    blob: new Blob([r.bytes], { type: file.type || 'application/octet-stream' }),
    filename: file.name.replace(/\.(pdf|docx|pptx)$/i, '') + `-compressed.${ext}`, // (v89) "report.docx" became "report.docx-compressed.docx"
    infoText: r.imagesProcessed > 0
      ? pcT('compressInfoImg', fmtSize(r.size), reduction, r.imagesProcessed)
      : pcT('compressInfo', fmtSize(r.size), reduction),
  };
}

async function compressOneFile(file, run){
  const ext = getFileExt(file.name);
  if(ext === 'docx' || ext === 'pptx') return compressOfficeFile(file, ext, run);
  return compressOnePdf(file, run);
}

/* (v140) Compress's loop: one file at a time in the worker, the type of the
   file being worked on kept for the error message (Word/PowerPoint/PDF). */
async function pcCompressAll(list, ctx, typeOf){
  const results = [], skipped = [];
  for(let f=0; f<list.length; f++){
    const file = list[f];
    pcCheckCancel();
    const ext = getFileExt(file.name);
    typeOf.label = ext === 'docx' ? 'Word document' : ext === 'pptx' ? 'PowerPoint file' : 'PDF';
    ctx.setStatus(list.length > 1 ? pcT('stFileOf', f+1, list.length, file.name + '…') : pcT('stCompressing'));
    // (v90) the bar also moves within one file (reported by the job)
    const onFrac = frac => ctx.setProgress((f + frac) / list.length);
    const run = (job, one, opt) => ctx.worker.run(job, one, opt, onFrac);
    try{ results.push(Object.assign(await compressOneFile(file, run), { before: file.size })); } // (v117) for the total
    catch(err){ skipped.push(pcSkipOrThrow(err, file, list.length, typeOf.label)); }
    ctx.setProgress((f+1)/list.length);
  }
  if(!results.length) throw pcAllSkipped('errSkipCompress', skipped);
  return { results, skipped };
}
function pcCompressNote(results){
  const decNames = results.filter(r => r.decrypted && !r.kept).map(r => r.name);
  // (v86) one PDF without any image: Light, Balanced and Strong give the same file
  const noImages = results.length === 1 && results[0].noImages;
  const certNames = results.filter(r => r.certSigned).map(r => r.name); // (v96) as Split, Rotate, ... say it
  const cmykNames = results.filter(r => r.cmyk).map(r => r.name); // (v119)
  const repairedNames = results.filter(r => r.repaired).map(r => r.name); // (v157)
  return [repairedNames.length ? pcT('compressRepaired', repairedNames.join(', ')) : '',
    decNames.length ? pcT('ownerNote', decNames.join(', ')) : '', certNames.length ? pcT('certBroke', certNames.join(', ')) : '',
    noImages ? pcT('compressNoImages') : '', cmykNames.length ? pcT('compressCmykNote', cmykNames.join(', ')) : ''].filter(Boolean).join(' ');
}

pcOnPanel('compress', function(){ // (v140) only once its panel is in the page (live, or made from its <template>)
  document.querySelectorAll('#quality-options .quality-opt').forEach(opt=>{
    opt.addEventListener('click', ()=>{
      document.querySelectorAll('#quality-options .quality-opt').forEach(o=>o.classList.remove('selected'));
      opt.classList.add('selected');
      selectedQuality = parseFloat(opt.dataset.q);
    });
  });
  const status = document.getElementById('status-compress');
  const result = document.getElementById('result-compress');
  const typeOf = { label: 'PDF' }; // the file type of the last file tried, for friendlyPdfError
  pcSetupTool('compress', {
    accept: isOfficeOrPdfFile, working: () => pcT('stCompressing'), zipName: 'compressed-files',
    // a changed file list clears the old status, as for Word and PowerPoint (fillMultiFilePanel)
    onFiles: () => { if(!pcKeepsResult(result)) status.classList.remove('show','done','error','working'); },
    reason: err => { const msg = friendlyPdfError(err, typeOf.label); typeOf.label = 'PDF'; return msg; },
    run: async (list, _option, ctx) => {
      const out = await pcCompressAll(list, ctx, typeOf);
      typeOf.label = 'PDF';
      // (v119 review) a file handed back unchanged still has its password: no "no longer has a password" note
      if(out.results.some(r => r.kept)) pcPasswordUsedRun = false;
      return Object.assign(out, {
        info: out.results.length === 1 ? out.results[0].infoText : pcCompressTotalText(out.results),
        note: pcCompressNote(out.results)
      });
    }
  });
}); // compress panel
const PC_CANVAS_PAGES = new Set();
function releasePageCanvases(pdfPage){
  [pdfPage._pcRender, pdfPage._pcNoText].forEach(r => { if(r && r.canvas){ r.canvas.width = r.canvas.height = 0; } });
  pdfPage._pcRender = null; pdfPage._pcNoText = null;
  PC_CANVAS_PAGES.delete(pdfPage);
}
/* (v48) Whatever way a conversion ends -- finished, cancelled or failed
   halfway through a page -- no page keeps its full-page canvases. */
function releaseAllPageCanvases(){ [...PC_CANVAS_PAGES].forEach(releasePageCanvases); }
/* (v58) the wrapper that calls releaseAllPageCanvases() after every
   conversion now sits at the end of app-convert.js */
/* The note under a Word/PowerPoint result: no text layer, and/or some
   formatting that could not be carried over. */
function pcConversionNote(results){
  const names = list => results.length > 1 ? ' (' + list.join(', ') + ')' : '';
  const nt = results.filter(r => r.noText).map(r => r.name);
  const dl = results.filter(r => r.decoLost).map(r => r.name);
  // (v56) only for a real, visible simplification (see pcSimplified)
  const sp = results.filter(r => r.simplified).map(r => r.name);
  // (v61) typed form values that could not be read; stamps, drawings and notes on top of the page
  const fl = results.filter(r => r.formLost).map(r => r.name);
  const an = results.filter(r => r.annotSkipped).map(r => r.name);
  return [nt.length ? pcT('noText') + names(nt) : '', dl.length ? pcT('decoLost') + names(dl) : '', sp.length ? pcT('simplified') + names(sp) : '',
    fl.length ? pcT('formLost') + names(fl) : '', an.length ? pcT('annotSkipped') + names(an) : ''].filter(Boolean).join(' ');
}

function setupSingleFileTool(name, defaultMode){
  let mode = defaultMode || 'text';
  const dz = document.getElementById('dropzone-'+name);
  const input = document.getElementById('input-'+name);
  const list = document.getElementById('filelist-'+name);
  const btn = document.getElementById('btn-'+name);
  const modeBox = document.getElementById('mode-options-'+name);
  const status = document.getElementById('status-'+name);
  const result = document.getElementById('result-'+name);

  registerMultiFilePanel(name, {list, btn, status, result}, isPdfFile);

  setupDropzone(dz, input, files=>{
    addSharedFiles(files, isPdfFile);
    input.value = '';
  }, isPdfFile);

  modeBox.querySelectorAll('.quality-opt').forEach(opt=>{
    opt.addEventListener('click', ()=>{
      modeBox.querySelectorAll('.quality-opt').forEach(o=>o.classList.remove('selected'));
      opt.classList.add('selected');
      mode = opt.dataset.mode;
    });
  });

  return { getFiles: ()=>multiFilePanels[name].files.slice(), getMode: ()=>mode, btn };
}

// (v52) start fetching the Word/PowerPoint library as soon as there is a PDF
// to convert, so pressing the button rarely has to wait for it. A failure
// here is not shown: the conversion itself tries again and reports it.
// (v142) PowerPoint is packed in the worker, which loads PptxGenJS itself
// (pcPackStart): the page only needs it when the worker can't, so it is not
// fetched here. Word keeps docx on the page: its recorder uses docx's values.
const PC_PRELOAD_ON_PAGE = { docx: ['docx', 'convert'], pptx: ['convert'] };
function pcPreloadLib(key){
  // (v58) with the Word/PowerPoint library comes our own conversion code
  PC_PRELOAD_ON_PAGE[key].forEach(k => pcLoadLib(k).catch(() => { /* retried and reported when the conversion starts */ }));
}
// Only for the tool actually in view (every tool page has all the panels),
// or as soon as the visitor points at / focuses / opens a conversion.
function pcToolInView(btnId){ const b = document.getElementById(btnId); return !!(b && b.offsetParent); }
fileHub.register(f => pcFileKind(f) === 'pdf', list => {
  if(!list.length) return;
  if(pcToolInView('btn-word')) pcPreloadLib('docx');
  if(pcToolInView('btn-ppt')) pcPreloadLib('pptx');
});
[['btn-word', 'docx', 'word'], ['btn-ppt', 'pptx', 'ppt']].forEach(([btnId, key, tab]) => {
  pcOnPanel(tab, () => ['pointerenter', 'focus'].forEach(ev => document.getElementById(btnId).addEventListener(ev, () => pcPreloadLib(key), { once: true })));
  document.querySelectorAll('.tab[data-tab="' + tab + '"]').forEach(t => t.addEventListener('click', () => { if(fileHub.all().length) pcPreloadLib(key); }));
});

pcOnPanel('word', function(){ // (v140) only once its panel is in the page (live, or made from its <template>); not re-indented, to keep the diff small
const wordTool = setupSingleFileTool('word');
const statusWord = document.getElementById('status-word');
const statusWordText = document.getElementById('status-word-text');
const progressWord = document.getElementById('progress-word');
const resultWord = document.getElementById('result-word');
const resultWordInfo = document.getElementById('result-word-info');
const downloadWord = document.getElementById('download-word');

wordTool.btn.addEventListener('click', async ()=>{
  if(isProcessing) return; // (v55) one tool at a time: they share the cancel flag and page caches
  const files = fileHub.unique(wordTool.getFiles());
  const mode = wordTool.getMode();
  if(!files.length) return;
  pcSetProcessing(true);
  wordTool.btn.disabled = true;
  statusWord.classList.add('show','working');
  statusWord.classList.remove('done','error');
  resultWord.classList.remove('show');
  document.getElementById('tabular-warning-word').style.display = 'none';
  progressWord.style.width='0%';
  statusWordText.textContent = pcT('stConverting');

  const skippedWord = [];
  try{
    pcCheckPhoneMemory('word', files); // (v94) refused up front on a phone instead of a closed tab
    await pcLoadPdfLibs(); // (v56) pdf-lib/pdf.js/JSZip are loaded on demand
    await pcLoadLib('docx');
    pcRequirePdfJs(); // (v60) a browser too old for pdf.js 4 gets a clear message
    await pcLoadLib('convert'); // (v58) the conversion code itself, see PC_LAZY_LIBS
    const results = [];
    for(let f=0; f<files.length; f++){
      const file = files[f];
      pcCheckCancel();
      let r;
      try{ r = await convertOneFileToWord(file, mode, (i,numPages,phase)=>{
        pcCheckCancel();
        if(phase === PC_PHASE_FINISHING){
          statusWordText.textContent = files.length > 1 ? pcT('stFileFinishing', f+1, files.length, file.name) : pcT('stFinishing');
          return;
        }
        const fileFrac = f/files.length;
        // (v57) editable text first looks at every page (sizes, margins,
        // running headers): the bar stood still at 0% on a long document
        if(phase === PC_PHASE_SCANNING || phase === PC_PHASE_ANALYZING){
          const part = phase === PC_PHASE_SCANNING ? PC_SCAN_SHARE*(i/numPages) : PC_SCAN_SHARE + (1 - PC_SCAN_SHARE)*(i/numPages);
          progressWord.style.width = Math.round((fileFrac + PC_ANALYZE_SHARE*part/files.length)*100)+'%';
          // (v98) the scan of sample pages can take long on a scan (every page image is decoded): its share in %
          const msg = phase === PC_PHASE_SCANNING ? pcT('analyzingDoc', Math.floor(100*i/numPages)) : pcT('analyzingPages', i, numPages);
          statusWordText.textContent = files.length > 1 ? pcT('stFileOf', f+1, files.length, msg) : msg;
          return;
        }
        const pageShare = mode === 'text' ? 1 - PC_ANALYZE_SHARE : 1, pageStart = mode === 'text' ? PC_ANALYZE_SHARE : 0;
        const withinFile = (pageStart + pageShare*i/numPages)/files.length;
        progressWord.style.width = Math.round((fileFrac+withinFile)*100)+'%';
        statusWordText.textContent = files.length > 1
          ? pcT('stFilePage', f+1, files.length, file.name, i, numPages)
          : pcT('stPage', i, numPages);
      }); }catch(err){ skippedWord.push(pcSkipOrThrow(err, file, files.length)); continue; }
      results.push(r);
      statusWordText.textContent = files.length > 1
        ? pcT('stFileFinishing', f+1, files.length, file.name)
        : pcT('stFinishing');
    }

    if(!results.length) throw pcAllSkipped('errSkipConvert', skippedWord);
    statusWordText.textContent = results.length > 1
      ? pcT('stZip', results.length)
      : pcT('stLast');
    await offerResults(downloadWord, results, 'converted-word-files');

    statusWord.classList.remove('working');
    statusWord.classList.add('done');
    statusWordText.textContent = skippedWord.length ? pcT('stDoneSkipped', skippedWord.join(', ')) : pcT('stDone');
    resultWordInfo.textContent = results.length === 1
      ? results[0].infoText
      : pcT('infoZipConverted', results.length);
    resultWord.classList.add('show');
    pcShowNote(resultWordInfo, pcConversionNote(results));
    const tabWarnWord = document.getElementById('tabular-warning-word');
    tabWarnWord.style.display = (mode==='text' && results.some(r=>r.tabularWarning)) ? 'block' : 'none';
  }catch(err){
    statusWord.classList.remove('working');
    statusWord.classList.add('error');
    statusWordText.textContent = friendlyPdfError(err);
    pcLogUnexpected(err);
  }finally{
    pcSetProcessing(false);
    wordTool.btn.disabled = !wordTool.getFiles().length; // (v94)
  }
});
}); // word panel

pcOnPanel('ppt', function(){ // (v140) only once its panel is in the page (live, or made from its <template>); not re-indented, to keep the diff small
const pptTool = setupSingleFileTool('ppt', 'text');
const statusPpt = document.getElementById('status-ppt');
const statusPptText = document.getElementById('status-ppt-text');
const progressPpt = document.getElementById('progress-ppt');
const resultPpt = document.getElementById('result-ppt');
const resultPptInfo = document.getElementById('result-ppt-info');
const downloadPpt = document.getElementById('download-ppt');

pptTool.btn.addEventListener('click', async ()=>{
  if(isProcessing) return; // (v55) one tool at a time: they share the cancel flag and page caches
  const files = fileHub.unique(pptTool.getFiles());
  const mode = pptTool.getMode();
  if(!files.length) return;
  pcSetProcessing(true);
  pptTool.btn.disabled = true;
  statusPpt.classList.add('show','working');
  statusPpt.classList.remove('done','error');
  resultPpt.classList.remove('show');
  document.getElementById('tabular-warning-ppt').style.display = 'none';
  progressPpt.style.width='0%';
  statusPptText.textContent = pcT('stConverting');

  const skippedPpt = [];
  try{
    pcCheckPhoneMemory('ppt', files); // (v94) refused up front on a phone instead of a closed tab
    await pcLoadPdfLibs(); // (v56) pdf-lib/pdf.js/JSZip are loaded on demand
    pcRequirePdfJs(); // (v60) a browser too old for pdf.js 4 gets a clear message
    await pcLoadLib('convert'); // (v58) the conversion code itself, see PC_LAZY_LIBS
    const results = [];
    for(let f=0; f<files.length; f++){
      const file = files[f];
      pcCheckCancel();
      let r;
      try{ r = await convertOneFileToPpt(file, mode, (i,numPages,phase)=>{
        pcCheckCancel();
        if(phase === PC_PHASE_FINISHING){
          statusPptText.textContent = files.length > 1 ? pcT('stFileFinishing', f+1, files.length, file.name) : pcT('stFinishing');
          return;
        }
        const fileFrac = f/files.length;
        const withinFile = (i/numPages)/files.length;
        progressPpt.style.width = Math.round((fileFrac+withinFile)*100)+'%';
        statusPptText.textContent = files.length > 1
          ? pcT('stFilePage', f+1, files.length, file.name, i, numPages)
          : pcT('stPage', i, numPages);
      }); }catch(err){ skippedPpt.push(pcSkipOrThrow(err, file, files.length)); continue; }
      results.push(r);
      statusPptText.textContent = files.length > 1
        ? pcT('stFileFinishing', f+1, files.length, file.name)
        : pcT('stFinishing');
    }

    if(!results.length) throw pcAllSkipped('errSkipConvert', skippedPpt);
    statusPptText.textContent = results.length > 1
      ? pcT('stZip', results.length)
      : pcT('stLast');
    await offerResults(downloadPpt, results, 'converted-powerpoint-files');

    statusPpt.classList.remove('working');
    statusPpt.classList.add('done');
    statusPptText.textContent = skippedPpt.length ? pcT('stDoneSkipped', skippedPpt.join(', ')) : pcT('stDone');
    resultPptInfo.textContent = results.length === 1
      ? results[0].infoText
      : pcT('infoZipConverted', results.length);
    resultPpt.classList.add('show');
    pcShowNote(resultPptInfo, pcConversionNote(results));
    const tabWarnPpt = document.getElementById('tabular-warning-ppt');
    tabWarnPpt.style.display = (mode==='text' && results.some(r=>r.tabularWarning)) ? 'block' : 'none';
  }catch(err){
    statusPpt.classList.remove('working');
    statusPpt.classList.add('error');
    statusPptText.textContent = friendlyPdfError(err);
    pcLogUnexpected(err);
  }finally{
    pcSetProcessing(false);
    pptTool.btn.disabled = !pptTool.getFiles().length; // (v94)
  }
});
}); // ppt panel

/* Privacy policy and terms of use are hidden by default — only visible
   after clicking the link in the footer or disclaimer. */
document.querySelectorAll('a[href="#voorwaarden"], a[href="#privacybeleid"]').forEach(link=>{
  link.addEventListener('click', e=>{
    e.preventDefault();
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if(!target) return;
    document.querySelectorAll('.legal-page.show').forEach(el=>{ if(el!==target) el.classList.remove('show'); });
    target.classList.add('show');
    target.scrollIntoView({behavior: pcScrollBehavior(), block:'start'});
  });
});
/* (v49) no smooth scrolling for visitors who asked for reduced motion */
function pcScrollBehavior(){
  return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
}

/* Cloudflare Web Analytics — cookie-free, privacy-friendly visitor
   counting. Token added 2026-09-16 after setting up Web Analytics for
   pdfcommunity.org (standalone snippet, not proxied through Cloudflare's
   DNS/CDN — the site's DNS stays at EuroDNS). */

/* =====================================================================
   v47: PDF STRUCTURE ENGINE
   Shared by every tool that edits a PDF with pdf-lib (merge, split,
   delete, extract, rotate, page numbers, watermark, compress).
   - openPdfForEdit(): loads a PDF for editing and, when it only has an
     OWNER password (the "no editing" kind that opens without asking for a
     password), decrypts it first. Before v47 such files were copied still
     encrypted, which produced blank pages or an unreadable file while the
     tool reported "Done!" (QA round 47, test T2).
   - pcAssemble(): builds a new PDF from pages of one or more documents and
     carries over bookmarks, internal links, form fields, layers (and their
     hidden/visible state), attachments, title/author and language. Before
     v47 pdf-lib's copyPages() dropped all of that, broke internal links and
     made hidden layers visible (test T4).
   - pcStampText(): draws text at a spot "as the reader sees the page",
     honouring the CropBox, a non-zero MediaBox origin and /Rotate (test T3).
   - pcCompressPdf(): recompresses the images inside the PDF instead of
     turning every page into a picture, so text, links, forms and the page
     size stay exactly as they were, and never hands back a bigger file
     (test T1).
   - pdf.js always gets its CMaps and standard fonts, so Chinese/Japanese/
     Korean text in non-embedded fonts is no longer lost (test T8).
   - A Cancel button for every tool, and a memory warning on phones.
   Everything still runs only in this browser tab.
   ===================================================================== */

/* ---------- messages (6 languages) ---------- */
const PC_MSG = {
  en: {
    // (v98) messages that i18n-runtime.js used to translate with regexes (l90-i18n)
    infoPages1: "1 page, {0}", infoPagesN: "{0} pages, {1}", pageOfTotal: "Page {0} of {1}", stMerging: "Merging…", stCompressing: "Compressing…", stConverting: "Converting…", stSplitting: "Splitting…", stRotating: "Rotating…", stNumbering: "Adding page numbers…", stRemoving: "Removing pages…", stDone: "Done!", stDoneSkippedOpen: "Done, but skipped (couldn't be opened): {0}", stDoneSkipped: "Done, but skipped: {0}", infoMerged: "{0} files merged, {1}", infoWordText1: "1 page, {0} — editable text", infoWordTextN: "{0} pages, {1} — editable text", infoWordImg1: "1 page, {0} — identical layout (images)", infoWordImgN: "{0} pages, {1} — identical layout (images)", infoPptText1: "1 slide, {0} — editable text", infoPptTextN: "{0} slides, {1} — editable text", infoPptImg1: "1 slide, {0} — identical layout (images)", infoPptImgN: "{0} slides, {1} — identical layout (images)", stFilePage: "File {0} of {1} ({2}) — page {3} of {4}…", stFileFinishing: "File {0} of {1} ({2}) — finishing file…", stFileOf: "File {0} of {1}: {2}", stPage: "Processing page {0} of {1}…", stFinishing: "Finishing file…", stZip: "Collecting all {0} files into one zip file…", stLast: "Last step — preparing file for download…", infoZipCompressed: "{0} files compressed, collected in one zip file", infoZipCompressedTotal: "{0} files compressed: {1} → {2} ({3}% smaller), collected in one zip file", infoZipConverted: "{0} files converted, collected in one zip file", compressInfoImg: "{0} ({1}% smaller, {2} image(s) shrunk)", infoCreated1: "1 file created", infoCreatedN: "{0} files created", infoRotated1: "1 file rotated", infoRotatedN: "{0} files rotated", infoNumbered1: "1 file numbered", infoNumberedN: "{0} files numbered", infoUpdated1: "1 file updated", infoUpdatedN: "{0} files updated", errPwUse: "This file is password-protected. Run it on its own to type its password, or remove the password first (e.g. with Unlock PDF on this site).", errPwSplit: "This file is password-protected. Run it on its own to type its password, or remove the password first (e.g. with Unlock PDF on this site).", errPwRotate: "This file is password-protected. Run it on its own to type its password, or remove the password first (e.g. with Unlock PDF on this site).", errPwNumbers: "This file is password-protected. Run it on its own to type its password, or remove the password first (e.g. with Unlock PDF on this site).", errPwDelete: "This file is password-protected. Run it on its own to type its password, or remove the password first (e.g. with Unlock PDF on this site).", errInvalidPdf: "Could not process this file. Is it a valid PDF?", errInvalidWord: "Could not process this file. Is it a valid Word document?", errInvalidPpt: "Could not process this file. Is it a valid PowerPoint file?", errNoneSplit: "None of the files could be split. Are they valid PDF files?", errNoneRotated: "None of the files could be rotated. Are they valid PDF files?", errNoneProcessed: "None of the files could be processed. Are they valid PDF files?", errSkipSplit: "Could not split: {0}", errSkipConvert: "Could not convert: {0}", errSkipCompress: "Could not compress: {0}", errSkipRotate: "Could not rotate: {0}", errSkipNumbers: "Could not add page numbers: {0}", errSkipDelete: "Could not delete pages: {0}", errMergeOpen: "Could not open: {0}. At least 2 valid files are needed to merge.", errMergeOpenAll: "Could not open these files.", errDeleteNeed: "Enter at least one valid page number to remove (e.g. \"2, 5-7\").", errDeleteAll: "You can't remove every page — the result would be an empty PDF.", pwAsk: "This file is password-protected. Type its password below and try again. It stays in your browser.", pwWrong: "That password is not correct for this file. Type it again.", pwLabel: "PDF password", pwRetry: "Try again", pwRemovedNote: "The result no longer has a password. To protect it again, use Protect PDF.", compressCmykNote: "Print colours (CMYK) were turned into screen colours (RGB) in: {0}. Colours can look a little different; for a print shop, use the original or Light.",
    outOfMemory: "Your browser ran out of memory or could no longer read the file, so nothing was saved. Close other tabs or apps, choose the file again and try once more, or do the job in smaller parts (for example fewer pages at a time).", // (v73) friendlyPdfError
    pdfjsDataMissing: "A font file this PDF needs could not be loaded (no connection?), so part of the text would be missing. Nothing was saved. Check your connection, reload the page and try again.", // (v157) pcPdfJsMissed
    fileGone: "This file can no longer be read. It was probably moved, renamed or deleted after you chose it. Choose it again and try once more.", // (v89) friendlyPdfError: the chosen file is no longer on the device
    wrongType: "Not added: {0}. This tool can’t use that type of file.", emptyFile: "Not added: {0}. The file is empty (0 bytes).", // (v89) pcTakeUsable: a file left out when dropped or picked
    // (v73, q16) share menu for several result files (pcOfferShare)
    shareFiles: "Save the {0} files separately",
    shareHint: "Opens your device’s share menu, so each file is saved on its own (on iPhone: ‘Save to Files’, or ‘Save Images’ for pictures). The Download button above gives the same files in one zip.",
    shareFailed: "The share menu could not be opened. Use the Download button above: the zip holds the same files.",
    // (v62) "What next?" block under a result (pcOfferNextSteps)
    nextTitle: "What next?",
    nextSub: "Continue with {0} in another tool. You don’t have to choose it again, and it isn’t uploaded.",
    nextTool_merge: "Merge with other PDFs",
    nextTool_compress: "Compress",
    nextTool_word: "Convert to Word",
    nextTool_sign: "Sign",
    nextTool_protect: "Add a password",
    nextTool_numbers: "Add page numbers",
    nextTool_nup: "Put several pages on one sheet", nextTool_org: "Put the pages in order", nextTool_txt: "Save as text", nextTool_meta: "Remove metadata", nextTool_fill: "Fill in a form or add text", nextTool_flatten: "Flatten fields and comments", nextTool_redact: "Black out text (redact)", nextTool_ocr: "Make it searchable (OCR)",
    nextFromStep: "File from the previous step: {0}",
    nextOthersCleared: "The other files you had chosen are no longer in the list.",
    nextNoFile: "The file from the previous step could not be passed on, because your browser does not let this site keep it for a moment (for example in a private window). Please choose the file again.",
    pageMissing: 'Page {0} does not exist: this document has {1} pages.',
    pageMissingOne: 'Page {0} does not exist: this document has only 1 page.',
    pageBadInput: 'Could not understand "{0}". Use commas, e.g. 2, 5-7.',
    splitPointRange: 'To cut the document, use page numbers from 1 to {0} (this document has {1} pages).',
    splitOnePage: 'This document has only 1 page, so there is nothing to split.',
    numbersNone: 'There are no pages to number: the document has only a cover page.',
    truncated: 'This PDF seems incomplete or damaged: parts of it are missing (was the download interrupted?). Download it again and try once more.',
    pdfConflict: "This PDF contains two different versions of the same part, so it is not certain which page is the real one. Open it in a PDF reader, save it as a new PDF (or print it to PDF) and try again.", compressRepaired: "{0} was damaged (for example its table of contents was missing or wrong). The copy is repaired, so it also opens in programs that could not open the original.", // (v157) pcResolveDuplicates, pcOriginalIntact
    officeWrongKind: 'This is not a valid {0} file. Is the file extension correct?',
    simplified: 'Some parts (such as formulas or dense charts) were carried over as pictures, so they cannot be edited as text.',
    formLost: "The values typed in some form fields could not be read, so they are missing from the result.",
    annotSkipped: "Stamps, drawings or comments added on top of the PDF were not carried over as editable content.",
    decoLost: 'Some formatting (colours, highlights, links, underlines or table details) could not be carried over; the text itself is complete.',
    formulaAlt: 'Formula',
    cancel: 'Cancel', cancelled: 'Cancelled.',
    xfaHybridNote: 'Note: {0} is a hybrid XFA form. The result keeps the regular form fields, but not the XFA version of the form (only some PDF programs use that).',
    formRenamedNote: 'Note: some form fields in {0} were renamed (for example name → name_2) because an earlier file uses the same name. Automatic calculations in that file were switched off, so its totals are no longer recalculated.',
    ownerNote: 'Note: this PDF had editing restrictions (an owner password). It opens without a password, so it was processed; the result no longer carries those restrictions: {0}',
    certBroke: "Note: {0} had a certificate-based digital signature. That signature is no longer valid in the new copy.",
    splitUncovered: "Note: these pages are not in any of the new files: {0}.",
    compressNoImages: 'This PDF has no images, so the compression strength makes no difference.',
    compressKept: '{0} — this file is already well optimized, so your original is kept unchanged',
    compressImagesUnsupported: "{0} — the images in this file can't be made smaller here (for example print colours (CMYK) or very large photos), so your original is kept unchanged", // (v90) pcKeptText
    officeTooLarge: "This Word or PowerPoint file unpacks to more than {0} MB, too much for this device's memory. Nothing was changed. Try it on a computer, or remove large videos or pictures from the file first.", // (v90) pcOpenOfficeZip
    compressInfo: '{0} ({1}% smaller)',
    dpiCapped: 'Very large page(s): {0} saved at a lower resolution ({1} DPI) because of the browser\'s image size limit.',
    imageTooLarge: "A page is too large for this browser to turn into an image, even at a lower resolution. Try again on a computer, or split the PDF first.",
    finishFailed: "The file could not be finished correctly, so nothing was saved. Please try again.",
    libLoadFailed: "A required component could not be loaded. Check your connection (or ad blocker) and try again.",
    oldBrowser: "This tool needs a newer browser (on iPhone and iPad: iOS 16.4 or later). Update your browser or system and try again; the other tools on this site do work.",
    notPdfShort: "not a valid PDF",
    passwordShort: "password-protected",
    xfa: 'This is a dynamic XFA form, which most PDF programs and this site cannot display. Open it first in a desktop PDF program that supports XFA forms and print or save it as a regular PDF.',
    mobileMemTooBig: 'This job would need about {0} of memory, more than a phone\'s browser can give, so the tool won\'t start it. Use a computer, or split the file into smaller parts first.',
    xfaShort: 'a dynamic XFA form, which can\'t be edited here',
    mobileMemWarn: 'On a phone, this job may need more memory than the browser allows (about {0}), and the page can reload. A computer is safer for files this large.',
    mobileMemStop: 'This job would need about {0} of memory, more than a phone\'s browser can give, so it was not started. Use a computer for this file, or split it into smaller parts first.',
    largeFiles: "These files total {0}. Everything is processed in your browser's own memory, so this may take a while and could be slow on an older device or phone.",
    workerFailed: "Your browser stopped working on this file, probably because it ran out of memory. Close other tabs or apps and try again, or use a computer for very large files.",
    rotatePages: "Only these pages (optional, e.g. 1, 3-5; empty = all pages)",
    // (v62) page previews (pc-thumbs.js)
    thumbsHint: "Or tap the pages to select them:", thumbsHintSplit: "Or tap a page to split after it:", thumbsGroup: "Page previews", thumbsPage: "Page {0}", thumbsSplitAfter: "Split after page {0}", thumbsSel0: "No pages selected", thumbsSel1: "1 page selected", thumbsSelN: "{0} pages selected", thumbsRotAll: "No pages selected: all pages will be rotated", thumbsCut0: "No split points: every page becomes a separate file", thumbsCut1: "1 split point: 2 files", thumbsCutN: "{0} split points: {1} files", thumbsRanges: "You typed page ranges: each range becomes a separate file. Empty the field to pick split points on the pages.", thumbsMore: "Show more pages ({0} left)", thumbsMulti: "Page previews appear when you add a single PDF. The page numbers you type apply to every file.", thumbsFailed: "Page previews can't be shown for this file.", thumbsTooBig: "This file is too large to show page previews on this device. Type the page numbers instead.",
    noText: "This PDF has no text layer (for example a scan, or text turned into outlines), so there is no editable text to convert. Choose \"Identical layout\" to keep how the pages look.",
    analyzingPages: 'Analysing pages ({0} of {1})…',
    analyzingDoc: 'Analysing the document ({0}%)…',
    numPos: "Position", numPosOpts: "Bottom centre|Bottom right|Bottom left|Top centre|Top right|Top left", numStart: "Start at number", numSkipFirst: "Don't number the first page (cover)", numStartBad: "Type a whole number from 0 to 99999 as the start number.",
    numSize: "Size",
    numSizeOpts: "Small|Medium|Large",
    numColor: "Colour",
    numColorOpts: "Grey|Black|White|Blue|Red",
    numNoPages: "None of the chosen pages gets a number. Check the page list.",
    splitRange: 'Use page numbers or ranges separated by commas, e.g. "3, 7" or "1-3, 4-10".',
    splitEvery: "Or: a new file every … pages (optional)",
    splitEveryBad: "Type a whole number of pages, for example 2.",
    splitEveryBoth: "Fill in one of the two fields: where to split, or every how many pages.",
    splitEveryAll: "This file has {0} pages: every {1} pages gives just one file. Type a smaller number.",
    tabDone: 'Done', tabFailed: 'Failed', // (v95) tab title after a job
    staleRelease: "PDFCommunity was just updated. Reload this page (your files are not kept) and try again." // (v96) pcLoadLib
  },
  nl: {
    // (v98) messages that i18n-runtime.js used to translate with regexes (l90-i18n)
    infoPages1: "1 pagina, {0}", infoPagesN: "{0} pagina's, {1}", pageOfTotal: "Pagina {0} van {1}", stMerging: "Bezig met samenvoegen…", stCompressing: "Bezig met comprimeren…", stConverting: "Bezig met omzetten…", stSplitting: "Bezig met splitsen…", stRotating: "Bezig met draaien…", stNumbering: "Bezig met paginanummers toevoegen…", stRemoving: "Bezig met pagina's verwijderen…", stDone: "Klaar!", stDoneSkippedOpen: "Klaar, maar overgeslagen (kon niet geopend worden): {0}", stDoneSkipped: "Klaar, maar overgeslagen: {0}", infoMerged: "{0} bestanden samengevoegd, {1}", infoWordText1: "1 pagina, {0} – bewerkbare tekst", infoWordTextN: "{0} pagina's, {1} – bewerkbare tekst", infoWordImg1: "1 pagina, {0} – identieke lay-out (afbeeldingen)", infoWordImgN: "{0} pagina's, {1} – identieke lay-out (afbeeldingen)", infoPptText1: "1 dia, {0} – bewerkbare tekst", infoPptTextN: "{0} dia's, {1} – bewerkbare tekst", infoPptImg1: "1 dia, {0} – identieke lay-out (afbeeldingen)", infoPptImgN: "{0} dia's, {1} – identieke lay-out (afbeeldingen)", stFilePage: "Bestand {0} van {1} ({2}) – pagina {3} van {4}…", stFileFinishing: "Bestand {0} van {1} ({2}) – bestand afwerken…", stFileOf: "Bestand {0} van {1}: {2}", stPage: "Pagina {0} van {1} verwerken…", stFinishing: "Bestand afwerken…", stZip: "Alle {0} bestanden in één zip-bestand verzamelen…", stLast: "Laatste stap – bestand klaarmaken om te downloaden…", infoZipCompressed: "{0} bestanden gecomprimeerd, verzameld in één zip-bestand", infoZipCompressedTotal: "{0} bestanden gecomprimeerd: {1} → {2} ({3}% kleiner), verzameld in één zip-bestand", infoZipConverted: "{0} bestanden omgezet, verzameld in één zip-bestand", compressInfoImg: "{0} ({1}% kleiner, {2} afbeelding(en) verkleind)", infoCreated1: "1 bestand gemaakt", infoCreatedN: "{0} bestanden gemaakt", infoRotated1: "1 bestand gedraaid", infoRotatedN: "{0} bestanden gedraaid", infoNumbered1: "1 bestand genummerd", infoNumberedN: "{0} bestanden genummerd", infoUpdated1: "1 bestand aangepast", infoUpdatedN: "{0} bestanden aangepast", errPwUse: "Dit bestand is beveiligd met een wachtwoord. Verwerk het apart om het wachtwoord te typen, of verwijder eerst het wachtwoord (bv. met PDF ontgrendelen op deze site).", errPwSplit: "Dit bestand is beveiligd met een wachtwoord. Verwerk het apart om het wachtwoord te typen, of verwijder eerst het wachtwoord (bv. met PDF ontgrendelen op deze site).", errPwRotate: "Dit bestand is beveiligd met een wachtwoord. Verwerk het apart om het wachtwoord te typen, of verwijder eerst het wachtwoord (bv. met PDF ontgrendelen op deze site).", errPwNumbers: "Dit bestand is beveiligd met een wachtwoord. Verwerk het apart om het wachtwoord te typen, of verwijder eerst het wachtwoord (bv. met PDF ontgrendelen op deze site).", errPwDelete: "Dit bestand is beveiligd met een wachtwoord. Verwerk het apart om het wachtwoord te typen, of verwijder eerst het wachtwoord (bv. met PDF ontgrendelen op deze site).", errInvalidPdf: "Dit bestand kon niet verwerkt worden. Is het een geldige PDF?", errInvalidWord: "Dit bestand kon niet verwerkt worden. Is het een geldig Word-document?", errInvalidPpt: "Dit bestand kon niet verwerkt worden. Is het een geldig PowerPoint-bestand?", errNoneSplit: "Geen enkel bestand kon gesplitst worden. Zijn het geldige PDF's?", errNoneRotated: "Geen enkel bestand kon gedraaid worden. Zijn het geldige PDF's?", errNoneProcessed: "Geen enkel bestand kon verwerkt worden. Zijn het geldige PDF's?", errSkipSplit: "Kon niet splitsen: {0}", errSkipConvert: "Kon niet omzetten: {0}", errSkipCompress: "Kon niet comprimeren: {0}", errSkipRotate: "Kon niet draaien: {0}", errSkipNumbers: "Kon geen paginanummers toevoegen: {0}", errSkipDelete: "Kon geen pagina's verwijderen: {0}", errMergeOpen: "Kon niet openen: {0}. Er zijn minstens 2 geldige bestanden nodig om samen te voegen.", errMergeOpenAll: "Deze bestanden konden niet geopend worden.", errDeleteNeed: "Vul minstens één geldig paginanummer in om te verwijderen (bv. \"2, 5-7\").", errDeleteAll: "Je kan niet alle pagina's verwijderen – het resultaat zou een lege PDF zijn.", pwAsk: "Dit bestand is beveiligd met een wachtwoord. Typ het wachtwoord hieronder en probeer opnieuw. Het blijft in je browser.", pwWrong: "Dat wachtwoord klopt niet voor dit bestand. Typ het opnieuw.", pwLabel: "Wachtwoord van de PDF", pwRetry: "Opnieuw proberen", pwRemovedNote: "Het resultaat heeft geen wachtwoord meer. Wil je het opnieuw beveiligen, gebruik dan PDF beveiligen.", compressCmykNote: "Drukkleuren (CMYK) zijn omgezet naar schermkleuren (RGB) in: {0}. Kleuren kunnen iets anders ogen; geef een drukkerij het origineel of gebruik Licht.",
    outOfMemory: "Je browser had niet genoeg geheugen of kon het bestand niet meer lezen, dus er is niets bewaard. Sluit andere tabbladen of apps, kies het bestand opnieuw en probeer nog eens, of doe het in kleinere delen (bijvoorbeeld minder pagina's tegelijk).", // (v73) friendlyPdfError
    pdfjsDataMissing: "Een lettertypebestand dat deze PDF nodig heeft, kon niet geladen worden (geen verbinding?). Een deel van de tekst zou ontbreken, dus er is niets bewaard. Controleer je verbinding, herlaad de pagina en probeer opnieuw.", // (v157) pcPdfJsMissed
    fileGone: "Dit bestand kan niet meer gelezen worden. Waarschijnlijk is het verplaatst, hernoemd of verwijderd nadat je het koos. Kies het opnieuw en probeer nog eens.", // (v89) friendlyPdfError: the chosen file is no longer on the device
    wrongType: "Niet toegevoegd: {0}. Dit soort bestand werkt niet in deze tool.", emptyFile: "Niet toegevoegd: {0}. Het bestand is leeg (0 bytes).", // (v89) pcTakeUsable: a file left out when dropped or picked
    // (v73, q16) share menu for several result files (pcOfferShare)
    shareFiles: "De {0} bestanden apart bewaren",
    shareHint: "Opent het deelmenu van je toestel, zodat je elk bestand apart bewaart (op iPhone: ‘Bewaar in Bestanden’, of ‘Bewaar afbeeldingen’ voor foto’s). De downloadknop hierboven geeft dezelfde bestanden in één zip.",
    shareFailed: "Het deelmenu kon niet geopend worden. Gebruik de downloadknop hierboven: de zip bevat dezelfde bestanden.",
    // (v62) "What next?" block under a result (pcOfferNextSteps)
    nextTitle: "Wat nu?",
    nextSub: "Ga verder met {0} in een andere tool. Je hoeft het bestand niet opnieuw te kiezen en het wordt niet geüpload.",
    nextTool_merge: "Samenvoegen met andere PDF's",
    nextTool_compress: "Comprimeren",
    nextTool_word: "Omzetten naar Word",
    nextTool_sign: "Ondertekenen",
    nextTool_protect: "Wachtwoord toevoegen",
    nextTool_numbers: "Paginanummers toevoegen",
    nextTool_nup: "Meerdere pagina's per blad", nextTool_org: "Pagina's ordenen", nextTool_txt: "Opslaan als tekst", nextTool_meta: "Metadata wissen", nextTool_fill: "Formulier invullen of tekst toevoegen", nextTool_flatten: "Velden en opmerkingen afvlakken", nextTool_redact: "Tekst zwartlakken", nextTool_ocr: "Doorzoekbaar maken (OCR)",
    nextFromStep: "Bestand uit vorige stap: {0}",
    nextOthersCleared: "De andere bestanden die je gekozen had, staan niet meer in de lijst.",
    nextNoFile: "Het bestand uit de vorige stap kon niet mee, omdat je browser deze site het niet even laat bewaren (bijvoorbeeld in een privévenster). Kies het bestand opnieuw.",
    pageMissing: "Pagina {0} bestaat niet: dit document heeft {1} pagina's.",
    pageMissingOne: 'Pagina {0} bestaat niet: dit document heeft maar 1 pagina.',
    pageBadInput: 'Onbegrijpelijke invoer: "{0}". Gebruik komma\'s, bv. 2, 5-7.',
    splitPointRange: "Om te splitsen gebruik je paginanummers van 1 tot {0} (dit document heeft {1} pagina's).",
    splitOnePage: 'Dit document heeft maar 1 pagina, dus er valt niets te splitsen.',
    numbersNone: "Er zijn geen pagina's om te nummeren: het document heeft alleen een voorblad.",
    truncated: 'Deze PDF lijkt onvolledig of beschadigd: er ontbreken delen (was de download onderbroken?). Download hem opnieuw en probeer nog eens.',
    pdfConflict: "Deze PDF bevat twee verschillende versies van hetzelfde onderdeel, dus het is niet zeker welke pagina de echte is. Open hem in een PDF-lezer, bewaar hem als nieuwe PDF (of druk hem af naar PDF) en probeer opnieuw.", compressRepaired: "{0} was beschadigd (bijvoorbeeld een ontbrekende of foute inhoudstabel). De kopie is hersteld, dus ze opent ook in programma's die het origineel niet konden openen.", // (v157) pcResolveDuplicates, pcOriginalIntact
    officeWrongKind: 'Dit is geen geldig {0}-bestand. Klopt de bestandsextensie?',
    simplified: 'Sommige onderdelen (zoals formules of dichte grafieken) zijn als afbeelding overgenomen en dus niet als tekst te bewerken.',
    formLost: "De ingevulde waarden van sommige formuliervelden konden niet gelezen worden en ontbreken dus in het resultaat.",
    annotSkipped: "Stempels, tekeningen of opmerkingen die bovenop de PDF zijn aangebracht, zijn niet als bewerkbare inhoud overgenomen.",
    decoLost: 'Een deel van de opmaak (kleuren, markeringen, links, onderstreping of tabeldetails) kon niet worden overgenomen; de tekst zelf is volledig.',
    formulaAlt: 'Formule',
    cancel: 'Annuleren', cancelled: 'Geannuleerd.',
    xfaHybridNote: 'Let op: {0} is een hybride XFA-formulier. Het resultaat houdt de gewone formuliervelden, maar niet de XFA-versie van het formulier (die gebruiken maar enkele PDF-programma\'s).',
    formRenamedNote: 'Let op: enkele formuliervelden in {0} kregen een nieuwe naam (bv. naam → naam_2), omdat een eerder bestand dezelfde naam gebruikt. Automatische berekeningen in dat bestand zijn uitgezet, dus totalen worden niet meer herberekend.',
    ownerNote: 'Let op: deze PDF had bewerkingsbeperkingen (een eigenaarswachtwoord). Hij opent zonder wachtwoord en is dus verwerkt; het resultaat heeft die beperkingen niet meer: {0}',
    certBroke: "Let op: {0} had een digitale handtekening met certificaat. Die handtekening is in de nieuwe kopie niet meer geldig.",
    splitUncovered: "Let op: deze pagina's zitten in geen enkel nieuw bestand: {0}.",
    compressNoImages: 'Deze PDF bevat geen afbeeldingen, dus de sterkte maakt geen verschil.',
    compressKept: '{0} – dit bestand is al goed geoptimaliseerd, dus je origineel blijft ongewijzigd',
    compressImagesUnsupported: '{0} – de afbeeldingen in dit bestand kunnen hier niet kleiner gemaakt worden (bijvoorbeeld drukkleuren (CMYK) of heel grote foto’s), dus je origineel blijft ongewijzigd', // (v90) pcKeptText
    officeTooLarge: "Dit Word- of PowerPoint-bestand wordt bij het uitpakken groter dan {0} MB, te veel voor het geheugen van dit toestel. Er is niets veranderd. Probeer het op een computer, of haal eerst grote video's of afbeeldingen uit het bestand.", // (v90) pcOpenOfficeZip
    compressInfo: '{0} ({1}% kleiner)',
    dpiCapped: "Zeer grote pagina('s): {0} opgeslagen met een lagere resolutie ({1} DPI) door de beeldlimiet van de browser.",
    imageTooLarge: "Een pagina is te groot om in deze browser naar een afbeelding om te zetten, zelfs met een lagere resolutie. Probeer het op een computer, of splits de PDF eerst.",
    finishFailed: "Het bestand kon niet correct afgewerkt worden, dus er is niets bewaard. Probeer het opnieuw.",
    libLoadFailed: "Een nodig onderdeel kon niet geladen worden. Controleer je verbinding (of adblocker) en probeer opnieuw.",
    oldBrowser: "Deze tool heeft een recentere browser nodig (op iPhone en iPad: iOS 16.4 of nieuwer). Werk je browser of systeem bij en probeer opnieuw; de andere tools op deze site werken wel.",
    notPdfShort: "geen geldige PDF",
    passwordShort: "beveiligd met een wachtwoord",
    xfa: 'Dit is een dynamisch XFA-formulier dat de meeste PDF-programma\'s en deze site niet kunnen tonen. Open het eerst in een PDF-programma op je computer dat XFA-formulieren ondersteunt en druk het af of bewaar het als gewone PDF.',
    mobileMemTooBig: 'Deze taak zou ongeveer {0} geheugen vragen, meer dan de browser van een smartphone kan geven. Daarom start de tool ze niet. Gebruik een computer, of splits het bestand eerst in kleinere delen.',
    xfaShort: 'een dynamisch XFA-formulier, dat hier niet bewerkt kan worden',
    mobileMemWarn: 'Op een smartphone kan deze taak meer geheugen vragen dan de browser toelaat (ongeveer {0}), waardoor de pagina kan herladen. Gebruik voor zulke grote bestanden liever een computer.',
    mobileMemStop: 'Deze taak zou ongeveer {0} geheugen vragen, meer dan de browser van een smartphone kan geven. Daarom is ze niet gestart. Gebruik voor dit bestand een computer, of splits het eerst in kleinere delen.',
    largeFiles: "Deze bestanden zijn samen {0}. Alles wordt verwerkt in het geheugen van je browser, dus dit kan even duren en traag zijn op een ouder toestel of een smartphone.",
    workerFailed: "Je browser is gestopt met het verwerken van dit bestand, waarschijnlijk door een tekort aan geheugen. Sluit andere tabbladen of apps en probeer opnieuw, of gebruik voor heel grote bestanden een computer.",
    rotatePages: "Alleen deze pagina's (optioneel, bv. 1, 3-5; leeg = alle pagina's)",
    // (v62) page previews (pc-thumbs.js)
    thumbsHint: "Of tik op de pagina's om ze te kiezen:", thumbsHintSplit: "Of tik op een pagina om erna te splitsen:", thumbsGroup: "Paginavoorbeelden", thumbsPage: "Pagina {0}", thumbsSplitAfter: "Splitsen na pagina {0}", thumbsSel0: "Geen pagina's gekozen", thumbsSel1: "1 pagina gekozen", thumbsSelN: "{0} pagina's gekozen", thumbsRotAll: "Geen pagina's gekozen: alle pagina's worden gedraaid", thumbsCut0: "Geen splitspunten: elke pagina wordt een apart bestand", thumbsCut1: "1 splitspunt: 2 bestanden", thumbsCutN: "{0} splitspunten: {1} bestanden", thumbsRanges: "Je hebt paginabereiken getypt: elk bereik wordt een apart bestand. Maak het veld leeg om splitspunten op de pagina's te kiezen.", thumbsMore: "Meer pagina's tonen (nog {0})", thumbsMulti: "Paginavoorbeelden verschijnen als je één PDF toevoegt. De paginanummers die je typt, gelden voor elk bestand.", thumbsFailed: "Voor dit bestand kunnen geen paginavoorbeelden getoond worden.", thumbsTooBig: "Dit bestand is te groot om op dit toestel paginavoorbeelden te tonen. Typ de paginanummers in de plaats.",
    noText: "Deze PDF heeft geen tekstlaag (bijvoorbeeld een scan, of tekst die in vormen is omgezet), dus er is geen bewerkbare tekst om om te zetten. Kies \"Identieke lay-out\" om de pagina's te behouden zoals ze eruitzien.",
    analyzingPages: "Pagina's analyseren ({0} van {1})…",
    analyzingDoc: 'Document analyseren ({0}%)…',
    numPos: "Positie", numPosOpts: "Onder midden|Onder rechts|Onder links|Boven midden|Boven rechts|Boven links", numStart: "Beginnen bij nummer", numSkipFirst: "Eerste pagina (voorblad) niet nummeren", numStartBad: "Typ als startnummer een geheel getal van 0 tot 99999.",
    numSize: "Grootte",
    numSizeOpts: "Klein|Middel|Groot",
    numColor: "Kleur",
    numColorOpts: "Grijs|Zwart|Wit|Blauw|Rood",
    numNoPages: "Geen enkele gekozen pagina krijgt een nummer. Controleer de paginalijst.",
    splitRange: 'Gebruik paginanummers of bereiken gescheiden door komma\'s, bv. "3, 7" of "1-3, 4-10".',
    splitEvery: "Of: om de … pagina's een nieuw bestand (optioneel)",
    splitEveryBad: "Typ een geheel aantal pagina's, bijvoorbeeld 2.",
    splitEveryBoth: "Vul één van de twee velden in: waar je splitst, of om de hoeveel pagina's.",
    splitEveryAll: "Dit bestand heeft {0} pagina's: om de {1} pagina's geeft maar één bestand. Typ een kleiner getal.",
    tabDone: 'Klaar', tabFailed: 'Mislukt', // (v95) tab title after a job
    staleRelease: "PDFCommunity is net bijgewerkt. Herlaad deze pagina (je bestanden worden niet bewaard) en probeer opnieuw." // (v96) pcLoadLib
  },
  fr: {
    // (v98) messages that i18n-runtime.js used to translate with regexes (l90-i18n)
    infoPages1: "1 page, {0}", infoPagesN: "{0} pages, {1}", pageOfTotal: "Page {0} sur {1}", stMerging: "Fusion en cours…", stCompressing: "Compression en cours…", stConverting: "Conversion en cours…", stSplitting: "Division en cours…", stRotating: "Rotation en cours…", stNumbering: "Ajout des numéros de page…", stRemoving: "Suppression des pages…", stDone: "Terminé !", stDoneSkippedOpen: "Terminé, mais ignorés (impossible à ouvrir) : {0}", stDoneSkipped: "Terminé, mais ignorés : {0}", infoMerged: "{0} fichiers fusionnés, {1}", infoWordText1: "1 page, {0} – texte modifiable", infoWordTextN: "{0} pages, {1} – texte modifiable", infoWordImg1: "1 page, {0} – mise en page identique (images)", infoWordImgN: "{0} pages, {1} – mise en page identique (images)", infoPptText1: "1 diapositive, {0} – texte modifiable", infoPptTextN: "{0} diapositives, {1} – texte modifiable", infoPptImg1: "1 diapositive, {0} – mise en page identique (images)", infoPptImgN: "{0} diapositives, {1} – mise en page identique (images)", stFilePage: "Fichier {0} sur {1} ({2}) – page {3} sur {4}…", stFileFinishing: "Fichier {0} sur {1} ({2}) – finalisation…", stFileOf: "Fichier {0} sur {1} : {2}", stPage: "Traitement de la page {0} sur {1}…", stFinishing: "Finalisation du fichier…", stZip: "Regroupement des {0} fichiers dans un seul zip…", stLast: "Dernière étape – préparation du téléchargement…", infoZipCompressed: "{0} fichiers compressés, regroupés dans un seul zip", infoZipCompressedTotal: "{0} fichiers compressés\u00a0: {1} → {2} ({3}\u00a0% plus léger), regroupés dans un seul zip", infoZipConverted: "{0} fichiers convertis, regroupés dans un seul zip", compressInfoImg: "{0} ({1} % plus léger, {2} image(s) réduite(s))", infoCreated1: "1 fichier créé", infoCreatedN: "{0} fichiers créés", infoRotated1: "Rotation appliquée à 1 fichier", infoRotatedN: "Rotation appliquée à {0} fichiers", infoNumbered1: "1 fichier numéroté", infoNumberedN: "{0} fichiers numérotés", infoUpdated1: "1 fichier modifié", infoUpdatedN: "{0} fichiers modifiés", errPwUse: "Ce fichier est protégé par un mot de passe. Traitez-le seul pour saisir son mot de passe, ou retirez d’abord le mot de passe (par ex. avec Déverrouiller un PDF sur ce site).", errPwSplit: "Ce fichier est protégé par un mot de passe. Traitez-le seul pour saisir son mot de passe, ou retirez d’abord le mot de passe (par ex. avec Déverrouiller un PDF sur ce site).", errPwRotate: "Ce fichier est protégé par un mot de passe. Traitez-le seul pour saisir son mot de passe, ou retirez d’abord le mot de passe (par ex. avec Déverrouiller un PDF sur ce site).", errPwNumbers: "Ce fichier est protégé par un mot de passe. Traitez-le seul pour saisir son mot de passe, ou retirez d’abord le mot de passe (par ex. avec Déverrouiller un PDF sur ce site).", errPwDelete: "Ce fichier est protégé par un mot de passe. Traitez-le seul pour saisir son mot de passe, ou retirez d’abord le mot de passe (par ex. avec Déverrouiller un PDF sur ce site).", errInvalidPdf: "Impossible de traiter ce fichier. Est-ce un PDF valide ?", errInvalidWord: "Impossible de traiter ce fichier. Est-ce un document Word valide ?", errInvalidPpt: "Impossible de traiter ce fichier. Est-ce un fichier PowerPoint valide ?", errNoneSplit: "Aucun fichier n'a pu être divisé. S'agit-il de PDF valides ?", errNoneRotated: "La rotation n'a pu être appliquée à aucun fichier. S'agit-il de PDF valides ?", errNoneProcessed: "Aucun fichier n'a pu être traité. S'agit-il de PDF valides ?", errSkipSplit: "Division impossible : {0}", errSkipConvert: "Impossible de convertir : {0}", errSkipCompress: "Impossible de compresser : {0}", errSkipRotate: "Rotation impossible : {0}", errSkipNumbers: "Numérotation impossible : {0}", errSkipDelete: "Suppression impossible : {0}", errMergeOpen: "Ouverture impossible : {0}. Il faut au moins 2 fichiers valides pour fusionner.", errMergeOpenAll: "Impossible d'ouvrir ces fichiers.", errDeleteNeed: "Indiquez au moins un numéro de page valide à supprimer (par ex. « 2, 5-7 »).", errDeleteAll: "Impossible de supprimer toutes les pages – le résultat serait un PDF vide.", pwAsk: "Ce fichier est protégé par un mot de passe. Saisissez-le ci-dessous et réessayez. Il reste dans votre navigateur.", pwWrong: "Ce mot de passe n’est pas correct pour ce fichier. Saisissez-le à nouveau.", pwLabel: "Mot de passe du PDF", pwRetry: "Réessayer", pwRemovedNote: "Le résultat n’a plus de mot de passe. Pour le protéger à nouveau, utilisez Protéger un PDF.", compressCmykNote: "Les couleurs d’impression (CMJN) ont été converties en couleurs d’écran (RVB) dans : {0}. Les couleurs peuvent légèrement changer ; pour un imprimeur, utilisez l’original ou Légère.",
    outOfMemory: "Votre navigateur a manqué de mémoire ou n’a plus pu lire le fichier\u00a0: rien n’a été enregistré. Fermez d’autres onglets ou applications, choisissez à nouveau le fichier et réessayez, ou procédez en plusieurs fois (par exemple moins de pages à la fois).", // (v73) friendlyPdfError
    pdfjsDataMissing: "Un fichier de police nécessaire à ce PDF n’a pas pu être chargé (pas de connexion\xa0?)\xa0: une partie du texte manquerait, donc rien n’a été enregistré. Vérifiez votre connexion, rechargez la page et réessayez.", // (v157) pcPdfJsMissed
    fileGone: "Ce fichier ne peut plus être lu. Il a probablement été déplacé, renommé ou supprimé après que vous l’avez choisi. Choisissez-le à nouveau et réessayez.", // (v89) friendlyPdfError: the chosen file is no longer on the device
    wrongType: "Non ajouté : {0}. Cet outil n’accepte pas ce type de fichier.", emptyFile: "Non ajouté : {0}. Le fichier est vide (0 octet).", // (v89) pcTakeUsable: a file left out when dropped or picked
    // (v73, q16) share menu for several result files (pcOfferShare)
    shareFiles: "Enregistrer les {0} fichiers séparément",
    shareHint: "Ouvre le menu de partage de votre appareil pour enregistrer chaque fichier à part (sur iPhone\u00a0: «\u00a0Enregistrer dans Fichiers\u00a0», ou «\u00a0Enregistrer les images\u00a0» pour les images). Le bouton de téléchargement ci-dessus donne les mêmes fichiers dans un seul zip.",
    shareFailed: "Le menu de partage n’a pas pu s’ouvrir. Utilisez le bouton de téléchargement ci-dessus\u00a0: le zip contient les mêmes fichiers.",
    // (v62) "What next?" block under a result (pcOfferNextSteps)
    nextTitle: "Et maintenant\u00a0?",
    nextSub: "Continuez avec {0} dans un autre outil. Inutile de le choisir à nouveau, et il n'est pas envoyé.",
    nextTool_merge: "Fusionner avec d’autres PDF",
    nextTool_compress: "Compresser",
    nextTool_word: "Convertir en Word",
    nextTool_sign: "Signer",
    nextTool_protect: "Ajouter un mot de passe",
    nextTool_numbers: "Numéroter les pages",
    nextTool_nup: "Plusieurs pages par feuille", nextTool_org: "Organiser les pages", nextTool_txt: "Enregistrer en texte", nextTool_meta: "Supprimer les métadonnées", nextTool_fill: "Remplir un formulaire ou ajouter du texte", nextTool_flatten: "Aplatir les champs et commentaires", nextTool_redact: "Caviarder du texte", nextTool_ocr: "Rendre consultable (OCR)",
    nextFromStep: "Fichier de l’étape précédente\u00a0: {0}",
    nextOthersCleared: "Les autres fichiers que vous aviez choisis ne sont plus dans la liste.",
    nextNoFile: "Le fichier de l’étape précédente n’a pas pu être transmis, car votre navigateur ne permet pas à ce site de le garder un instant (par exemple en navigation privée). Choisissez à nouveau le fichier.",
    pageMissing: "La page {0} n'existe pas\u00a0: ce document compte {1} pages.",
    pageMissingOne: "La page {0} n'existe pas\u00a0: ce document ne compte qu'une page.",
    pageBadInput: 'Saisie incompréhensible\u00a0: «\u00a0{0}\u00a0». Utilisez des virgules, par ex. 2, 5-7.',
    splitPointRange: 'Pour diviser, utilisez des numéros de page de 1 à {0} (ce document compte {1} pages).',
    splitOnePage: "Ce document ne compte qu'une page\u00a0: il n'y a rien à diviser.",
    numbersNone: "Il n'y a aucune page à numéroter\u00a0: le document ne contient qu'une page de couverture.",
    truncated: 'Ce PDF semble incomplet ou endommagé\u00a0: il en manque des parties (le téléchargement a-t-il été interrompu\u00a0?). Téléchargez-le à nouveau et réessayez.',
    pdfConflict: "Ce PDF contient deux versions différentes d’un même élément : on ne peut pas savoir avec certitude quelle page est la bonne. Ouvrez-le dans un lecteur PDF, enregistrez-le comme nouveau PDF (ou imprimez-le en PDF) et réessayez.", compressRepaired: "{0} était endommagé (par exemple une table des matières interne absente ou erronée). La copie est réparée et s’ouvre donc aussi dans les programmes qui ne pouvaient pas ouvrir l’original.", // (v157) pcResolveDuplicates, pcOriginalIntact
    officeWrongKind: "Ce n'est pas un fichier {0} valide. L'extension du fichier est-elle correcte\u00a0?",
    simplified: "Certains éléments (comme des formules ou des graphiques denses) ont été repris sous forme d'images et ne sont donc pas modifiables comme du texte.",
    formLost: "Les valeurs saisies dans certains champs de formulaire n'ont pas pu être lues\u00a0: elles manquent dans le résultat.",
    annotSkipped: "Les tampons, dessins ou commentaires ajoutés par-dessus le PDF n'ont pas été repris comme contenu modifiable.",
    decoLost: "Une partie de la mise en forme (couleurs, surlignages, liens, soulignements ou détails de tableau) n'a pas pu être reprise\u00a0; le texte lui-même est complet.",
    formulaAlt: 'Formule',
    cancel: 'Annuler', cancelled: 'Annulé.',
    xfaHybridNote: 'Remarque\u00a0: {0} est un formulaire XFA hybride. Le résultat garde les champs de formulaire normaux, mais pas la version XFA du formulaire (seuls certains logiciels PDF l\'utilisent).',
    formRenamedNote: 'Remarque\u00a0: certains champs de formulaire de {0} ont été renommés (par exemple nom → nom_2), car un fichier précédent utilise le même nom. Les calculs automatiques de ce fichier ont été désactivés\u00a0: ses totaux ne sont plus recalculés.',
    ownerNote: 'Remarque : ce PDF avait des restrictions de modification (un mot de passe propriétaire). Il s\'ouvre sans mot de passe et a donc été traité ; le résultat n\'a plus ces restrictions : {0}',
    certBroke: "Attention\u00a0: {0} portait une signature numérique avec certificat. Cette signature n'est plus valide dans la nouvelle copie.",
    splitUncovered: "Attention\u00a0: ces pages ne figurent dans aucun des nouveaux fichiers\u00a0: {0}.",
    compressNoImages: "Ce PDF ne contient pas d'images : le niveau de compression ne change donc rien.",
    compressKept: '{0} – ce fichier est déjà bien optimisé, votre original est donc conservé tel quel',
    compressImagesUnsupported: '{0} – les images de ce fichier ne peuvent pas être réduites ici (par exemple couleurs d’impression (CMJN) ou très grandes photos), votre original est donc conservé tel quel', // (v90) pcKeptText
    officeTooLarge: 'Ce fichier Word ou PowerPoint dépasse {0} Mo une fois décompressé, c’est trop pour la mémoire de cet appareil. Rien n’a été modifié. Essayez sur un ordinateur, ou retirez d’abord les grandes vidéos ou images du fichier.', // (v90) pcOpenOfficeZip
    compressInfo: '{0} ({1} % plus léger)',
    dpiCapped: 'Page(s) très grande(s) : {0} enregistrée(s) avec une résolution plus basse ({1} DPI) à cause de la limite d\'image du navigateur.',
    imageTooLarge: "Une page est trop grande pour être convertie en image dans ce navigateur, même avec une résolution plus basse. Réessayez sur un ordinateur ou divisez d'abord le PDF.",
    finishFailed: "Le fichier n'a pas pu être finalisé correctement, rien n'a donc été enregistré. Veuillez réessayer.",
    libLoadFailed: "Un composant nécessaire n'a pas pu être chargé. Vérifiez votre connexion (ou votre bloqueur de publicités) et réessayez.",
    oldBrowser: "Cet outil nécessite un navigateur plus récent (sur iPhone et iPad : iOS 16.4 ou ultérieur). Mettez à jour votre navigateur ou votre système et réessayez ; les autres outils du site fonctionnent.",
    notPdfShort: "PDF non valide",
    passwordShort: "protégé par un mot de passe",
    xfa: 'Il s\'agit d\'un formulaire XFA dynamique, que la plupart des logiciels PDF et ce site ne peuvent pas afficher. Ouvrez-le d\'abord dans un logiciel PDF de bureau compatible avec les formulaires XFA, puis imprimez-le ou enregistrez-le comme PDF normal.',
    mobileMemTooBig: 'Cette tâche demanderait environ {0} de mémoire, plus que ce que le navigateur d\'un téléphone peut fournir\u00a0: l\'outil ne la lancera donc pas. Utilisez un ordinateur, ou divisez d\'abord le fichier en parties plus petites.',
    xfaShort: 'un formulaire XFA dynamique, qui ne peut pas être modifié ici',
    mobileMemWarn: 'Sur un téléphone, cette tâche peut demander plus de mémoire que le navigateur n\'en autorise (environ {0}), et la page peut se recharger. Pour des fichiers aussi volumineux, un ordinateur est plus sûr.',
    mobileMemStop: 'Cette tâche demanderait environ {0} de mémoire, plus que ce que le navigateur d\'un téléphone peut fournir\u00a0: elle n\'a donc pas été lancée. Utilisez un ordinateur pour ce fichier, ou divisez-le d\'abord en parties plus petites.',
    largeFiles: "Ces fichiers pèsent au total {0}. Tout est traité dans la mémoire de votre navigateur, ce qui peut prendre un moment et être lent sur un appareil ancien ou un téléphone.",
    workerFailed: "Votre navigateur a arrêté le traitement de ce fichier, probablement par manque de mémoire. Fermez d'autres onglets ou applications et réessayez, ou utilisez un ordinateur pour les très gros fichiers.",
    rotatePages: "Uniquement ces pages (facultatif, par ex. 1, 3-5 ; vide = toutes)",
    // (v62) page previews (pc-thumbs.js)
    thumbsHint: "Ou touchez les pages pour les sélectionner\u00a0:", thumbsHintSplit: "Ou touchez une page pour diviser après celle-ci\u00a0:", thumbsGroup: "Aperçus des pages", thumbsPage: "Page {0}", thumbsSplitAfter: "Diviser après la page {0}", thumbsSel0: "Aucune page sélectionnée", thumbsSel1: "1 page sélectionnée", thumbsSelN: "{0} pages sélectionnées", thumbsRotAll: "Aucune page sélectionnée\u00a0: toutes les pages seront pivotées", thumbsCut0: "Aucun point de division\u00a0: chaque page devient un fichier distinct", thumbsCut1: "1 point de division\u00a0: 2 fichiers", thumbsCutN: "{0} points de division\u00a0: {1} fichiers", thumbsRanges: "Vous avez saisi des plages de pages\u00a0: chaque plage devient un fichier distinct. Videz le champ pour choisir les points de division sur les pages.", thumbsMore: "Afficher plus de pages (encore {0})", thumbsMulti: "Les aperçus des pages s'affichent lorsque vous ajoutez un seul PDF. Les numéros de page saisis s'appliquent à chaque fichier.", thumbsFailed: "Impossible d'afficher les aperçus des pages de ce fichier.", thumbsTooBig: "Ce fichier est trop volumineux pour afficher les aperçus des pages sur cet appareil. Saisissez plutôt les numéros de page.",
    noText: "Ce PDF n'a pas de couche de texte (par exemple un scan, ou du texte converti en tracés) : il n'y a donc pas de texte modifiable à convertir. Choisissez « Mise en page identique » pour garder l'aspect des pages.",
    analyzingPages: 'Analyse des pages ({0} sur {1})…',
    analyzingDoc: 'Analyse du document ({0}\u00a0%)…',
    numPos: "Position", numPosOpts: "En bas au centre|En bas à droite|En bas à gauche|En haut au centre|En haut à droite|En haut à gauche", numStart: "Commencer au numéro", numSkipFirst: "Ne pas numéroter la première page (couverture)", numStartBad: "Saisissez un nombre entier de 0 à 99999 comme numéro de départ.",
    numSize: "Taille",
    numSizeOpts: "Petite|Moyenne|Grande",
    numColor: "Couleur",
    numColorOpts: "Gris|Noir|Blanc|Bleu|Rouge",
    numNoPages: "Aucune des pages choisies ne reçoit de numéro. Vérifiez la liste des pages.",
    splitRange: 'Utilisez des numéros de page ou des plages séparés par des virgules, par ex. « 3, 7 » ou « 1-3, 4-10 ».',
    splitEvery: "Ou : un nouveau fichier toutes les … pages (facultatif)",
    splitEveryBad: "Saisissez un nombre entier de pages, par exemple 2.",
    splitEveryBoth: "Remplissez un seul des deux champs : où couper, ou toutes les combien de pages.",
    splitEveryAll: "Ce fichier a {0} pages : toutes les {1} pages ne donne qu’un seul fichier. Saisissez un nombre plus petit.",
    tabDone: 'Terminé', tabFailed: 'Échec', // (v95) tab title after a job
    staleRelease: "PDFCommunity vient d'être mis à jour. Rechargez cette page (vos fichiers ne sont pas conservés) et réessayez." // (v96) pcLoadLib
  },
  de: {
    // (v98) messages that i18n-runtime.js used to translate with regexes (l90-i18n)
    infoPages1: "1 Seite, {0}", infoPagesN: "{0} Seiten, {1}", pageOfTotal: "Seite {0} von {1}", stMerging: "Wird zusammengefügt…", stCompressing: "Wird komprimiert…", stConverting: "Wird umgewandelt…", stSplitting: "Wird geteilt…", stRotating: "Wird gedreht…", stNumbering: "Seitenzahlen werden eingefügt…", stRemoving: "Seiten werden gelöscht…", stDone: "Fertig!", stDoneSkippedOpen: "Fertig, aber übersprungen (ließ sich nicht öffnen): {0}", stDoneSkipped: "Fertig, aber übersprungen: {0}", infoMerged: "{0} Dateien zusammengefügt, {1}", infoWordText1: "1 Seite, {0} – bearbeitbarer Text", infoWordTextN: "{0} Seiten, {1} – bearbeitbarer Text", infoWordImg1: "1 Seite, {0} – identisches Layout (Bilder)", infoWordImgN: "{0} Seiten, {1} – identisches Layout (Bilder)", infoPptText1: "1 Folie, {0} – bearbeitbarer Text", infoPptTextN: "{0} Folien, {1} – bearbeitbarer Text", infoPptImg1: "1 Folie, {0} – identisches Layout (Bilder)", infoPptImgN: "{0} Folien, {1} – identisches Layout (Bilder)", stFilePage: "Datei {0} von {1} ({2}) – Seite {3} von {4}…", stFileFinishing: "Datei {0} von {1} ({2}) – Datei wird fertiggestellt…", stFileOf: "Datei {0} von {1}: {2}", stPage: "Seite {0} von {1} wird verarbeitet…", stFinishing: "Datei wird fertiggestellt…", stZip: "Alle {0} Dateien werden in einer Zip-Datei gesammelt…", stLast: "Letzter Schritt – Datei wird zum Herunterladen vorbereitet…", infoZipCompressed: "{0} Dateien komprimiert, in einer Zip-Datei gesammelt", infoZipCompressedTotal: "{0} Dateien komprimiert: {1} → {2} ({3} % kleiner), in einer Zip-Datei gesammelt", infoZipConverted: "{0} Dateien umgewandelt, in einer Zip-Datei gesammelt", compressInfoImg: "{0} ({1} % kleiner, {2} Bild(er) verkleinert)", infoCreated1: "1 Datei erstellt", infoCreatedN: "{0} Dateien erstellt", infoRotated1: "1 Datei gedreht", infoRotatedN: "{0} Dateien gedreht", infoNumbered1: "1 Datei nummeriert", infoNumberedN: "{0} Dateien nummeriert", infoUpdated1: "1 Datei bearbeitet", infoUpdatedN: "{0} Dateien bearbeitet", errPwUse: "Diese Datei ist passwortgeschützt. Verarbeiten Sie sie einzeln, um ihr Passwort einzugeben, oder entfernen Sie zuerst das Passwort (z. B. mit „PDF entsperren“ auf dieser Website).", errPwSplit: "Diese Datei ist passwortgeschützt. Verarbeiten Sie sie einzeln, um ihr Passwort einzugeben, oder entfernen Sie zuerst das Passwort (z. B. mit „PDF entsperren“ auf dieser Website).", errPwRotate: "Diese Datei ist passwortgeschützt. Verarbeiten Sie sie einzeln, um ihr Passwort einzugeben, oder entfernen Sie zuerst das Passwort (z. B. mit „PDF entsperren“ auf dieser Website).", errPwNumbers: "Diese Datei ist passwortgeschützt. Verarbeiten Sie sie einzeln, um ihr Passwort einzugeben, oder entfernen Sie zuerst das Passwort (z. B. mit „PDF entsperren“ auf dieser Website).", errPwDelete: "Diese Datei ist passwortgeschützt. Verarbeiten Sie sie einzeln, um ihr Passwort einzugeben, oder entfernen Sie zuerst das Passwort (z. B. mit „PDF entsperren“ auf dieser Website).", errInvalidPdf: "Diese Datei konnte nicht verarbeitet werden. Ist es ein gültiges PDF?", errInvalidWord: "Diese Datei konnte nicht verarbeitet werden. Ist es ein gültiges Word-Dokument?", errInvalidPpt: "Diese Datei konnte nicht verarbeitet werden. Ist es eine gültige PowerPoint-Datei?", errNoneSplit: "Keine der Dateien konnte geteilt werden. Sind es gültige PDF-Dateien?", errNoneRotated: "Keine der Dateien konnte gedreht werden. Sind es gültige PDF-Dateien?", errNoneProcessed: "Keine der Dateien konnte verarbeitet werden. Sind es gültige PDF-Dateien?", errSkipSplit: "Teilen nicht möglich: {0}", errSkipConvert: "Konnte nicht umgewandelt werden: {0}", errSkipCompress: "Konnte nicht komprimiert werden: {0}", errSkipRotate: "Drehen nicht möglich: {0}", errSkipNumbers: "Seitenzahlen konnten nicht eingefügt werden: {0}", errSkipDelete: "Seiten konnten nicht gelöscht werden: {0}", errMergeOpen: "Konnte nicht geöffnet werden: {0}. Zum Zusammenfügen sind mindestens 2 gültige Dateien nötig.", errMergeOpenAll: "Diese Dateien konnten nicht geöffnet werden.", errDeleteNeed: "Geben Sie mindestens eine gültige Seitenzahl zum Löschen ein (z. B. „2, 5-7“).", errDeleteAll: "Sie können nicht alle Seiten löschen – das Ergebnis wäre ein leeres PDF.", pwAsk: "Diese Datei ist passwortgeschützt. Geben Sie das Passwort unten ein und versuchen Sie es erneut. Es bleibt in Ihrem Browser.", pwWrong: "Dieses Passwort ist für diese Datei nicht korrekt. Geben Sie es erneut ein.", pwLabel: "Passwort des PDFs", pwRetry: "Erneut versuchen", pwRemovedNote: "Das Ergebnis hat kein Passwort mehr. Um es wieder zu schützen, verwenden Sie „PDF schützen“.", compressCmykNote: "Druckfarben (CMYK) wurden in Bildschirmfarben (RGB) umgewandelt in: {0}. Farben können etwas anders aussehen; für eine Druckerei verwenden Sie das Original oder „Leicht“.",
    outOfMemory: "Ihrem Browser ging der Speicher aus oder er konnte die Datei nicht mehr lesen, daher wurde nichts gespeichert. Schließen Sie andere Tabs oder Apps, wählen Sie die Datei erneut und versuchen Sie es noch einmal, oder teilen Sie die Aufgabe auf (zum Beispiel weniger Seiten auf einmal).", // (v73) friendlyPdfError
    pdfjsDataMissing: "Eine Schriftdatei, die diese PDF braucht, konnte nicht geladen werden (keine Verbindung?). Ein Teil des Textes würde fehlen, daher wurde nichts gespeichert. Prüfen Sie Ihre Verbindung, laden Sie die Seite neu und versuchen Sie es noch einmal.", // (v157) pcPdfJsMissed
    fileGone: "Diese Datei kann nicht mehr gelesen werden. Wahrscheinlich wurde sie verschoben, umbenannt oder gelöscht, nachdem Sie sie ausgewählt haben. Wählen Sie sie erneut aus und versuchen Sie es noch einmal.", // (v89) friendlyPdfError: the chosen file is no longer on the device
    wrongType: "Nicht hinzugefügt: {0}. Dieses Tool kann diesen Dateityp nicht verwenden.", emptyFile: "Nicht hinzugefügt: {0}. Die Datei ist leer (0 Byte).", // (v89) pcTakeUsable: a file left out when dropped or picked
    // (v73, q16) share menu for several result files (pcOfferShare)
    shareFiles: "Die {0} Dateien einzeln speichern",
    shareHint: "Öffnet das Teilen-Menü Ihres Geräts, damit Sie jede Datei einzeln speichern (auf dem iPhone: „In Dateien sichern“ oder „Bilder sichern“ für Bilder). Der Download-Button oben liefert dieselben Dateien in einem ZIP.",
    shareFailed: "Das Teilen-Menü konnte nicht geöffnet werden. Nutzen Sie den Download-Button oben: Das ZIP enthält dieselben Dateien.",
    // (v62) "What next?" block under a result (pcOfferNextSteps)
    nextTitle: "Wie geht es weiter?",
    nextSub: "Arbeiten Sie mit {0} in einem anderen Tool weiter. Sie müssen die Datei nicht erneut auswählen, und sie wird nicht hochgeladen.",
    nextTool_merge: "Mit anderen PDFs zusammenfügen",
    nextTool_compress: "Komprimieren",
    nextTool_word: "In Word umwandeln",
    nextTool_sign: "Unterschreiben",
    nextTool_protect: "Passwort hinzufügen",
    nextTool_numbers: "Seitenzahlen einfügen",
    nextTool_nup: "Mehrere Seiten pro Blatt", nextTool_org: "Seiten ordnen", nextTool_txt: "Als Text speichern", nextTool_meta: "Metadaten entfernen", nextTool_fill: "Formular ausfüllen oder Text hinzufügen", nextTool_flatten: "Felder und Kommentare abflachen", nextTool_redact: "Text schwärzen", nextTool_ocr: "Durchsuchbar machen (OCR)",
    nextFromStep: "Datei aus dem vorherigen Schritt: {0}",
    nextOthersCleared: "Die anderen ausgewählten Dateien stehen nicht mehr in der Liste.",
    nextNoFile: "Die Datei aus dem vorherigen Schritt konnte nicht übernommen werden, weil Ihr Browser dieser Website nicht erlaubt, sie kurz zu speichern (zum Beispiel in einem privaten Fenster). Bitte wählen Sie die Datei erneut aus.",
    pageMissing: 'Seite {0} gibt es nicht: Dieses Dokument hat {1} Seiten.',
    pageMissingOne: 'Seite {0} gibt es nicht: Dieses Dokument hat nur 1 Seite.',
    pageBadInput: 'Unverständliche Eingabe: „{0}“. Verwenden Sie Kommas, z. B. 2, 5-7.',
    splitPointRange: 'Zum Teilen verwenden Sie Seitenzahlen von 1 bis {0} (dieses Dokument hat {1} Seiten).',
    splitOnePage: 'Dieses Dokument hat nur 1 Seite, es gibt also nichts zu teilen.',
    numbersNone: 'Es gibt keine Seiten zum Nummerieren: Das Dokument hat nur ein Deckblatt.',
    truncated: 'Dieses PDF scheint unvollständig oder beschädigt zu sein: Teile fehlen (wurde der Download unterbrochen?). Laden Sie es erneut herunter und versuchen Sie es noch einmal.',
    pdfConflict: "Dieses PDF enthält zwei verschiedene Fassungen desselben Teils, daher ist nicht sicher, welche Seite die richtige ist. Öffnen Sie es in einem PDF-Reader, speichern Sie es als neues PDF (oder drucken Sie es als PDF) und versuchen Sie es erneut.", compressRepaired: "{0} war beschädigt (zum Beispiel fehlte das interne Inhaltsverzeichnis oder war falsch). Die Kopie ist repariert und öffnet sich daher auch in Programmen, die das Original nicht öffnen konnten.", // (v157) pcResolveDuplicates, pcOriginalIntact
    officeWrongKind: 'Das ist keine gültige {0}-Datei. Stimmt die Dateiendung?',
    simplified: 'Einige Elemente (etwa Formeln oder dichte Diagramme) wurden als Bilder übernommen und lassen sich daher nicht als Text bearbeiten.',
    formLost: "Die eingetragenen Werte einiger Formularfelder konnten nicht gelesen werden und fehlen daher im Ergebnis.",
    annotSkipped: "Stempel, Zeichnungen oder Kommentare, die auf dem PDF angebracht wurden, wurden nicht als bearbeitbarer Inhalt übernommen.",
    decoLost: 'Ein Teil der Formatierung (Farben, Markierungen, Links, Unterstreichungen oder Tabellendetails) konnte nicht übernommen werden; der Text selbst ist vollständig.',
    formulaAlt: 'Formel',
    cancel: 'Abbrechen', cancelled: 'Abgebrochen.',
    xfaHybridNote: 'Hinweis: {0} ist ein hybrides XFA-Formular. Das Ergebnis behält die normalen Formularfelder, aber nicht die XFA-Version des Formulars (die nur einige PDF-Programme verwenden).',
    formRenamedNote: 'Hinweis: Einige Formularfelder in {0} wurden umbenannt (z. B. Name → Name_2), weil eine frühere Datei denselben Namen verwendet. Automatische Berechnungen in dieser Datei wurden ausgeschaltet, Summen werden also nicht mehr neu berechnet.',
    ownerNote: 'Hinweis: Dieses PDF hatte Bearbeitungsbeschränkungen (ein Besitzerpasswort). Es öffnet sich ohne Passwort und wurde daher verarbeitet; das Ergebnis hat diese Beschränkungen nicht mehr: {0}',
    certBroke: "Hinweis: {0} hatte eine digitale Signatur mit Zertifikat. Diese Signatur ist in der neuen Kopie nicht mehr gültig.",
    splitUncovered: "Hinweis: Diese Seiten sind in keiner der neuen Dateien: {0}.",
    compressNoImages: 'Dieses PDF enthält keine Bilder, daher macht die Komprimierungsstufe keinen Unterschied.',
    compressKept: '{0} – diese Datei ist bereits gut optimiert, Ihr Original bleibt daher unverändert',
    compressImagesUnsupported: '{0} – die Bilder in dieser Datei lassen sich hier nicht verkleinern (zum Beispiel Druckfarben (CMYK) oder sehr große Fotos), Ihr Original bleibt daher unverändert', // (v90) pcKeptText
    officeTooLarge: 'Diese Word- oder PowerPoint-Datei ist entpackt größer als {0} MB, zu viel für den Speicher dieses Geräts. Es wurde nichts geändert. Versuchen Sie es an einem Computer oder entfernen Sie zuerst große Videos oder Bilder aus der Datei.', // (v90) pcOpenOfficeZip
    compressInfo: '{0} ({1} % kleiner)',
    dpiCapped: 'Sehr große Seite(n): {0} wegen der Bildgrößen-Grenze des Browsers mit niedrigerer Auflösung ({1} DPI) gespeichert.',
    imageTooLarge: "Eine Seite ist zu groß, um in diesem Browser in ein Bild umgewandelt zu werden, selbst mit niedrigerer Auflösung. Versuchen Sie es an einem Computer oder teilen Sie das PDF zuerst.",
    finishFailed: "Die Datei konnte nicht korrekt fertiggestellt werden, daher wurde nichts gespeichert. Bitte versuchen Sie es erneut.",
    libLoadFailed: "Ein benötigter Baustein konnte nicht geladen werden. Prüfen Sie Ihre Verbindung (oder Ihren Werbeblocker) und versuchen Sie es erneut.",
    oldBrowser: "Dieses Tool braucht einen neueren Browser (auf iPhone und iPad: iOS 16.4 oder neuer). Aktualisieren Sie Ihren Browser oder Ihr System und versuchen Sie es erneut; die anderen Tools dieser Website funktionieren.",
    notPdfShort: "kein gültiges PDF",
    passwordShort: "passwortgeschützt",
    xfa: 'Dies ist ein dynamisches XFA-Formular, das die meisten PDF-Programme und diese Website nicht anzeigen können. Öffnen Sie es zuerst in einem PDF-Programm auf Ihrem Computer, das XFA-Formulare unterstützt, und drucken oder speichern Sie es als normales PDF.',
    mobileMemTooBig: 'Diese Aufgabe würde etwa {0} Speicher benötigen, mehr als der Browser eines Smartphones bereitstellen kann. Das Tool startet sie daher nicht. Verwenden Sie einen Computer oder teilen Sie die Datei zuerst in kleinere Teile.',
    xfaShort: 'ein dynamisches XFA-Formular, das hier nicht bearbeitet werden kann',
    mobileMemWarn: 'Auf einem Smartphone kann diese Aufgabe mehr Speicher benötigen, als der Browser erlaubt (etwa {0}), und die Seite kann neu geladen werden. Für so große Dateien ist ein Computer sicherer.',
    mobileMemStop: 'Diese Aufgabe würde etwa {0} Speicher benötigen, mehr als der Browser eines Smartphones bereitstellen kann. Sie wurde daher nicht gestartet. Verwenden Sie für diese Datei einen Computer oder teilen Sie sie zuerst in kleinere Teile.',
    largeFiles: "Diese Dateien sind zusammen {0} groß. Alles wird im Arbeitsspeicher Ihres Browsers verarbeitet, das kann also etwas dauern und auf einem älteren Gerät oder Smartphone langsam sein.",
    workerFailed: "Ihr Browser hat die Verarbeitung dieser Datei abgebrochen, wahrscheinlich wegen zu wenig Arbeitsspeicher. Schließen Sie andere Tabs oder Apps und versuchen Sie es erneut, oder verwenden Sie für sehr große Dateien einen Computer.",
    rotatePages: "Nur diese Seiten (optional, z. B. 1, 3-5; leer = alle Seiten)",
    // (v62) page previews (pc-thumbs.js)
    thumbsHint: "Oder tippen Sie auf die Seiten, um sie auszuwählen:", thumbsHintSplit: "Oder tippen Sie auf eine Seite, um danach zu teilen:", thumbsGroup: "Seitenvorschauen", thumbsPage: "Seite {0}", thumbsSplitAfter: "Nach Seite {0} teilen", thumbsSel0: "Keine Seiten ausgewählt", thumbsSel1: "1 Seite ausgewählt", thumbsSelN: "{0} Seiten ausgewählt", thumbsRotAll: "Keine Seiten ausgewählt: Alle Seiten werden gedreht", thumbsCut0: "Keine Trennstellen: Jede Seite wird eine eigene Datei", thumbsCut1: "1 Trennstelle: 2 Dateien", thumbsCutN: "{0} Trennstellen: {1} Dateien", thumbsRanges: "Sie haben Seitenbereiche eingegeben: Jeder Bereich wird eine eigene Datei. Leeren Sie das Feld, um Trennstellen auf den Seiten zu wählen.", thumbsMore: "Weitere Seiten anzeigen (noch {0})", thumbsMulti: "Seitenvorschauen erscheinen, wenn Sie ein einzelnes PDF hinzufügen. Die eingegebenen Seitenzahlen gelten für jede Datei.", thumbsFailed: "Für diese Datei können keine Seitenvorschauen angezeigt werden.", thumbsTooBig: "Diese Datei ist zu groß, um auf diesem Gerät Seitenvorschauen anzuzeigen. Geben Sie stattdessen die Seitenzahlen ein.",
    noText: "Dieses PDF hat keine Textebene (zum Beispiel ein Scan oder in Pfade umgewandelter Text), daher gibt es keinen bearbeitbaren Text. Wählen Sie „Identisches Layout“, um das Aussehen der Seiten zu behalten.",
    analyzingPages: 'Seiten werden analysiert ({0} von {1})…',
    analyzingDoc: 'Dokument wird analysiert ({0}\u00a0%)…',
    numPos: "Position", numPosOpts: "Unten Mitte|Unten rechts|Unten links|Oben Mitte|Oben rechts|Oben links", numStart: "Beginnen bei Nummer", numSkipFirst: "Erste Seite (Deckblatt) nicht nummerieren", numStartBad: "Geben Sie als Startnummer eine ganze Zahl von 0 bis 99999 ein.",
    numSize: "Größe",
    numSizeOpts: "Klein|Mittel|Groß",
    numColor: "Farbe",
    numColorOpts: "Grau|Schwarz|Weiß|Blau|Rot",
    numNoPages: "Keine der gewählten Seiten bekommt eine Nummer. Prüfen Sie die Seitenliste.",
    splitRange: 'Verwenden Sie Seitenzahlen oder Bereiche, getrennt durch Kommas, z. B. „3, 7“ oder „1-3, 4-10“.',
    splitEvery: "Oder: alle … Seiten eine neue Datei (optional)",
    splitEveryBad: "Geben Sie eine ganze Seitenzahl ein, zum Beispiel 2.",
    splitEveryBoth: "Füllen Sie nur eines der beiden Felder aus: wo geteilt wird oder alle wie viele Seiten.",
    splitEveryAll: "Diese Datei hat {0} Seiten: alle {1} Seiten ergibt nur eine Datei. Geben Sie eine kleinere Zahl ein.",
    tabDone: 'Fertig', tabFailed: 'Fehlgeschlagen', // (v95) tab title after a job
    staleRelease: "PDFCommunity wurde gerade aktualisiert. Laden Sie diese Seite neu (Ihre Dateien werden nicht behalten) und versuchen Sie es erneut." // (v96) pcLoadLib
  },
  es: {
    // (v98) messages that i18n-runtime.js used to translate with regexes (l90-i18n)
    infoPages1: "1 página, {0}", infoPagesN: "{0} páginas, {1}", pageOfTotal: "Página {0} de {1}", stMerging: "Uniendo…", stCompressing: "Comprimiendo…", stConverting: "Convirtiendo…", stSplitting: "Dividiendo…", stRotating: "Rotando…", stNumbering: "Añadiendo números de página…", stRemoving: "Eliminando páginas…", stDone: "¡Listo!", stDoneSkippedOpen: "Listo, pero se omitieron (no se pudieron abrir): {0}", stDoneSkipped: "Listo, pero se omitieron: {0}", infoMerged: "{0} archivos unidos, {1}", infoWordText1: "1 página, {0} – texto editable", infoWordTextN: "{0} páginas, {1} – texto editable", infoWordImg1: "1 página, {0} – diseño idéntico (imágenes)", infoWordImgN: "{0} páginas, {1} – diseño idéntico (imágenes)", infoPptText1: "1 diapositiva, {0} – texto editable", infoPptTextN: "{0} diapositivas, {1} – texto editable", infoPptImg1: "1 diapositiva, {0} – diseño idéntico (imágenes)", infoPptImgN: "{0} diapositivas, {1} – diseño idéntico (imágenes)", stFilePage: "Archivo {0} de {1} ({2}) – página {3} de {4}…", stFileFinishing: "Archivo {0} de {1} ({2}) – terminando el archivo…", stFileOf: "Archivo {0} de {1}: {2}", stPage: "Procesando página {0} de {1}…", stFinishing: "Terminando el archivo…", stZip: "Reuniendo los {0} archivos en un solo zip…", stLast: "Último paso: preparando el archivo para descargar…", infoZipCompressed: "{0} archivos comprimidos, reunidos en un solo zip", infoZipCompressedTotal: "{0} archivos comprimidos: {1} → {2} ({3} % más pequeño), reunidos en un solo zip", infoZipConverted: "{0} archivos convertidos, reunidos en un solo zip", compressInfoImg: "{0} ({1} % más pequeño, {2} imagen(es) reducida(s))", infoCreated1: "1 archivo creado", infoCreatedN: "{0} archivos creados", infoRotated1: "1 archivo rotado", infoRotatedN: "{0} archivos rotados", infoNumbered1: "1 archivo numerado", infoNumberedN: "{0} archivos numerados", infoUpdated1: "1 archivo modificado", infoUpdatedN: "{0} archivos modificados", errPwUse: "Este archivo está protegido con contraseña. Procésalo por separado para escribir su contraseña, o quita primero la contraseña (p. ej. con Desbloquear PDF en este sitio).", errPwSplit: "Este archivo está protegido con contraseña. Procésalo por separado para escribir su contraseña, o quita primero la contraseña (p. ej. con Desbloquear PDF en este sitio).", errPwRotate: "Este archivo está protegido con contraseña. Procésalo por separado para escribir su contraseña, o quita primero la contraseña (p. ej. con Desbloquear PDF en este sitio).", errPwNumbers: "Este archivo está protegido con contraseña. Procésalo por separado para escribir su contraseña, o quita primero la contraseña (p. ej. con Desbloquear PDF en este sitio).", errPwDelete: "Este archivo está protegido con contraseña. Procésalo por separado para escribir su contraseña, o quita primero la contraseña (p. ej. con Desbloquear PDF en este sitio).", errInvalidPdf: "No se pudo procesar este archivo. ¿Es un PDF válido?", errInvalidWord: "No se pudo procesar este archivo. ¿Es un documento Word válido?", errInvalidPpt: "No se pudo procesar este archivo. ¿Es un archivo de PowerPoint válido?", errNoneSplit: "No se pudo dividir ninguno de los archivos. ¿Son archivos PDF válidos?", errNoneRotated: "No se pudo rotar ninguno de los archivos. ¿Son archivos PDF válidos?", errNoneProcessed: "No se pudo procesar ninguno de los archivos. ¿Son archivos PDF válidos?", errSkipSplit: "No se pudo dividir: {0}", errSkipConvert: "No se pudo convertir: {0}", errSkipCompress: "No se pudo comprimir: {0}", errSkipRotate: "No se pudo rotar: {0}", errSkipNumbers: "No se pudieron añadir números de página: {0}", errSkipDelete: "No se pudieron eliminar páginas: {0}", errMergeOpen: "No se pudo abrir: {0}. Se necesitan al menos 2 archivos válidos para unir.", errMergeOpenAll: "No se pudieron abrir estos archivos.", errDeleteNeed: "Escribe al menos un número de página válido para eliminar (p. ej. “2, 5-7”).", errDeleteAll: "No puedes eliminar todas las páginas: el resultado sería un PDF vacío.", pwAsk: "Este archivo está protegido con contraseña. Escríbela abajo y vuelve a intentarlo. Se queda en tu navegador.", pwWrong: "Esa contraseña no es correcta para este archivo. Escríbela de nuevo.", pwLabel: "Contraseña del PDF", pwRetry: "Reintentar", pwRemovedNote: "El resultado ya no tiene contraseña. Para protegerlo de nuevo, usa Proteger PDF.", compressCmykNote: "Los colores de impresión (CMYK) se han convertido en colores de pantalla (RGB) en: {0}. Los colores pueden verse algo distintos; para una imprenta, usa el original o Ligera.",
    outOfMemory: "Tu navegador se quedó sin memoria o ya no pudo leer el archivo, así que no se guardó nada. Cierra otras pestañas o aplicaciones, vuelve a elegir el archivo e inténtalo de nuevo, o hazlo por partes (por ejemplo, menos páginas a la vez).", // (v73) friendlyPdfError
    pdfjsDataMissing: "No se pudo cargar un archivo de fuente que necesita este PDF (¿sin conexión?): faltaría parte del texto, así que no se guardó nada. Comprueba tu conexión, recarga la página e inténtalo de nuevo.", // (v157) pcPdfJsMissed
    fileGone: "Ya no se puede leer este archivo. Probablemente se movió, se renombró o se eliminó después de elegirlo. Vuelve a elegirlo e inténtalo de nuevo.", // (v89) friendlyPdfError: the chosen file is no longer on the device
    wrongType: "No añadido: {0}. Esta herramienta no admite ese tipo de archivo.", emptyFile: "No añadido: {0}. El archivo está vacío (0 bytes).", // (v89) pcTakeUsable: a file left out when dropped or picked
    // (v73, q16) share menu for several result files (pcOfferShare)
    shareFiles: "Guardar los {0} archivos por separado",
    shareHint: "Abre el menú de compartir de tu dispositivo para guardar cada archivo por separado (en iPhone: «Guardar en Archivos», o «Guardar imágenes» para las imágenes). El botón de descarga de arriba da los mismos archivos en un solo zip.",
    shareFailed: "No se pudo abrir el menú de compartir. Usa el botón de descarga de arriba: el zip contiene los mismos archivos.",
    // (v62) "What next?" block under a result (pcOfferNextSteps)
    nextTitle: "¿Y ahora qué?",
    nextSub: "Sigue con {0} en otra herramienta. No tienes que volver a elegirlo y no se sube.",
    nextTool_merge: "Unir con otros PDF",
    nextTool_compress: "Comprimir",
    nextTool_word: "Convertir a Word",
    nextTool_sign: "Firmar",
    nextTool_protect: "Añadir una contraseña",
    nextTool_numbers: "Numerar páginas",
    nextTool_nup: "Varias páginas por hoja", nextTool_org: "Ordenar las páginas", nextTool_txt: "Guardar como texto", nextTool_meta: "Borrar metadatos", nextTool_fill: "Rellenar un formulario o añadir texto", nextTool_flatten: "Aplanar campos y comentarios", nextTool_redact: "Censurar texto", nextTool_ocr: "Hacer buscable (OCR)",
    nextFromStep: "Archivo del paso anterior: {0}",
    nextOthersCleared: "Los demás archivos que habías elegido ya no están en la lista.",
    nextNoFile: "No se pudo pasar el archivo del paso anterior, porque tu navegador no permite que este sitio lo guarde un momento (por ejemplo, en una ventana privada). Vuelve a elegir el archivo.",
    pageMissing: 'La página {0} no existe: este documento tiene {1} páginas.',
    pageMissingOne: 'La página {0} no existe: este documento solo tiene 1 página.',
    pageBadInput: 'No se entiende “{0}”. Usa comas, p. ej. 2, 5-7.',
    splitPointRange: 'Para dividir, usa números de página del 1 al {0} (este documento tiene {1} páginas).',
    splitOnePage: 'Este documento solo tiene 1 página, así que no hay nada que dividir.',
    numbersNone: 'No hay páginas que numerar: el documento solo tiene la portada.',
    truncated: 'Este PDF parece incompleto o dañado: le faltan partes (¿se interrumpió la descarga?). Descárgalo de nuevo y vuelve a intentarlo.',
    pdfConflict: "Este PDF contiene dos versiones distintas de la misma parte, así que no se sabe con seguridad cuál es la página correcta. Ábrelo en un lector de PDF, guárdalo como un PDF nuevo (o imprímelo en PDF) y vuelve a intentarlo.", compressRepaired: "{0} estaba dañado (por ejemplo, su tabla interna faltaba o era incorrecta). La copia está reparada, así que también se abre en programas que no podían abrir el original.", // (v157) pcResolveDuplicates, pcOriginalIntact
    officeWrongKind: 'No es un archivo {0} válido. ¿Es correcta la extensión del archivo?',
    simplified: 'Algunos elementos (como fórmulas o gráficos densos) se han incluido como imágenes, por lo que no se pueden editar como texto.',
    formLost: "No se pudieron leer los valores escritos en algunos campos de formulario, así que faltan en el resultado.",
    annotSkipped: "Los sellos, dibujos o comentarios añadidos encima del PDF no se han pasado como contenido editable.",
    decoLost: 'Parte del formato (colores, resaltados, enlaces, subrayados o detalles de tablas) no se pudo conservar; el texto en sí está completo.',
    formulaAlt: 'Fórmula',
    cancel: 'Cancelar', cancelled: 'Cancelado.',
    xfaHybridNote: 'Nota: {0} es un formulario XFA híbrido. El resultado conserva los campos de formulario normales, pero no la versión XFA del formulario (solo la usan algunos programas de PDF).',
    formRenamedNote: 'Nota: se cambió el nombre de algunos campos de formulario de {0} (por ejemplo nombre → nombre_2), porque un archivo anterior usa el mismo nombre. Los cálculos automáticos de ese archivo se han desactivado, así que sus totales ya no se recalculan.',
    ownerNote: 'Nota: este PDF tenía restricciones de edición (una contraseña de propietario). Se abre sin contraseña, así que se ha procesado; el resultado ya no tiene esas restricciones: {0}',
    certBroke: "Atención: {0} tenía una firma digital con certificado. Esa firma ya no es válida en la nueva copia.",
    splitUncovered: "Atención: estas páginas no están en ninguno de los archivos nuevos: {0}.",
    compressNoImages: 'Este PDF no contiene imágenes, así que el nivel de compresión no cambia nada.',
    compressKept: '{0} – este archivo ya está bien optimizado, así que tu original se conserva sin cambios',
    compressImagesUnsupported: '{0} – las imágenes de este archivo no se pueden reducir aquí (por ejemplo, colores de impresión (CMYK) o fotos muy grandes), así que tu original se conserva sin cambios', // (v90) pcKeptText
    officeTooLarge: 'Este archivo de Word o PowerPoint ocupa más de {0} MB al descomprimirlo, demasiado para la memoria de este dispositivo. No se ha cambiado nada. Inténtalo en un ordenador o quita antes los vídeos o imágenes grandes del archivo.', // (v90) pcOpenOfficeZip
    compressInfo: '{0} ({1} % más pequeño)',
    dpiCapped: 'Página(s) muy grande(s): {0} guardada(s) con menor resolución ({1} DPI) por el límite de tamaño de imagen del navegador.',
    imageTooLarge: "Una página es demasiado grande para convertirla en imagen en este navegador, incluso con menor resolución. Inténtalo en un ordenador o divide primero el PDF.",
    finishFailed: "No se pudo terminar el archivo correctamente, así que no se guardó nada. Inténtalo de nuevo.",
    libLoadFailed: "No se pudo cargar un componente necesario. Revisa tu conexión (o tu bloqueador de anuncios) e inténtalo de nuevo.",
    oldBrowser: "Esta herramienta necesita un navegador más reciente (en iPhone y iPad: iOS 16.4 o posterior). Actualiza tu navegador o tu sistema e inténtalo de nuevo; las demás herramientas del sitio sí funcionan.",
    notPdfShort: "no es un PDF válido",
    passwordShort: "protegido con contraseña",
    xfa: 'Es un formulario XFA dinámico, que la mayoría de los programas de PDF y este sitio no pueden mostrar. Ábrelo primero en un programa de PDF de escritorio compatible con formularios XFA e imprímelo o guárdalo como PDF normal.',
    mobileMemTooBig: 'Esta tarea necesitaría unos {0} de memoria, más de lo que puede dar el navegador de un móvil, así que la herramienta no la iniciará. Usa un ordenador o divide primero el archivo en partes más pequeñas.',
    xfaShort: 'un formulario XFA dinámico, que no se puede editar aquí',
    mobileMemWarn: 'En un móvil, esta tarea puede necesitar más memoria de la que permite el navegador (unos {0}) y la página puede recargarse. Para archivos tan grandes es más seguro un ordenador.',
    mobileMemStop: 'Esta tarea necesitaría unos {0} de memoria, más de lo que puede dar el navegador de un móvil, así que no se ha iniciado. Usa un ordenador para este archivo o divídelo primero en partes más pequeñas.',
    largeFiles: "Estos archivos suman {0}. Todo se procesa en la memoria de tu navegador, así que puede tardar un poco y ser lento en un dispositivo antiguo o en el móvil.",
    workerFailed: "Tu navegador dejó de procesar este archivo, probablemente por falta de memoria. Cierra otras pestañas o aplicaciones y vuelve a intentarlo, o usa un ordenador para archivos muy grandes.",
    rotatePages: "Solo estas páginas (opcional, p. ej. 1, 3-5; vacío = todas)",
    // (v62) page previews (pc-thumbs.js)
    thumbsHint: "O toca las páginas para seleccionarlas:", thumbsHintSplit: "O toca una página para dividir después de ella:", thumbsGroup: "Vistas previas de las páginas", thumbsPage: "Página {0}", thumbsSplitAfter: "Dividir después de la página {0}", thumbsSel0: "Ninguna página seleccionada", thumbsSel1: "1 página seleccionada", thumbsSelN: "{0} páginas seleccionadas", thumbsRotAll: "Ninguna página seleccionada: se girarán todas las páginas", thumbsCut0: "Sin puntos de división: cada página será un archivo aparte", thumbsCut1: "1 punto de división: 2 archivos", thumbsCutN: "{0} puntos de división: {1} archivos", thumbsRanges: "Has escrito rangos de páginas: cada rango será un archivo aparte. Vacía el campo para elegir los puntos de división en las páginas.", thumbsMore: "Mostrar más páginas (quedan {0})", thumbsMulti: "Las vistas previas de las páginas aparecen cuando añades un solo PDF. Los números de página que escribas se aplican a cada archivo.", thumbsFailed: "No se pueden mostrar vistas previas de las páginas de este archivo.", thumbsTooBig: "Este archivo es demasiado grande para mostrar vistas previas de las páginas en este dispositivo. Escribe los números de página.",
    noText: "Este PDF no tiene capa de texto (por ejemplo, un escaneo o texto convertido en trazados), así que no hay texto editable que convertir. Elige “Diseño idéntico” para conservar el aspecto de las páginas.",
    analyzingPages: 'Analizando páginas ({0} de {1})…',
    analyzingDoc: 'Analizando el documento ({0}\u00a0%)…',
    numPos: "Posición", numPosOpts: "Abajo centro|Abajo derecha|Abajo izquierda|Arriba centro|Arriba derecha|Arriba izquierda", numStart: "Empezar en el número", numSkipFirst: "No numerar la primera página (portada)", numStartBad: "Escribe un número entero de 0 a 99999 como número inicial.",
    numSize: "Tamaño",
    numSizeOpts: "Pequeño|Mediano|Grande",
    numColor: "Color",
    numColorOpts: "Gris|Negro|Blanco|Azul|Rojo",
    numNoPages: "Ninguna de las páginas elegidas recibe número. Revisa la lista de páginas.",
    splitRange: 'Usa números de página o rangos separados por comas, p. ej. “3, 7” o “1-3, 4-10”.',
    splitEvery: "O bien: un archivo nuevo cada … páginas (opcional)",
    splitEveryBad: "Escribe un número entero de páginas, por ejemplo 2.",
    splitEveryBoth: "Rellena solo uno de los dos campos: dónde dividir o cada cuántas páginas.",
    splitEveryAll: "Este archivo tiene {0} páginas: cada {1} páginas da un solo archivo. Escribe un número menor.",
    tabDone: 'Listo', tabFailed: 'Error', // (v95) tab title after a job
    staleRelease: "PDFCommunity se acaba de actualizar. Vuelve a cargar esta página (tus archivos no se conservan) e inténtalo de nuevo." // (v96) pcLoadLib
  },
  pt: {
    // (v98) messages that i18n-runtime.js used to translate with regexes (l90-i18n)
    infoPages1: "1 página, {0}", infoPagesN: "{0} páginas, {1}", pageOfTotal: "Página {0} de {1}", stMerging: "Juntando…", stCompressing: "Comprimindo…", stConverting: "Convertendo…", stSplitting: "Dividindo…", stRotating: "Girando…", stNumbering: "Adicionando números de página…", stRemoving: "Excluindo páginas…", stDone: "Pronto!", stDoneSkippedOpen: "Pronto, mas foram ignorados (não puderam ser abertos): {0}", stDoneSkipped: "Pronto, mas foram ignorados: {0}", infoMerged: "{0} arquivos juntados, {1}", infoWordText1: "1 página, {0} – texto editável", infoWordTextN: "{0} páginas, {1} – texto editável", infoWordImg1: "1 página, {0} – layout idêntico (imagens)", infoWordImgN: "{0} páginas, {1} – layout idêntico (imagens)", infoPptText1: "1 slide, {0} – texto editável", infoPptTextN: "{0} slides, {1} – texto editável", infoPptImg1: "1 slide, {0} – layout idêntico (imagens)", infoPptImgN: "{0} slides, {1} – layout idêntico (imagens)", stFilePage: "Arquivo {0} de {1} ({2}) – página {3} de {4}…", stFileFinishing: "Arquivo {0} de {1} ({2}) – finalizando o arquivo…", stFileOf: "Arquivo {0} de {1}: {2}", stPage: "Processando página {0} de {1}…", stFinishing: "Finalizando o arquivo…", stZip: "Reunindo os {0} arquivos em um único zip…", stLast: "Última etapa – preparando o arquivo para download…", infoZipCompressed: "{0} arquivos comprimidos, reunidos em um único zip", infoZipCompressedTotal: "{0} arquivos comprimidos: {1} → {2} ({3}% menor), reunidos em um único zip", infoZipConverted: "{0} arquivos convertidos, reunidos em um único zip", compressInfoImg: "{0} ({1}% menor, {2} imagem(ns) reduzida(s))", infoCreated1: "1 arquivo criado", infoCreatedN: "{0} arquivos criados", infoRotated1: "1 arquivo girado", infoRotatedN: "{0} arquivos girados", infoNumbered1: "1 arquivo numerado", infoNumberedN: "{0} arquivos numerados", infoUpdated1: "1 arquivo alterado", infoUpdatedN: "{0} arquivos alterados", errPwUse: "Este arquivo é protegido por senha. Processe-o separadamente para digitar a senha, ou remova a senha primeiro (por ex. com Desbloquear PDF neste site).", errPwSplit: "Este arquivo é protegido por senha. Processe-o separadamente para digitar a senha, ou remova a senha primeiro (por ex. com Desbloquear PDF neste site).", errPwRotate: "Este arquivo é protegido por senha. Processe-o separadamente para digitar a senha, ou remova a senha primeiro (por ex. com Desbloquear PDF neste site).", errPwNumbers: "Este arquivo é protegido por senha. Processe-o separadamente para digitar a senha, ou remova a senha primeiro (por ex. com Desbloquear PDF neste site).", errPwDelete: "Este arquivo é protegido por senha. Processe-o separadamente para digitar a senha, ou remova a senha primeiro (por ex. com Desbloquear PDF neste site).", errInvalidPdf: "Não foi possível processar este arquivo. Ele é um PDF válido?", errInvalidWord: "Não foi possível processar este arquivo. Ele é um documento Word válido?", errInvalidPpt: "Não foi possível processar este arquivo. Ele é um arquivo de PowerPoint válido?", errNoneSplit: "Nenhum dos arquivos pôde ser dividido. Eles são PDFs válidos?", errNoneRotated: "Nenhum dos arquivos pôde ser girado. Eles são PDFs válidos?", errNoneProcessed: "Nenhum dos arquivos pôde ser processado. Eles são PDFs válidos?", errSkipSplit: "Não foi possível dividir: {0}", errSkipConvert: "Não foi possível converter: {0}", errSkipCompress: "Não foi possível comprimir: {0}", errSkipRotate: "Não foi possível girar: {0}", errSkipNumbers: "Não foi possível adicionar números de página: {0}", errSkipDelete: "Não foi possível excluir páginas: {0}", errMergeOpen: "Não foi possível abrir: {0}. São necessários pelo menos 2 arquivos válidos para juntar.", errMergeOpenAll: "Não foi possível abrir estes arquivos.", errDeleteNeed: "Digite pelo menos um número de página válido para excluir (por ex. “2, 5-7”).", errDeleteAll: "Não é possível excluir todas as páginas – o resultado seria um PDF vazio.", pwAsk: "Este arquivo é protegido por senha. Digite a senha abaixo e tente de novo. Ela fica no seu navegador.", pwWrong: "Essa senha não está correta para este arquivo. Digite-a de novo.", pwLabel: "Senha do PDF", pwRetry: "Tentar de novo", pwRemovedNote: "O resultado não tem mais senha. Para protegê-lo de novo, use Proteger PDF.", compressCmykNote: "As cores de impressão (CMYK) foram convertidas em cores de tela (RGB) em: {0}. As cores podem ficar um pouco diferentes; para uma gráfica, use o original ou Leve.",
    outOfMemory: "Seu navegador ficou sem memória ou não conseguiu mais ler o arquivo, então nada foi salvo. Feche outras abas ou aplicativos, escolha o arquivo de novo e tente outra vez, ou faça em partes menores (por exemplo, menos páginas de cada vez).", // (v73) friendlyPdfError
    pdfjsDataMissing: "Não foi possível carregar um arquivo de fonte de que este PDF precisa (sem conexão?): faltaria parte do texto, então nada foi salvo. Verifique sua conexão, recarregue a página e tente de novo.", // (v157) pcPdfJsMissed
    fileGone: "Não é mais possível ler este arquivo. Provavelmente ele foi movido, renomeado ou excluído depois que você o escolheu. Escolha-o de novo e tente outra vez.", // (v89) friendlyPdfError: the chosen file is no longer on the device
    wrongType: "Não adicionado: {0}. Esta ferramenta não aceita esse tipo de arquivo.", emptyFile: "Não adicionado: {0}. O arquivo está vazio (0 bytes).", // (v89) pcTakeUsable: a file left out when dropped or picked
    // (v73, q16) share menu for several result files (pcOfferShare)
    shareFiles: "Salvar os {0} arquivos separadamente",
    shareHint: "Abre o menu de compartilhamento do seu aparelho para salvar cada arquivo separadamente (no iPhone: “Salvar em Arquivos”, ou “Salvar Imagens” para imagens). O botão de download acima traz os mesmos arquivos em um único zip.",
    shareFailed: "Não foi possível abrir o menu de compartilhamento. Use o botão de download acima: o zip contém os mesmos arquivos.",
    // (v62) "What next?" block under a result (pcOfferNextSteps)
    nextTitle: "E agora?",
    nextSub: "Continue com {0} em outra ferramenta. Você não precisa escolher o arquivo de novo, e ele não é enviado.",
    nextTool_merge: "Juntar com outros PDFs",
    nextTool_compress: "Comprimir",
    nextTool_word: "Converter para Word",
    nextTool_sign: "Assinar",
    nextTool_protect: "Adicionar senha",
    nextTool_numbers: "Numerar páginas",
    nextTool_nup: "Várias páginas por folha", nextTool_org: "Organizar as páginas", nextTool_txt: "Salvar como texto", nextTool_meta: "Remover metadados", nextTool_fill: "Preencher um formulário ou adicionar texto", nextTool_flatten: "Achatar campos e comentários", nextTool_redact: "Tarjar texto", nextTool_ocr: "Tornar pesquisável (OCR)",
    nextFromStep: "Arquivo da etapa anterior: {0}",
    nextOthersCleared: "Os outros arquivos que você tinha escolhido não estão mais na lista.",
    nextNoFile: "Não foi possível passar o arquivo da etapa anterior, porque seu navegador não permite que este site o guarde por um instante (por exemplo, em uma janela anônima). Escolha o arquivo de novo.",
    pageMissing: 'A página {0} não existe: este documento tem {1} páginas.',
    pageMissingOne: 'A página {0} não existe: este documento tem só 1 página.',
    pageBadInput: 'Não foi possível entender “{0}”. Use vírgulas, por ex. 2, 5-7.',
    splitPointRange: 'Para dividir, use números de página de 1 a {0} (este documento tem {1} páginas).',
    splitOnePage: 'Este documento tem só 1 página, então não há nada para dividir.',
    numbersNone: 'Não há páginas para numerar: o documento tem apenas a capa.',
    truncated: 'Este PDF parece incompleto ou danificado: faltam partes dele (o download foi interrompido?). Baixe-o novamente e tente outra vez.',
    pdfConflict: "Este PDF contém duas versões diferentes da mesma parte, então não é certo qual página é a verdadeira. Abra-o em um leitor de PDF, salve-o como um novo PDF (ou imprima-o em PDF) e tente novamente.", compressRepaired: "{0} estava danificado (por exemplo, a tabela interna faltava ou estava errada). A cópia foi reparada, então também abre em programas que não conseguiam abrir o original.", // (v157) pcResolveDuplicates, pcOriginalIntact
    officeWrongKind: 'Este não é um arquivo {0} válido. A extensão do arquivo está correta?',
    simplified: 'Alguns elementos (como fórmulas ou gráficos densos) foram mantidos como imagens, então não podem ser editados como texto.',
    formLost: "Não foi possível ler os valores digitados em alguns campos de formulário, então eles não aparecem no resultado.",
    annotSkipped: "Carimbos, desenhos ou comentários adicionados por cima do PDF não foram passados como conteúdo editável.",
    decoLost: 'Parte da formatação (cores, destaques, links, sublinhados ou detalhes de tabelas) não pôde ser mantida; o texto em si está completo.',
    formulaAlt: 'Fórmula',
    cancel: 'Cancelar', cancelled: 'Cancelado.',
    xfaHybridNote: 'Observação: {0} é um formulário XFA híbrido. O resultado mantém os campos de formulário normais, mas não a versão XFA do formulário (que só alguns programas de PDF usam).',
    formRenamedNote: 'Observação: alguns campos de formulário de {0} foram renomeados (por exemplo nome → nome_2), porque um arquivo anterior usa o mesmo nome. Os cálculos automáticos desse arquivo foram desativados, então os totais não são mais recalculados.',
    ownerNote: 'Observação: este PDF tinha restrições de edição (uma senha de proprietário). Ele abre sem senha, por isso foi processado; o resultado não tem mais essas restrições: {0}',
    certBroke: "Atenção: {0} tinha uma assinatura digital com certificado. Essa assinatura não é mais válida na nova cópia.",
    splitUncovered: "Atenção: estas páginas não estão em nenhum dos novos arquivos: {0}.",
    compressNoImages: 'Este PDF não contém imagens, então o nível de compressão não faz diferença.',
    compressKept: '{0} – este arquivo já está bem otimizado, então seu original foi mantido sem alterações',
    compressImagesUnsupported: '{0} – as imagens deste arquivo não podem ser reduzidas aqui (por exemplo, cores de impressão (CMYK) ou fotos muito grandes), então seu original foi mantido sem alterações', // (v90) pcKeptText
    officeTooLarge: 'Este arquivo do Word ou PowerPoint passa de {0} MB ao ser descompactado, demais para a memória deste aparelho. Nada foi alterado. Tente em um computador ou remova antes os vídeos ou imagens grandes do arquivo.', // (v90) pcOpenOfficeZip
    compressInfo: '{0} ({1}% menor)',
    dpiCapped: 'Página(s) muito grande(s): {0} salva(s) com resolução menor ({1} DPI) por causa do limite de tamanho de imagem do navegador.',
    imageTooLarge: "Uma página é grande demais para virar imagem neste navegador, mesmo com resolução menor. Tente em um computador ou divida o PDF primeiro.",
    finishFailed: "Não foi possível finalizar o arquivo corretamente, então nada foi salvo. Tente de novo.",
    libLoadFailed: "Não foi possível carregar um componente necessário. Verifique sua conexão (ou bloqueador de anúncios) e tente novamente.",
    oldBrowser: "Esta ferramenta precisa de um navegador mais recente (no iPhone e iPad: iOS 16.4 ou posterior). Atualize seu navegador ou sistema e tente novamente; as outras ferramentas do site funcionam.",
    notPdfShort: "não é um PDF válido",
    passwordShort: "protegido por senha",
    xfa: 'Este é um formulário XFA dinâmico, que a maioria dos programas de PDF e este site não conseguem exibir. Abra-o primeiro em um programa de PDF para computador compatível com formulários XFA e imprima ou salve como PDF normal.',
    mobileMemTooBig: 'Esta tarefa precisaria de cerca de {0} de memória, mais do que o navegador de um celular consegue oferecer, por isso a ferramenta não vai iniciá-la. Use um computador ou divida primeiro o arquivo em partes menores.',
    xfaShort: 'um formulário XFA dinâmico, que não pode ser editado aqui',
    mobileMemWarn: 'Em um celular, esta tarefa pode exigir mais memória do que o navegador permite (cerca de {0}), e a página pode recarregar. Para arquivos tão grandes, um computador é mais seguro.',
    mobileMemStop: 'Esta tarefa precisaria de cerca de {0} de memória, mais do que o navegador de um celular consegue oferecer, por isso não foi iniciada. Use um computador para este arquivo ou divida-o primeiro em partes menores.',
    largeFiles: "Estes arquivos somam {0}. Tudo é processado na memória do seu navegador, então pode demorar um pouco e ficar lento em um aparelho mais antigo ou no celular.",
    workerFailed: "Seu navegador parou de processar este arquivo, provavelmente por falta de memória. Feche outras abas ou aplicativos e tente de novo, ou use um computador para arquivos muito grandes.",
    rotatePages: "Somente estas páginas (opcional, por ex. 1, 3-5; vazio = todas)",
    // (v62) page previews (pc-thumbs.js)
    thumbsHint: "Ou toque nas páginas para selecioná-las:", thumbsHintSplit: "Ou toque em uma página para dividir depois dela:", thumbsGroup: "Prévias das páginas", thumbsPage: "Página {0}", thumbsSplitAfter: "Dividir depois da página {0}", thumbsSel0: "Nenhuma página selecionada", thumbsSel1: "1 página selecionada", thumbsSelN: "{0} páginas selecionadas", thumbsRotAll: "Nenhuma página selecionada: todas as páginas serão giradas", thumbsCut0: "Sem pontos de divisão: cada página vira um arquivo separado", thumbsCut1: "1 ponto de divisão: 2 arquivos", thumbsCutN: "{0} pontos de divisão: {1} arquivos", thumbsRanges: "Você digitou intervalos de páginas: cada intervalo vira um arquivo separado. Esvazie o campo para escolher os pontos de divisão nas páginas.", thumbsMore: "Mostrar mais páginas (faltam {0})", thumbsMulti: "As prévias das páginas aparecem quando você adiciona um único PDF. Os números de página digitados valem para todos os arquivos.", thumbsFailed: "Não é possível mostrar prévias das páginas deste arquivo.", thumbsTooBig: "Este arquivo é grande demais para mostrar prévias das páginas neste dispositivo. Digite os números das páginas.",
    noText: "Este PDF não tem camada de texto (por exemplo, uma digitalização ou texto convertido em contornos), então não há texto editável para converter. Escolha “Layout idêntico” para manter a aparência das páginas.",
    analyzingPages: 'Analisando páginas ({0} de {1})…',
    analyzingDoc: 'Analisando o documento ({0}%)…',
    numPos: "Posição", numPosOpts: "Embaixo no centro|Embaixo à direita|Embaixo à esquerda|Em cima no centro|Em cima à direita|Em cima à esquerda", numStart: "Começar no número", numSkipFirst: "Não numerar a primeira página (capa)", numStartBad: "Digite um número inteiro de 0 a 99999 como número inicial.",
    numSize: "Tamanho",
    numSizeOpts: "Pequeno|Médio|Grande",
    numColor: "Cor",
    numColorOpts: "Cinza|Preto|Branco|Azul|Vermelho",
    numNoPages: "Nenhuma das páginas escolhidas recebe número. Verifique a lista de páginas.",
    splitRange: 'Use números de página ou intervalos separados por vírgulas, por ex. “3, 7” ou “1-3, 4-10”.',
    splitEvery: "Ou: um novo arquivo a cada … páginas (opcional)",
    splitEveryBad: "Digite um número inteiro de páginas, por exemplo 2.",
    splitEveryBoth: "Preencha só um dos dois campos: onde dividir ou a cada quantas páginas.",
    splitEveryAll: "Este arquivo tem {0} páginas: a cada {1} páginas dá um só arquivo. Digite um número menor.",
    tabDone: 'Pronto', tabFailed: 'Erro', // (v95) tab title after a job
    staleRelease: "O PDFCommunity acabou de ser atualizado. Recarregue esta página (seus arquivos não são mantidos) e tente novamente." // (v96) pcLoadLib
  }, it: {
    // (v98) messages that i18n-runtime.js used to translate with regexes (l90-i18n)
    infoPages1: "1 pagina, {0}", infoPagesN: "{0} pagine, {1}", pageOfTotal: "Pagina {0} di {1}", stMerging: "Unione in corso…", stCompressing: "Compressione in corso…", stConverting: "Conversione in corso…", stSplitting: "Divisione in corso…", stRotating: "Rotazione in corso…", stNumbering: "Aggiunta dei numeri di pagina…", stRemoving: "Eliminazione delle pagine…", stDone: "Fatto!", stDoneSkippedOpen: "Fatto, ma saltati (impossibile aprirli): {0}", stDoneSkipped: "Fatto, ma saltati: {0}", infoMerged: "{0} file uniti, {1}", infoWordText1: "1 pagina, {0} — testo modificabile", infoWordTextN: "{0} pagine, {1} — testo modificabile", infoWordImg1: "1 pagina, {0} — layout identico (immagini)", infoWordImgN: "{0} pagine, {1} — layout identico (immagini)", infoPptText1: "1 diapositiva, {0} — testo modificabile", infoPptTextN: "{0} diapositive, {1} — testo modificabile", infoPptImg1: "1 diapositiva, {0} — layout identico (immagini)", infoPptImgN: "{0} diapositive, {1} — layout identico (immagini)", stFilePage: "File {0} di {1} ({2}) — pagina {3} di {4}…", stFileFinishing: "File {0} di {1} ({2}) — completamento del file…", stFileOf: "File {0} di {1}: {2}", stPage: "Elaborazione della pagina {0} di {1}…", stFinishing: "Completamento del file…", stZip: "Raccolta di tutti i {0} file in un unico zip…", stLast: "Ultimo passaggio — preparazione del file per il download…", infoZipCompressed: "{0} file compressi, raccolti in un unico zip", infoZipCompressedTotal: "{0} file compressi: {1} → {2} ({3}% più piccoli), raccolti in un unico zip", infoZipConverted: "{0} file convertiti, raccolti in un unico zip", compressInfoImg: "{0} ({1}% più piccolo, immagini ridotte: {2})", infoCreated1: "1 file creato", infoCreatedN: "{0} file creati", infoRotated1: "1 file ruotato", infoRotatedN: "{0} file ruotati", infoNumbered1: "1 file numerato", infoNumberedN: "{0} file numerati", infoUpdated1: "1 file aggiornato", infoUpdatedN: "{0} file aggiornati", errPwUse: "Questo file è protetto da password. Elaboralo da solo per digitare la password, oppure rimuovi prima la password (per es. con Sbloccare PDF su questo sito).", errPwSplit: "Questo file è protetto da password. Elaboralo da solo per digitare la password, oppure rimuovi prima la password (per es. con Sbloccare PDF su questo sito).", errPwRotate: "Questo file è protetto da password. Elaboralo da solo per digitare la password, oppure rimuovi prima la password (per es. con Sbloccare PDF su questo sito).", errPwNumbers: "Questo file è protetto da password. Elaboralo da solo per digitare la password, oppure rimuovi prima la password (per es. con Sbloccare PDF su questo sito).", errPwDelete: "Questo file è protetto da password. Elaboralo da solo per digitare la password, oppure rimuovi prima la password (per es. con Sbloccare PDF su questo sito).", errInvalidPdf: "Impossibile elaborare questo file. È un PDF valido?", errInvalidWord: "Impossibile elaborare questo file. È un documento Word valido?", errInvalidPpt: "Impossibile elaborare questo file. È un file PowerPoint valido?", errNoneSplit: "Non è stato possibile dividere nessuno dei file. Sono file PDF validi?", errNoneRotated: "Non è stato possibile ruotare nessuno dei file. Sono file PDF validi?", errNoneProcessed: "Non è stato possibile elaborare nessuno dei file. Sono file PDF validi?", errSkipSplit: "Impossibile dividere: {0}", errSkipConvert: "Impossibile convertire: {0}", errSkipCompress: "Impossibile comprimere: {0}", errSkipRotate: "Impossibile ruotare: {0}", errSkipNumbers: "Impossibile aggiungere i numeri di pagina: {0}", errSkipDelete: "Impossibile eliminare le pagine: {0}", errMergeOpen: "Impossibile aprire: {0}. Per unire servono almeno 2 file validi.", errMergeOpenAll: "Impossibile aprire questi file.", errDeleteNeed: "Inserisci almeno un numero di pagina valido da eliminare (per es. “2, 5-7”).", errDeleteAll: "Non puoi eliminare tutte le pagine — il risultato sarebbe un PDF vuoto.", pwAsk: "Questo file è protetto da password. Scrivila qui sotto e riprova. La password resta nel tuo browser.", pwWrong: "Questa password non è corretta per questo file. Scrivila di nuovo.", pwLabel: "Password del PDF", pwRetry: "Riprova", pwRemovedNote: "Il risultato non ha più una password. Per proteggerlo di nuovo, usa Proteggere PDF.", compressCmykNote: "I colori di stampa (CMYK) sono stati convertiti in colori per lo schermo (RGB) in: {0}. I colori possono apparire un po' diversi; per una tipografia usa l'originale o il livello Leggera.",
    outOfMemory: "Il tuo browser ha esaurito la memoria o non è più riuscito a leggere il file, quindi non è stato salvato nulla. Chiudi altre schede o app, scegli di nuovo il file e riprova, oppure fai il lavoro in più parti (per esempio meno pagine alla volta).", // (v73) friendlyPdfError
    pdfjsDataMissing: "Non è stato possibile caricare un file di font necessario a questo PDF (nessuna connessione?): mancherebbe parte del testo, quindi non è stato salvato nulla. Controlla la connessione, ricarica la pagina e riprova.", // (v157) pcPdfJsMissed
    fileGone: "Questo file non si può più leggere. Probabilmente è stato spostato, rinominato o eliminato dopo che l'hai scelto. Sceglilo di nuovo e riprova.", // (v89) friendlyPdfError: the chosen file is no longer on the device
    wrongType: "Non aggiunto: {0}. Questo strumento non supporta questo tipo di file.", emptyFile: "Non aggiunto: {0}. Il file è vuoto (0 byte).", // (v89) pcTakeUsable: a file left out when dropped or picked
    // (v73, q16) share menu for several result files (pcOfferShare)
    shareFiles: "Salva i {0} file separatamente",
    shareHint: "Apre il menu di condivisione del dispositivo, così ogni file viene salvato separatamente (su iPhone: ‘Salva su File’, o ‘Salva immagini’ per le foto). Il pulsante Scarica qui sopra fornisce gli stessi file in un unico zip.",
    shareFailed: "Non è stato possibile aprire il menu di condivisione. Usa il pulsante Scarica qui sopra: lo zip contiene gli stessi file.",
    // (v62) "What next?" block under a result (pcOfferNextSteps)
    nextTitle: "E adesso?",
    nextSub: "Continua con {0} in un altro strumento. Non devi sceglierlo di nuovo e non viene caricato.",
    nextTool_merge: "Unisci con altri PDF",
    nextTool_compress: "Comprimi",
    nextTool_word: "Converti in Word",
    nextTool_sign: "Firma",
    nextTool_protect: "Aggiungi una password",
    nextTool_numbers: "Aggiungi numeri di pagina",
    nextTool_nup: "Metti più pagine su un foglio", nextTool_org: "Metti in ordine le pagine", nextTool_txt: "Salva come testo", nextTool_meta: "Rimuovi i metadati", nextTool_fill: "Compila un modulo o aggiungi testo", nextTool_flatten: "Appiattisci campi e commenti", nextTool_redact: "Oscura il testo", nextTool_ocr: "Rendi ricercabile (OCR)",
    nextFromStep: "File del passaggio precedente: {0}",
    nextOthersCleared: "Gli altri file che avevi scelto non sono più nell'elenco.",
    nextNoFile: "Non è stato possibile passare il file del passaggio precedente, perché il tuo browser non permette a questo sito di conservarlo per un momento (per esempio in una finestra privata). Scegli di nuovo il file.",
    pageMissing: "La pagina {0} non esiste: questo documento ha {1} pagine.",
    pageMissingOne: "La pagina {0} non esiste: questo documento ha solo 1 pagina.",
    pageBadInput: "Impossibile interpretare “{0}”. Usa le virgole, per es. 2, 5-7.",
    splitPointRange: "Per dividere il documento, usa numeri di pagina da 1 a {0} (questo documento ha {1} pagine).",
    splitOnePage: "Questo documento ha solo 1 pagina, quindi non c'è niente da dividere.",
    numbersNone: "Non ci sono pagine da numerare: il documento ha solo la copertina.",
    truncated: "Questo PDF sembra incompleto o danneggiato: ne mancano delle parti (il download si è interrotto?). Scaricalo di nuovo e riprova.",
    pdfConflict: "Questo PDF contiene due versioni diverse della stessa parte, quindi non è certo quale sia la pagina giusta. Aprilo in un lettore PDF, salvalo come nuovo PDF (o stampalo in PDF) e riprova.", compressRepaired: "{0} era danneggiato (per esempio la tabella interna mancava o era errata). La copia è stata riparata, quindi si apre anche nei programmi che non riuscivano ad aprire l’originale.", // (v157) pcResolveDuplicates, pcOriginalIntact
    officeWrongKind: "Questo non è un file {0} valido. L'estensione del file è corretta?",
    simplified: "Alcune parti (come formule o grafici complessi) sono state riportate come immagini, quindi non si possono modificare come testo.",
    formLost: "Non è stato possibile leggere i valori inseriti in alcuni campi del modulo, quindi mancano nel risultato.",
    annotSkipped: "Timbri, disegni o commenti aggiunti sopra il PDF non sono stati riportati come contenuto modificabile.",
    decoLost: "Parte della formattazione (colori, evidenziazioni, link, sottolineature o dettagli delle tabelle) non è stata mantenuta; il testo in sé è completo.",
    formulaAlt: "Formula",
    cancel: "Annulla", cancelled: "Annullato.",
    xfaHybridNote: "Nota: {0} è un modulo XFA ibrido. Il risultato mantiene i normali campi del modulo, ma non la versione XFA del modulo (la usano solo alcuni programmi PDF).",
    formRenamedNote: "Nota: alcuni campi del modulo in {0} sono stati rinominati (per esempio nome → nome_2) perché un file precedente usa lo stesso nome. I calcoli automatici in quel file sono stati disattivati, quindi i totali non vengono più ricalcolati.",
    ownerNote: "Nota: questo PDF aveva restrizioni di modifica (una password del proprietario). Si apre senza password, quindi è stato elaborato; il risultato non ha più quelle restrizioni: {0}",
    certBroke: "Nota: {0} aveva una firma digitale basata su certificato. Quella firma non è più valida nella nuova copia.",
    splitUncovered: "Nota: queste pagine non sono in nessuno dei nuovi file: {0}.",
    compressNoImages: "Questo PDF non contiene immagini, quindi il livello di compressione non fa differenza.",
    compressKept: "{0} — questo file è già ben ottimizzato, quindi il tuo originale resta invariato",
    compressImagesUnsupported: "{0} — le immagini di questo file non si possono ridurre qui (per esempio colori di stampa (CMYK) o foto molto grandi), quindi il tuo originale resta invariato", // (v90) pcKeptText
    officeTooLarge: "Questo file Word o PowerPoint, una volta decompresso, supera i {0} MB: troppo per la memoria di questo dispositivo. Non è stato modificato nulla. Prova su un computer, oppure rimuovi prima dal file i video o le immagini di grandi dimensioni.", // (v90) pcOpenOfficeZip
    compressInfo: "{0} ({1}% più piccolo)",
    dpiCapped: "Pagine molto grandi salvate a risoluzione più bassa ({1} DPI) per il limite di dimensione delle immagini del browser: {0}.",
    imageTooLarge: "Una pagina è troppo grande perché questo browser la converta in immagine, anche a risoluzione più bassa. Riprova su un computer, oppure dividi prima il PDF.",
    finishFailed: "Non è stato possibile completare correttamente il file, quindi non è stato salvato nulla. Riprova.",
    libLoadFailed: "Non è stato possibile caricare un componente necessario. Controlla la connessione (o il blocco degli annunci) e riprova.",
    oldBrowser: "Questo strumento richiede un browser più recente (su iPhone e iPad: iOS 16.4 o successivo). Aggiorna il browser o il sistema e riprova; gli altri strumenti del sito funzionano.",
    notPdfShort: "non è un PDF valido",
    passwordShort: "protetto da password",
    xfa: "Questo è un modulo XFA dinamico, che la maggior parte dei programmi PDF e questo sito non possono visualizzare. Aprilo prima in un programma PDF desktop che supporti i moduli XFA e stampalo o salvalo come PDF normale.",
    mobileMemTooBig: "Questa operazione richiederebbe circa {0} di memoria, più di quanto possa offrire il browser di uno smartphone, quindi lo strumento non la avvierà. Usa un computer, oppure dividi prima il file in parti più piccole.",
    xfaShort: "un modulo XFA dinamico, che qui non si può modificare",
    mobileMemWarn: "Su uno smartphone questa operazione può richiedere più memoria di quanta ne consenta il browser (circa {0}) e la pagina potrebbe ricaricarsi. Per file così grandi è più sicuro un computer.",
    mobileMemStop: "Questa operazione richiederebbe circa {0} di memoria, più di quanto possa offrire il browser di uno smartphone, quindi non è stata avviata. Usa un computer per questo file, oppure dividilo prima in parti più piccole.",
    largeFiles: "Questi file pesano in totale {0}. Tutto viene elaborato nella memoria del tuo browser, quindi potrebbe volerci un po' ed essere lento su un dispositivo datato o su uno smartphone.",
    workerFailed: "Il tuo browser ha smesso di elaborare questo file, probabilmente per mancanza di memoria. Chiudi altre schede o app e riprova, oppure usa un computer per i file molto grandi.",
    rotatePages: "Solo queste pagine (facoltativo, per es. 1, 3-5; vuoto = tutte le pagine)",
    // (v62) page previews (pc-thumbs.js)
    thumbsHint: "Oppure tocca le pagine per selezionarle:", thumbsHintSplit: "Oppure tocca una pagina per dividere dopo di essa:", thumbsGroup: "Anteprime delle pagine", thumbsPage: "Pagina {0}", thumbsSplitAfter: "Dividi dopo la pagina {0}", thumbsSel0: "Nessuna pagina selezionata", thumbsSel1: "1 pagina selezionata", thumbsSelN: "{0} pagine selezionate", thumbsRotAll: "Nessuna pagina selezionata: verranno ruotate tutte le pagine", thumbsCut0: "Nessun punto di divisione: ogni pagina diventa un file separato", thumbsCut1: "1 punto di divisione: 2 file", thumbsCutN: "{0} punti di divisione: {1} file", thumbsRanges: "Hai inserito degli intervalli di pagine: ogni intervallo diventa un file separato. Svuota il campo per scegliere i punti di divisione sulle pagine.", thumbsMore: "Mostra altre pagine (ne restano {0})", thumbsMulti: "Le anteprime delle pagine compaiono quando aggiungi un solo PDF. I numeri di pagina che inserisci valgono per ogni file.", thumbsFailed: "Impossibile mostrare le anteprime delle pagine per questo file.", thumbsTooBig: "Questo file è troppo grande per mostrare le anteprime delle pagine su questo dispositivo. Inserisci invece i numeri di pagina.",
    noText: "Questo PDF non ha un livello di testo (per esempio una scansione, o testo convertito in tracciati), quindi non c'è testo modificabile da convertire. Scegli “Layout identico” per mantenere l'aspetto delle pagine.",
    analyzingPages: "Analisi delle pagine ({0} di {1})…",
    analyzingDoc: "Analisi del documento ({0}%)…",
    numPos: "Posizione", numPosOpts: "In basso al centro|In basso a destra|In basso a sinistra|In alto al centro|In alto a destra|In alto a sinistra", numStart: "Inizia dal numero", numSkipFirst: "Non numerare la prima pagina (copertina)", numStartBad: "Inserisci un numero intero da 0 a 99999 come numero iniziale.",
    numSize: "Dimensione",
    numSizeOpts: "Piccola|Media|Grande",
    numColor: "Colore",
    numColorOpts: "Grigio|Nero|Bianco|Blu|Rosso",
    numNoPages: "Nessuna delle pagine scelte riceve un numero. Controlla l’elenco delle pagine.",
    splitRange: "Usa numeri di pagina o intervalli separati da virgole, per es. “3, 7” o “1-3, 4-10”.",
    splitEvery: "Oppure: un nuovo file ogni … pagine (facoltativo)",
    splitEveryBad: "Scrivi un numero intero di pagine, per esempio 2.",
    splitEveryBoth: "Compila solo uno dei due campi: dove dividere oppure ogni quante pagine.",
    splitEveryAll: "Questo file ha {0} pagine: ogni {1} pagine dà un solo file. Scrivi un numero più piccolo.",
    tabDone: "Fatto", tabFailed: "Non riuscito", // (v95) tab title after a job
    staleRelease: "PDFCommunity è stato appena aggiornato. Ricarica questa pagina (i tuoi file non vengono conservati) e riprova." // (v96) pcLoadLib
  }, pl: {
    // (v98) messages that i18n-runtime.js used to translate with regexes (l90-i18n)
    infoPages1: "1 strona, {0}", infoPagesN: "{0} {0#strona|strony|stron}, {1}", pageOfTotal: "Strona {0} z {1}", stMerging: "Łączenie…", stCompressing: "Kompresowanie…", stConverting: "Konwersja…", stSplitting: "Dzielenie…", stRotating: "Obracanie…", stNumbering: "Dodawanie numerów stron…", stRemoving: "Usuwanie stron…", stDone: "Gotowe!", stDoneSkippedOpen: "Gotowe, ale pominięto (nie da się otworzyć): {0}", stDoneSkipped: "Gotowe, ale pominięto: {0}", infoMerged: "Połączono {0} {0#plik|pliki|plików}, {1}", infoWordText1: "1 strona, {0} — edytowalny tekst", infoWordTextN: "{0} {0#strona|strony|stron}, {1} — edytowalny tekst", infoWordImg1: "1 strona, {0} — identyczny układ (obrazy)", infoWordImgN: "{0} {0#strona|strony|stron}, {1} — identyczny układ (obrazy)", infoPptText1: "1 slajd, {0} — edytowalny tekst", infoPptTextN: "{0} {0#slajd|slajdy|slajdów}, {1} — edytowalny tekst", infoPptImg1: "1 slajd, {0} — identyczny układ (obrazy)", infoPptImgN: "{0} {0#slajd|slajdy|slajdów}, {1} — identyczny układ (obrazy)", stFilePage: "Plik {0} z {1} ({2}) — strona {3} z {4}…", stFileFinishing: "Plik {0} z {1} ({2}) — kończenie pliku…", stFileOf: "Plik {0} z {1}: {2}", stPage: "Przetwarzanie strony {0} z {1}…", stFinishing: "Kończenie pliku…", stZip: "Pakowanie wszystkich plików ({0}) do jednego pliku zip…", stLast: "Ostatni krok — przygotowanie pliku do pobrania…", infoZipCompressed: "Skompresowane pliki: {0}, zebrane w jednym pliku zip", infoZipCompressedTotal: "Skompresowane pliki: {0}: {1} → {2} (mniejsze o {3}%), zebrane w jednym pliku zip", infoZipConverted: "Przekonwertowane pliki: {0}, zebrane w jednym pliku zip", compressInfoImg: "{0} (mniejszy o {1}%, zmniejszone obrazy: {2})", infoCreated1: "Utworzono 1 plik", infoCreatedN: "Utworzono {0} {0#plik|pliki|plików}", infoRotated1: "Obrócono 1 plik", infoRotatedN: "Obrócono {0} {0#plik|pliki|plików}", infoNumbered1: "Ponumerowano 1 plik", infoNumberedN: "Ponumerowano {0} {0#plik|pliki|plików}", infoUpdated1: "Zaktualizowano 1 plik", infoUpdatedN: "Zaktualizowano {0} {0#plik|pliki|plików}", errPwUse: "Ten plik jest chroniony hasłem. Przetwórz go osobno, aby wpisać hasło, albo najpierw usuń hasło (np. narzędziem Odblokuj PDF w tym serwisie).", errPwSplit: "Ten plik jest chroniony hasłem. Przetwórz go osobno, aby wpisać hasło, albo najpierw usuń hasło (np. narzędziem Odblokuj PDF w tym serwisie).", errPwRotate: "Ten plik jest chroniony hasłem. Przetwórz go osobno, aby wpisać hasło, albo najpierw usuń hasło (np. narzędziem Odblokuj PDF w tym serwisie).", errPwNumbers: "Ten plik jest chroniony hasłem. Przetwórz go osobno, aby wpisać hasło, albo najpierw usuń hasło (np. narzędziem Odblokuj PDF w tym serwisie).", errPwDelete: "Ten plik jest chroniony hasłem. Przetwórz go osobno, aby wpisać hasło, albo najpierw usuń hasło (np. narzędziem Odblokuj PDF w tym serwisie).", errInvalidPdf: "Nie udało się przetworzyć tego pliku. Czy to prawidłowy PDF?", errInvalidWord: "Nie udało się przetworzyć tego pliku. Czy to prawidłowy dokument Word?", errInvalidPpt: "Nie udało się przetworzyć tego pliku. Czy to prawidłowy plik PowerPoint?", errNoneSplit: "Nie udało się podzielić żadnego z plików. Czy to prawidłowe pliki PDF?", errNoneRotated: "Nie udało się obrócić żadnego z plików. Czy to prawidłowe pliki PDF?", errNoneProcessed: "Nie udało się przetworzyć żadnego z plików. Czy to prawidłowe pliki PDF?", errSkipSplit: "Nie udało się podzielić: {0}", errSkipConvert: "Nie udało się przekonwertować: {0}", errSkipCompress: "Nie udało się skompresować: {0}", errSkipRotate: "Nie udało się obrócić: {0}", errSkipNumbers: "Nie udało się dodać numerów stron: {0}", errSkipDelete: "Nie udało się usunąć stron: {0}", errMergeOpen: "Nie udało się otworzyć: {0}. Do połączenia potrzeba co najmniej 2 prawidłowych plików.", errMergeOpenAll: "Nie udało się otworzyć tych plików.", errDeleteNeed: "Wpisz co najmniej jeden prawidłowy numer strony do usunięcia (np. „2, 5-7”).", errDeleteAll: "Nie możesz usunąć wszystkich stron — wynikiem byłby pusty PDF.", pwAsk: "Ten plik jest chroniony hasłem. Wpisz je poniżej i spróbuj ponownie. Hasło zostaje w Twojej przeglądarce.", pwWrong: "To hasło nie pasuje do tego pliku. Wpisz je jeszcze raz.", pwLabel: "Hasło do PDF", pwRetry: "Spróbuj ponownie", pwRemovedNote: "Wynik nie ma już hasła. Aby go ponownie zabezpieczyć, użyj narzędzia Zabezpiecz PDF.", compressCmykNote: "Kolory do druku (CMYK) zamieniono na kolory ekranowe (RGB) w: {0}. Barwy mogą wyglądać nieco inaczej; dla drukarni użyj oryginału lub poziomu Lekka.",
    outOfMemory: "Twojej przeglądarce zabrakło pamięci albo nie mogła już odczytać pliku, więc nic nie zostało zapisane. Zamknij inne karty lub aplikacje, wybierz plik ponownie i spróbuj jeszcze raz albo podziel pracę na części (np. mniej stron naraz).", // (v73) friendlyPdfError
    pdfjsDataMissing: "Nie udało się wczytać pliku czcionki potrzebnego dla tego PDF (brak połączenia?): brakowałoby części tekstu, więc nic nie zostało zapisane. Sprawdź połączenie, odśwież stronę i spróbuj ponownie.", // (v157) pcPdfJsMissed
    fileGone: "Tego pliku nie da się już odczytać. Prawdopodobnie został przeniesiony, zmienił nazwę lub został usunięty po wybraniu. Wybierz go ponownie i spróbuj jeszcze raz.", // (v89) friendlyPdfError: the chosen file is no longer on the device
    wrongType: "Nie dodano: {0}. To narzędzie nie obsługuje tego typu pliku.", emptyFile: "Nie dodano: {0}. Plik jest pusty (0 bajtów).", // (v89) pcTakeUsable: a file left out when dropped or picked
    // (v73, q16) share menu for several result files (pcOfferShare)
    shareFiles: "Zapisz pliki osobno ({0})",
    shareHint: "Otwiera menu udostępniania urządzenia, aby zapisać każdy plik osobno (na iPhonie: „Zachowaj w Plikach” albo „Zachowaj obrazy” dla zdjęć). Przycisk Pobierz powyżej daje te same pliki w jednym pliku zip.",
    shareFailed: "Nie udało się otworzyć menu udostępniania. Użyj przycisku Pobierz powyżej: plik zip zawiera te same pliki.",
    // (v62) "What next?" block under a result (pcOfferNextSteps)
    nextTitle: "Co dalej?",
    nextSub: "Kontynuuj z plikiem {0} w innym narzędziu. Nie musisz wybierać go ponownie i nie jest on przesyłany.",
    nextTool_merge: "Połącz z innymi plikami PDF",
    nextTool_compress: "Kompresuj",
    nextTool_word: "Konwertuj na Word",
    nextTool_sign: "Podpisz",
    nextTool_protect: "Dodaj hasło",
    nextTool_numbers: "Dodaj numery stron",
    nextTool_nup: "Umieść kilka stron na arkuszu", nextTool_org: "Uporządkuj strony", nextTool_txt: "Zapisz jako tekst", nextTool_meta: "Usuń metadane", nextTool_fill: "Wypełnij formularz lub dodaj tekst", nextTool_flatten: "Spłaszcz pola i komentarze", nextTool_redact: "Zaczernij tekst", nextTool_ocr: "Włącz wyszukiwanie (OCR)",
    nextFromStep: "Plik z poprzedniego kroku: {0}",
    nextOthersCleared: "Pozostałych wybranych plików nie ma już na liście.",
    nextNoFile: "Nie udało się przekazać pliku z poprzedniego kroku, bo Twoja przeglądarka nie pozwala temu serwisowi przechować go przez chwilę (np. w oknie prywatnym). Wybierz plik ponownie.",
    pageMissing: "Strona {0} nie istnieje: ten dokument ma {1} {1#stronę|strony|stron}.",
    pageMissingOne: "Strona {0} nie istnieje: ten dokument ma tylko 1 stronę.",
    pageBadInput: "Nie udało się odczytać „{0}”. Użyj przecinków, np. 2, 5-7.",
    splitPointRange: "Aby podzielić dokument, użyj numerów stron od 1 do {0} (ten dokument ma {1} {1#stronę|strony|stron}).",
    splitOnePage: "Ten dokument ma tylko 1 stronę, więc nie ma czego dzielić.",
    numbersNone: "Nie ma stron do ponumerowania: dokument ma tylko okładkę.",
    truncated: "Ten PDF wygląda na niekompletny lub uszkodzony: brakuje jego części (czy pobieranie zostało przerwane?). Pobierz go ponownie i spróbuj jeszcze raz.",
    pdfConflict: "Ten PDF zawiera dwie różne wersje tej samej części, więc nie wiadomo na pewno, która strona jest właściwa. Otwórz go w czytniku PDF, zapisz jako nowy PDF (albo wydrukuj do PDF) i spróbuj ponownie.", compressRepaired: "Plik {0} był uszkodzony (na przykład brakowało jego wewnętrznego spisu albo był błędny). Kopia jest naprawiona, więc otwiera się także w programach, które nie mogły otworzyć oryginału.", // (v157) pcResolveDuplicates, pcOriginalIntact
    officeWrongKind: "To nie jest prawidłowy plik {0}. Czy rozszerzenie pliku jest poprawne?",
    simplified: "Niektóre elementy (np. wzory lub złożone wykresy) przeniesiono jako obrazy, więc nie da się ich edytować jako tekstu.",
    formLost: "Nie udało się odczytać wartości wpisanych w niektórych polach formularza, więc brakuje ich w wyniku.",
    annotSkipped: "Pieczątek, rysunków ani komentarzy dodanych nad PDF nie przeniesiono jako edytowalnej treści.",
    decoLost: "Część formatowania (kolory, zakreślenia, linki, podkreślenia lub szczegóły tabel) nie została zachowana; sam tekst jest kompletny.",
    formulaAlt: "Wzór",
    cancel: "Anuluj", cancelled: "Anulowano.",
    xfaHybridNote: "Uwaga: {0} to hybrydowy formularz XFA. Wynik zachowuje zwykłe pola formularza, ale nie wersję XFA formularza (używają jej tylko niektóre programy PDF).",
    formRenamedNote: "Uwaga: niektóre pola formularza w {0} zmieniły nazwę (np. imie → imie_2), bo wcześniejszy plik używa tej samej nazwy. Automatyczne obliczenia w tym pliku zostały wyłączone, więc sumy nie są już przeliczane.",
    ownerNote: "Uwaga: ten PDF miał ograniczenia edycji (hasło właściciela). Otwiera się bez hasła, więc został przetworzony; wynik nie ma już tych ograniczeń: {0}",
    certBroke: "Uwaga: {0} miał podpis cyfrowy oparty na certyfikacie. W nowej kopii ten podpis nie jest już ważny.",
    splitUncovered: "Uwaga: tych stron nie ma w żadnym z nowych plików: {0}.",
    compressNoImages: "Ten PDF nie zawiera obrazów, więc poziom kompresji nie ma znaczenia.",
    compressKept: "{0} — ten plik jest już dobrze zoptymalizowany, więc Twój oryginał pozostaje bez zmian",
    compressImagesUnsupported: "{0} — obrazów w tym pliku nie da się tu zmniejszyć (np. kolory do druku (CMYK) lub bardzo duże zdjęcia), więc Twój oryginał pozostaje bez zmian", // (v90) pcKeptText
    officeTooLarge: "Ten plik Word lub PowerPoint po rozpakowaniu przekracza {0} MB: to za dużo dla pamięci tego urządzenia. Nic nie zostało zmienione. Spróbuj na komputerze albo najpierw usuń z pliku filmy lub duże obrazy.", // (v90) pcOpenOfficeZip
    compressInfo: "{0} (mniejszy o {1}%)",
    dpiCapped: "Bardzo duże strony zapisano w niższej rozdzielczości ({1} DPI) ze względu na limit rozmiaru obrazów w przeglądarce: {0}.",
    imageTooLarge: "Strona jest za duża, żeby ta przeglądarka zamieniła ją w obraz, nawet w niższej rozdzielczości. Spróbuj na komputerze albo najpierw podziel PDF.",
    finishFailed: "Nie udało się poprawnie dokończyć pliku, więc nic nie zostało zapisane. Spróbuj ponownie.",
    libLoadFailed: "Nie udało się wczytać potrzebnego składnika. Sprawdź połączenie (lub blokadę reklam) i spróbuj ponownie.",
    oldBrowser: "To narzędzie wymaga nowszej przeglądarki (na iPhonie i iPadzie: iOS 16.4 lub nowszy). Zaktualizuj przeglądarkę lub system i spróbuj ponownie; pozostałe narzędzia serwisu działają.",
    notPdfShort: "to nie jest prawidłowy PDF",
    passwordShort: "chroniony hasłem",
    xfa: "To dynamiczny formularz XFA, którego większość programów PDF i ten serwis nie potrafią wyświetlić. Najpierw otwórz go w programie PDF na komputerze, który obsługuje formularze XFA, i wydrukuj lub zapisz go jako zwykły PDF.",
    mobileMemTooBig: "Ta operacja wymagałaby ok. {0} pamięci, więcej niż może dać przeglądarka na smartfonie, więc narzędzie jej nie uruchomi. Użyj komputera albo najpierw podziel plik na mniejsze części.",
    xfaShort: "dynamiczny formularz XFA, którego nie da się tu edytować",
    mobileMemWarn: "Na smartfonie ta operacja może wymagać więcej pamięci, niż pozwala przeglądarka (ok. {0}), i strona może się przeładować. Przy tak dużych plikach bezpieczniejszy jest komputer.",
    mobileMemStop: "Ta operacja wymagałaby ok. {0} pamięci, więcej niż może dać przeglądarka na smartfonie, więc nie została uruchomiona. Do tego pliku użyj komputera albo najpierw podziel go na mniejsze części.",
    largeFiles: "Te pliki ważą łącznie {0}. Wszystko jest przetwarzane w pamięci Twojej przeglądarki, więc może to chwilę potrwać i działać wolno na starszym urządzeniu lub smartfonie.",
    workerFailed: "Twoja przeglądarka przestała przetwarzać ten plik, prawdopodobnie z braku pamięci. Zamknij inne karty lub aplikacje i spróbuj ponownie albo użyj komputera do bardzo dużych plików.",
    rotatePages: "Tylko te strony (opcjonalnie, np. 1, 3-5; puste = wszystkie strony)",
    // (v62) page previews (pc-thumbs.js)
    thumbsHint: "Albo dotknij stron, aby je zaznaczyć:", thumbsHintSplit: "Albo dotknij strony, aby podzielić po niej:", thumbsGroup: "Podglądy stron", thumbsPage: "Strona {0}", thumbsSplitAfter: "Podziel po stronie {0}", thumbsSel0: "Nie zaznaczono żadnej strony", thumbsSel1: "Zaznaczono 1 stronę", thumbsSelN: "Zaznaczono {0} {0#stronę|strony|stron}", thumbsRotAll: "Nie zaznaczono żadnej strony: obrócone zostaną wszystkie strony", thumbsCut0: "Brak miejsc podziału: każda strona stanie się osobnym plikiem", thumbsCut1: "1 miejsce podziału: 2 pliki", thumbsCutN: "{0} {0#miejsce|miejsca|miejsc} podziału: {1} {1#plik|pliki|plików}", thumbsRanges: "Wpisano zakresy stron: każdy zakres stanie się osobnym plikiem. Wyczyść pole, aby wybrać miejsca podziału na stronach.", thumbsMore: "Pokaż więcej stron (pozostało: {0})", thumbsMulti: "Podglądy stron pojawiają się, gdy dodasz tylko jeden PDF. Wpisane numery stron obowiązują dla każdego pliku.", thumbsFailed: "Nie udało się wyświetlić podglądów stron dla tego pliku.", thumbsTooBig: "Ten plik jest za duży, żeby wyświetlić podglądy stron na tym urządzeniu. Wpisz zamiast tego numery stron.",
    noText: "Ten PDF nie ma warstwy tekstowej (np. skan lub tekst zamieniony na krzywe), więc nie ma edytowalnego tekstu do przekonwertowania. Wybierz „Identyczny układ”, aby zachować wygląd stron.",
    analyzingPages: "Analiza stron ({0} z {1})…",
    analyzingDoc: "Analiza dokumentu ({0}%)…",
    numPos: "Położenie", numPosOpts: "Na dole, pośrodku|Na dole, z prawej|Na dole, z lewej|U góry, pośrodku|U góry, z prawej|U góry, z lewej", numStart: "Zacznij od numeru", numSkipFirst: "Nie numeruj pierwszej strony (okładka)", numStartBad: "Jako numer początkowy wpisz liczbę całkowitą od 0 do 99999.",
    numSize: "Rozmiar",
    numSizeOpts: "Mały|Średni|Duży",
    numColor: "Kolor",
    numColorOpts: "Szary|Czarny|Biały|Niebieski|Czerwony",
    numNoPages: "Żadna z wybranych stron nie dostanie numeru. Sprawdź listę stron.",
    splitRange: "Użyj numerów stron lub zakresów oddzielonych przecinkami, np. „3, 7” lub „1-3, 4-10”.",
    splitEvery: "Albo: nowy plik co … stron (opcjonalnie)",
    splitEveryBad: "Wpisz całkowitą liczbę stron, na przykład 2.",
    splitEveryBoth: "Wypełnij tylko jedno z dwóch pól: gdzie podzielić albo co ile stron.",
    splitEveryAll: "Ten plik ma {0} stron: co {1} stron daje tylko jeden plik. Wpisz mniejszą liczbę.",
    tabDone: "Gotowe", tabFailed: "Nie powiodło się", // (v95) tab title after a job
    staleRelease: "PDFCommunity zostało właśnie zaktualizowane. Odśwież tę stronę (Twoje pliki nie są przechowywane) i spróbuj ponownie." // (v96) pcLoadLib
  }
};
function pcT(key){
  const M = PC_MSG[PDFC_LANG] || PC_MSG.en;
  const s = M[key] != null ? M[key] : PC_MSG.en[key];
  if(s == null){ pcLogUnexpected(new Error('no message for key ' + key)); return key; } // a fault of ours, never "undefined" on screen
  return pcFill.apply(null, [s].concat(Array.prototype.slice.call(arguments, 1)));
}
/* (v94) Notes about the form of an assembled PDF (pcAssemble): fields
   renamed because another file already used the name, and hybrid XFA forms
   whose XFA part is not kept. nameOf: donor document -> file name. */
function pcAssembleNotes(out, nameOf){
  const info = out && out.__pcFormInfo;
  if(!info) return '';
  const list = docs => [...new Set(docs.map(nameOf))].join(', ');
  return [info.renamedDonors.length ? pcT('formRenamedNote', list(info.renamedDonors)) : '',
    info.xfaDonors.length ? pcT('xfaHybridNote', list(info.xfaDonors)) : ''].filter(Boolean).join(' ');
}
/* Percentage/size text in the page's own number format ("3,4 MB" in nl). */
function pcShowNote(anchorEl, text){
  if(!anchorEl) return;
  let n = anchorEl.parentNode && anchorEl.parentNode.querySelector(':scope > .pc-note[data-for="' + anchorEl.id + '"]');
  if(!text){ if(n) n.remove(); return; }
  if(!n){
    n = document.createElement('p');
    n.className = 'pc-note';
    n.setAttribute('data-for', anchorEl.id);
    n.style.cssText = 'margin:8px 0 0;font-size:0.85rem;line-height:1.4;opacity:0.85';
    anchorEl.insertAdjacentElement('afterend', n);
  }
  n.textContent = text;
}

/* ---------- (v119) A password-protected PDF: the password field in the tool ---------- */
/* Before v119 such a file was refused with "remove the password first (Unlock
   PDF)". Now the tool's status box asks for the password and runs again. The
   password stays in this page's memory only (never stored, never sent; the
   worker gets a copy with each job) and is used only for a file that does not
   open without one (pcOpenWithTypedPassword, pcGetDocument). */
let pcTypedPassword = '';
let pcPasswordAsked = false;   // this run failed on a file that needs a password
let pcPasswordUsedRun = false; // this run opened a file with the typed password
const PC_PW_OWN_FIELD = new Set(['unlock', 'protect']); // tools with a password field of their own
const PC_RESULT_SETTLE_MS = 400; // (v119) a result box's own layout (previews) has settled by then
function pcHostPassword(){ return pcTypedPassword; }
function pcSetTypedPassword(pw){ pcTypedPassword = pw; } // (v143) a password typed at a tool's preview (tools-more.js)
function pcHostPasswordUsed(){ pcPasswordUsedRun = true; }
function pcNotePassword(err){ if(err && (err.pw || err.name === 'PasswordException')) pcPasswordAsked = true; }
/* pdf.js asks for a password only when a file needs one (onPassword); a wrong
   or missing one rejects the load with a PasswordException, as before. */
const PC_PDFJS_NEED_PASSWORD = 1;
function pcPdfjsTask(src){
  const task = pdfjsLib.getDocument(src);
  task.onPassword = (update, reason) => {
    if(reason === PC_PDFJS_NEED_PASSWORD && pcTypedPassword){ update(pcTypedPassword); return; }
    const e = new Error('password protected'); e.name = 'PasswordException';
    throw e;
  };
  return task;
}
/* (v147) renderFrom: only for a document opened without images
   (pcTextOnlySource), a function giving the file's bytes again. */
function pcGetDocument(src, renderFrom){
  const probe = pcCutOffProbe(src && src.data); // (v140) pdf.js takes over the buffer: keep its ends first
  const task = pcPdfjsTask(src);
  const twin = renderFrom ? pcRenderTwin(renderFrom) : null;
  if(twin){ const destroy = task.destroy.bind(task); task.destroy = () => Promise.all([destroy(), twin.destroy()]); }
  // (v140) a cut-off download gets the same clear message here as in the
  // pdf-lib tools ("seems incomplete or damaged"), not "Is it a valid PDF?"
  const visible = task.promise.then(doc => pcWithVisibleTextOnly(doc, twin), err => { throw probe ? pcCutOffOr(probe, err) : err; });
  try{ Object.defineProperty(task, 'promise', { value: visible }); }catch(e){ pcLogUnexpected(e); /* hidden text (switched-off layers, v131; invisible text, v147) then stays in */ }
  return task;
}
/* (v140) Start and end of a PDF's bytes, enough for pcLooksCutOff (the %PDF
   header and the %%EOF marker), copied before pdf.js detaches the buffer. */
function pcCutOffProbe(bytes){
  if(!(bytes instanceof Uint8Array) || !bytes.length) return null;
  if(bytes.length <= PC_PDF_HEADER_WINDOW + PC_EOF_WINDOW) return bytes.slice();
  const probe = new Uint8Array(PC_PDF_HEADER_WINDOW + PC_EOF_WINDOW);
  probe.set(bytes.subarray(0, PC_PDF_HEADER_WINDOW), 0);
  probe.set(bytes.subarray(bytes.length - PC_EOF_WINDOW), PC_PDF_HEADER_WINDOW);
  return probe;
}
/* (v131) Text in an optional-content layer that is switched off (a hidden
   layer: an answer key, a translation, printer's marks) is not on the page
   as you see it, but getTextContent() returns it: PDF to Word, Excel and
   text copied it into the result. Every page of a document opened here
   leaves that text out. A PDF without layers costs nothing extra.
   (v147) The same for text nobody can see (pcWithoutInvisibleText). */
function pcWithVisibleTextOnly(doc, twin){
  const getPage = doc.getPage.bind(doc);
  let config = null;
  const ocConfig = () => config || (config = doc.getOptionalContentConfig());
  doc.getPage = async n => pcHideOffLayerText(await getPage(n), ocConfig, twin);
  return doc;
}
const pcOcPatched = new WeakSet();
function pcHideOffLayerText(page, ocConfig, twin){
  if(pcOcPatched.has(page)) return page;
  pcOcPatched.add(page);
  const getText = page.getTextContent.bind(page);
  const renderPage = twin ? () => twin.page(page.pageNumber) : async () => page;
  // (v157) pcAllText: everything pdf.js finds, hidden or not (Redact must find what it has to remove)
  page.getTextContent = async opts => opts && opts.pcAllText ? getText(Object.assign({}, opts, { pcAllText: undefined }))
    : pcWithoutInvisibleText(page, await pcOnLayerText(page, getText, ocConfig, opts), renderPage);
  return page;
}
async function pcOnLayerText(page, getText, ocConfig, opts){
  const cfg = await ocConfig();
  const groups = cfg && cfg.getGroups ? cfg.getGroups() : null;
  if(!groups || !Object.keys(groups).length) return getText(opts);
  const tc = await getText(Object.assign({}, opts, { includeMarkedContent: true }));
  const hidden = await pcOffLayerMarks(page, cfg);
  const items = pcVisibleItems(tc.items, hidden, !!(opts && opts.includeMarkedContent));
  return Object.assign({}, tc, { items });
}
/* Whether each optional-content section of the page (in drawing order) is
   switched off. (v147) The list without annotations (pcPageOpsRaw): their
   appearances come after the page's own content, so the order is the same. */
async function pcOffLayerMarks(page, cfg){
  const ol = await pcPageOpsRaw(page);
  const marks = [];
  ol.fnArray.forEach((fn, i) => {
    const a = ol.argsArray[i];
    if(fn === pdfjsLib.OPS.beginMarkedContentProps && a && a[0] === 'OC') marks.push(!!a[1] && !cfg.isVisible(a[1]));
  });
  return marks;
}
/* The text items outside switched-off sections; the section markers only when asked for. */
function pcVisibleItems(items, hidden, keepMarks){
  const out = [], stack = [];
  let k = 0;
  for(const it of items){
    const off = stack.length > 0 && stack[stack.length - 1];
    if(it.type === 'beginMarkedContent' || it.type === 'beginMarkedContentProps'){
      stack.push(off || (it.tag === 'OC' && !!hidden[k]));
      if(it.tag === 'OC') k++;
    }
    else if(it.type === 'endMarkedContent') stack.pop();
    else if(off) continue;
    if(keepMarks || !it.type) out.push(it);
  }
  return out;
}
function matMul(A, B){
  return [
    A[0]*B[0] + A[1]*B[2], A[0]*B[1] + A[1]*B[3],
    A[2]*B[0] + A[3]*B[2], A[2]*B[1] + A[3]*B[3],
    A[4]*B[0] + A[5]*B[2] + B[4], A[4]*B[1] + A[5]*B[3] + B[5],
  ];
}
function matApply(m,x,y){ return [x*m[0] + y*m[2] + m[4], x*m[1] + y*m[3] + m[5]]; }

// (v57) `f` may be left out for an array of numbers
function pcMinOf(arr, f){ let v = Infinity; for(const x of arr){ const y = f ? f(x) : x; if(y < v) v = y; } return v; }

function pcMaxOf(arr, f){ let v = -Infinity; for(const x of arr){ const y = f ? f(x) : x; if(y > v) v = y; } return v; }

function pcPathBox(subOps, coords, ctm){
  if(!subOps || !coords) return null;
  const { OPS } = pdfjsLib;
  let ci = 0; const pts = [];
  for(const op of subOps){
    if(op === OPS.moveTo || op === OPS.lineTo){ pts.push(matApply(ctm, coords[ci], coords[ci+1])); ci += 2; }
    else if(op === OPS.curveTo){ for(let k=0;k<3;k++){ pts.push(matApply(ctm, coords[ci], coords[ci+1])); ci += 2; } }
    else if(op === OPS.curveTo2 || op === OPS.curveTo3){ for(let k=0;k<2;k++){ pts.push(matApply(ctm, coords[ci], coords[ci+1])); ci += 2; } }
    else if(op === OPS.rectangle){ const x=coords[ci], y=coords[ci+1], w=coords[ci+2], h=coords[ci+3]; ci += 4; pts.push(matApply(ctm,x,y), matApply(ctm,x+w,y), matApply(ctm,x,y+h), matApply(ctm,x+w,y+h)); }
  }
  if(!pts.length) return null;
  const xs = pts.map(p=>p[0]), ys = pts.map(p=>p[1]);
  return { x0: pcMinOf(xs), y0: pcMinOf(ys), x1: pcMaxOf(xs), y1: pcMaxOf(ys) };
}

/* (v53) Walks a page's operator list keeping the full PDF text state --
   the text matrices, font size, character/word spacing, horizontal scale,
   leading and rise -- plus the fill colour. q/Q save and restore all of it
   except the text matrices (graphics state, PDF 32000 8.4 / 9.3); BT only
   resets the text matrices (the leading, a text-state parameter, carries
   over). Before v53 the colour sampler below kept only the CTM and colour
   on q/Q and reset the leading at BT. onShow(glyphArgs, st) is called for
   every shown glyph run before the text matrix advances past it; st.m is
   the text-to-page matrix at that moment. */
/* (v90) A fill without one plain colour (pdf.js gives other colour spaces
   as RGB already: this is a pattern or shading). Not the same as no fill
   command yet (st.fill null, before v107). */
const PC_NO_PLAIN_FILL = Object.freeze({ pattern: true });
function pcWalkTextOps(opList, onShow){
  const { OPS } = pdfjsLib;
  const stack = [];
  // (v56) font: the loaded font's id (as a text item's fontName), see pcZapfTextItems
  // (v107) the fill colour starts black (PDF 32000 8.4.1), and a Q that restores the
  // state from before any colour command restores black: a body text drawn in that
  // state had no colour sample and took the blue of the title (dia 23)
  // (v147) mode: the text render mode (Tr); clip: the box of the clip in force
  // (page space, null = none yet; the form boxes and clip paths, see pcClipCut)
  const st = { ctm: [1,0,0,1,0,0], tm: null, tlm: null, leading: 0, fontSize: 1, charSpacing: 0, wordSpacing: 0, hScale: 1, rise: 0, fill: { r: 0, g: 0, b: 0 }, font: null, mode: 0, clip: null };
  const GSTATE_KEYS = ['ctm', 'leading', 'fontSize', 'charSpacing', 'wordSpacing', 'hScale', 'rise', 'fill', 'font', 'mode', 'clip'];
  const save = () => stack.push(Object.fromEntries(GSTATE_KEYS.map(k => [k, st[k]])));
  const restore = () => { const g = stack.pop(); if(g) Object.assign(st, g); else st.ctm = [1,0,0,1,0,0]; };
  const advance = (tx, ty) => { st.tlm = matMul([1,0,0,1,tx,ty], st.tlm || [1,0,0,1,0,0]); st.tm = st.tlm; };
  const show = glyphArgs => {
    if(!st.tm || !Array.isArray(glyphArgs)) return;
    onShow(glyphArgs, { ...st, m: matMul(st.tm, st.ctm), op: opIndex });
    let tx = 0;
    for(const el of glyphArgs){
      if(typeof el === 'number'){ tx -= (el/1000) * st.fontSize * st.hScale; continue; }
      if(el && typeof el === 'object') tx += (((el.width||0)/1000) * st.fontSize + st.charSpacing + (el.isSpace ? st.wordSpacing : 0)) * st.hScale;
    }
    if(tx) st.tm = matMul([1,0,0,1,tx,0], st.tm);
  };
  const cmyk = (c,m,y,k) => ({ r:255*(1-c)*(1-k), g:255*(1-m)*(1-k), b:255*(1-y)*(1-k) });
  let opIndex = -1; // (v86) passed to onShow as st.op
  let pathBox = null;
  for(let i=0;i<opList.fnArray.length;i++){
    const fn = opList.fnArray[i], args = opList.argsArray[i];
    opIndex = i;
    if(fn === OPS.save) save();
    else if(fn === OPS.restore) restore();
    else if(fn === OPS.transform) st.ctm = matMul(args, st.ctm);
    // A form's own matrix applies to everything drawn inside it (see
    // getImagePlacements), undone at its end like a save/restore pair.
    else if(fn === OPS.paintFormXObjectBegin){
      save();
      if(args && args[0]) st.ctm = matMul(args[0], st.ctm);
      // (v147) a form shows nothing outside its own box
      if(args && args[1]) st.clip = pcClipCut(st.clip, pcPathBox([OPS.rectangle], [args[1][0], args[1][1], args[1][2] - args[1][0], args[1][3] - args[1][1]], st.ctm));
    }
    else if(fn === OPS.constructPath) pathBox = pcPathBox(args && args[0], args && args[1], st.ctm);
    else if(fn === OPS.clip || fn === OPS.eoClip) st.clip = pcClipCut(st.clip, pathBox);
    else if(fn === OPS.setTextRenderingMode) st.mode = args[0];
    else if(fn === OPS.paintFormXObjectEnd) restore();
    else if(fn === OPS.setFillRGBColor) st.fill = { r: args[0], g: args[1], b: args[2] };
    else if(fn === OPS.setFillGray){ const g = args[0]*255; st.fill = { r:g, g, b:g }; }
    else if(fn === OPS.setFillCMYKColor) st.fill = cmyk(args[0], args[1], args[2], args[3]);
    else if(fn === OPS.setFillColor || fn === OPS.setFillColorN || fn === OPS.setFillColorSpace) st.fill = PC_NO_PLAIN_FILL;
    else if(fn === OPS.beginText){ st.tm = [1,0,0,1,0,0]; st.tlm = [1,0,0,1,0,0]; }
    else if(fn === OPS.setTextMatrix){ st.tm = args; st.tlm = args; }
    else if(fn === OPS.setLeading) st.leading = args[0];
    else if(fn === OPS.setFont){ if(typeof args[1] === 'number') st.fontSize = args[1]; if(args && typeof args[0] === 'string') st.font = args[0]; }
    else if(fn === OPS.setCharSpacing) st.charSpacing = args[0] || 0;
    else if(fn === OPS.setWordSpacing) st.wordSpacing = args[0] || 0;
    else if(fn === OPS.setHScale) st.hScale = (typeof args[0]==='number' ? args[0]/100 : 1) || 1;
    else if(fn === OPS.setTextRise) st.rise = args[0] || 0;
    else if(fn === OPS.moveText) advance(args[0], args[1]);
    else if(fn === OPS.setLeadingMoveText){ st.leading = -args[1]; advance(args[0], args[1]); }
    else if(fn === OPS.nextLine) advance(0, -st.leading);
    else if(fn === OPS.showText || fn === OPS.showSpacedText) show(args && args[0]);
    else if(fn === OPS.nextLineShowText || fn === OPS.nextLineSetSpacingShowText){
      advance(0, -st.leading);
      // nextLineSetSpacingShowText's args are [aw, ac, glyphs]
      show(Array.isArray(args) ? args.find(a => Array.isArray(a)) : null);
    }
  }
}

/* (v86) Page-space box of every shown text run, by op index (ascent and
   descent estimated from the font size). For text used as a clip: render
   modes 4-7 add the glyphs to the clip at ET, and a gradient painted
   through it ("WordArt" gradient text, PowerPoint's gradient text fill)
   drew nothing in the converted slide -- no clip path for the art crop
   to follow, and the text itself is invisible paint. */
const PC_TEXT_ASCENT = 0.95, PC_TEXT_DESCENT = 0.25;
const PC_TEXT_CLIP_MODE = 4; // Tr 4-7: the text adds to the clip
function pcTextRunBoxes(opList){
  const boxes = new Map();
  pcWalkTextOps(opList, (glyphs, st) => boxes.set(st.op, pcRunBox(glyphs, st)));
  return boxes;
}
/* (v147) The page-space box of one shown run (see pcWalkTextOps). */
function pcRunBox(glyphs, st){
  let w = 0;
  for(const el of glyphs){
    if(typeof el === 'number') w -= (el/1000) * st.fontSize * st.hScale;
    else if(el && typeof el === 'object') w += (((el.width||0)/1000) * st.fontSize + st.charSpacing + (el.isSpace ? st.wordSpacing : 0)) * st.hScale;
  }
  const lo = st.rise - PC_TEXT_DESCENT * st.fontSize, hi = st.rise + PC_TEXT_ASCENT * st.fontSize;
  const pts = [[0, lo], [w, lo], [0, hi], [w, hi]].map(([x, y]) => matApply(st.m, x, y));
  const xs = pts.map(p => p[0]), ys = pts.map(p => p[1]);
  return { minX: pcMinOf(xs), maxX: pcMaxOf(xs), minY: pcMinOf(ys), maxY: pcMaxOf(ys) };
}
/* (v147) The clip box after one more clip (a box {x0, y0, x1, y1} or null).
   The box of a path holds its control points: never smaller than the clip. */
function pcClipCut(clip, box){
  if(!box) return clip;
  if(!clip) return box;
  return { x0: Math.max(clip.x0, box.x0), y0: Math.max(clip.y0, box.y0), x1: Math.min(clip.x1, box.x1), y1: Math.min(clip.y1, box.y1) };
}

function pcTextItemBox(it){
  const t = it.transform, sx = Math.hypot(t[0], t[1]) || 1, sy = Math.hypot(t[2], t[3]) || 1;
  const w = it.width || 0, h = it.height || sy;
  const dx = [t[0] / sx * w, t[1] / sx * w], dy = [t[2] / sy * h, t[3] / sy * h];
  const xs = [t[4], t[4] + dx[0], t[4] + dy[0], t[4] + dx[0] + dy[0]];
  const ys = [t[5], t[5] + dx[1], t[5] + dy[1], t[5] + dx[1] + dy[1]];
  return { l: Math.min(...xs), r: Math.max(...xs), b: Math.min(...ys), t: Math.max(...ys), h, chars: it.str.trim().length };
}
/* (v147) Text that is drawn but nobody can SEE: white (or nearly white)
   text on a white page, and text that lies entirely outside its clip or
   outside the page box. getTextContent() returns it all, so PDF to Word,
   Excel and text copied it into the result; PowerPoint already left it out
   with its own ink check (makeInkChecker). Every page of a document opened
   here now leaves it out, decided once for every tool:
   - outside the clip / page box: from the drawing commands alone (the box
     of a clip path holds its control points, so it is never too small);
   - white text: only when the page render shows no ink at all in the
     run's box (pcPixelsFlat). White text on a dark panel or a photo shows
     ink and stays. Only pages with such a run are rendered.
   Text drawn invisibly on purpose (Tr 3: the text layer of a scanned,
   searchable PDF; Tr 7: text used only as a clip) always stays. A text
   item goes only when every run it is made of is hidden: one line with a
   black and a white word in one pdf.js item stays whole. */
const PC_INK_FLAT_MAX = 24;        // a box whose pixels differ less than this (r+g+b) shows no ink
const PC_WHITE_TEXT_MIN = 242;     // a fill this light in every channel (0.95) is checked on the render
const PC_HIDDEN_RENDER_SCALE = 1;  // the render that checks white text (72 dpi: a 6 pt glyph still shows)
const PC_RUN_MATCH_SHARE = 0.5;    // a run belongs to a text item when they share this much of the smaller box
const PC_CLIP_OUT_SLACK_PT = 0.5;  // a run this close to the clip may still touch it
const PC_TR_FILL = 0, PC_TR_INVISIBLE = 3, PC_TR_FILL_CLIP = 4, PC_TR_CLIP = 7; // text render modes (Tr)
/* The pixels of a page-space box (two opposite corners) on a render, or null
   when the box is under two pixels wide or tall. */
function pcInkBoxPixels(ctx, canvas, viewport, xa, ya, xb, yb){
  const [vx0, vy0] = viewport.convertToViewportPoint(xa, ya);
  const [vx1, vy1] = viewport.convertToViewportPoint(xb, yb);
  const left = Math.max(0, Math.floor(Math.min(vx0, vx1))), top = Math.max(0, Math.floor(Math.min(vy0, vy1)));
  const bw = Math.min(canvas.width - left, Math.ceil(Math.abs(vx1 - vx0))), bh = Math.min(canvas.height - top, Math.ceil(Math.abs(vy1 - vy0)));
  if(bw < 2 || bh < 2) return null;
  return ctx.getImageData(left, top, bw, bh).data;
}
/* One flat colour: nothing visible is drawn there. */
function pcPixelsFlat(d){
  let lo = 765, hi = 0;
  for(let k=0;k<d.length;k+=4){ const v = d[k]+d[k+1]+d[k+2]; if(v<lo) lo=v; if(v>hi) hi=v; }
  return hi - lo <= PC_INK_FLAT_MAX;
}
/* A page's drawing commands without its annotations: one set of options
   everywhere (app-convert.js pcPageOps), so pdf.js's own cache of the list is
   shared and Word, Excel and PowerPoint read it only once. */
function pcPageOpsRaw(page){
  return page.getOperatorList({ annotationMode: pdfjsLib.AnnotationMode.DISABLE });
}
const pcShowsGlyph = el => !!el && typeof el === 'object' && !!String(el.unicode || '').trim();
function pcWhiteFill(st){
  if(st.mode !== PC_TR_FILL && st.mode !== PC_TR_FILL_CLIP) return false; // a stroke has its own colour
  const f = st.fill;
  return !!f && f !== PC_NO_PLAIN_FILL && f.r >= PC_WHITE_TEXT_MIN && f.g >= PC_WHITE_TEXT_MIN && f.b >= PC_WHITE_TEXT_MIN;
}
function pcRunOutside(b, clip){
  if(!clip) return false;
  const s = PC_CLIP_OUT_SLACK_PT;
  return b.maxX < clip.x0 - s || b.minX > clip.x1 + s || b.maxY < clip.y0 - s || b.minY > clip.y1 + s;
}
/* Every shown run of the page: its box, and whether it lies outside the
   clip (out) or is white text still to be checked on the render (white). */
function pcPageRuns(opList, page){
  const v = page.view, view = { x0: Math.min(v[0], v[2]), y0: Math.min(v[1], v[3]), x1: Math.max(v[0], v[2]), y1: Math.max(v[1], v[3]) };
  const runs = [];
  pcWalkTextOps(opList, (glyphs, st) => {
    if(!glyphs.some(pcShowsGlyph)) return;
    const box = pcRunBox(glyphs, st);
    const keep = st.mode === PC_TR_INVISIBLE || st.mode === PC_TR_CLIP;
    runs.push({ box, keep, out: !keep && pcRunOutside(box, pcClipCut(st.clip, view)), white: !keep && pcWhiteFill(st), flat: false });
  });
  return runs;
}
/* Marks the white runs that show no ink on the page render. A render that
   fails proves nothing: the text then stays, as before v147 (logged). */
async function pcMarkFlatRuns(runs, getRenderPage){
  let c = null;
  try{
    const page = await getRenderPage();
    const vp = page.getViewport({ scale: PC_HIDDEN_RENDER_SCALE });
    c = document.createElement('canvas');
    c.width = Math.max(1, Math.ceil(vp.width)); c.height = Math.max(1, Math.ceil(vp.height));
    const ctx = pcCanvas2d(c);
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, c.width, c.height);
    await page.render({ canvasContext: ctx, viewport: vp }).promise;
    runs.forEach(r => { const d = pcInkBoxPixels(ctx, c, vp, r.box.minX, r.box.maxY, r.box.maxX, r.box.minY); r.flat = !!d && pcPixelsFlat(d); });
  }catch(e){ pcLogUnexpected(e); }
  finally{ if(c) c.width = c.height = 0; }
}
const pcRunHidden = r => !r.keep && (r.out || r.flat);
function pcBoxShare(it, r){
  const b = pcTextItemBox(it), rb = r.box;
  const w = Math.min(b.r, rb.maxX) - Math.max(b.l, rb.minX), h = Math.min(b.t, rb.maxY) - Math.max(b.b, rb.minY);
  const small = Math.min((b.r - b.l) * (b.t - b.b), (rb.maxX - rb.minX) * (rb.maxY - rb.minY));
  return w > 0 && h > 0 && small > 0 ? w * h / small : 0;
}
/* A text item goes when it is made of runs only, and every one of them is hidden. */
function pcItemHidden(it, runs){
  if(!it.str || !it.str.trim() || !it.transform) return false;
  let matched = 0;
  for(const r of runs){
    if(pcBoxShare(it, r) < PC_RUN_MATCH_SHARE) continue;
    if(!pcRunHidden(r)) return false;
    matched++;
  }
  return matched > 0;
}
async function pcWithoutInvisibleText(page, tc, getRenderPage){
  const runs = pcPageRuns(await pcPageOpsRaw(page), page);
  const white = runs.filter(r => r.white && !r.out);
  if(white.length) await pcMarkFlatRuns(white, getRenderPage);
  if(!runs.some(pcRunHidden)) return tc;
  const items = tc.items.filter(it => !pcItemHidden(it, runs));
  return items.length === tc.items.length ? tc : Object.assign({}, tc, { items });
}
/* (v147) A text-only tool (PDF to text) opens its document without images
   (maxImageSize: pdf.js then skips decoding them -- reading the drawing
   commands of a 25 MB photo PDF took 39 s instead of 0.7 s). Pages with
   white text are rendered from a second, full copy of the file, opened only
   when such a page comes up (renderFrom gives its bytes again). */
const PC_NO_IMAGES = 1; // pdf.js maxImageSize: every image larger than one pixel is left out
function pcTextOnlySource(bytes){ return Object.assign(pcPdfSource(bytes), { maxImageSize: PC_NO_IMAGES }); }
function pcRenderTwin(renderFrom){
  let task = null, doc = null;
  return {
    page: async n => {
      if(!doc){ task = pcPdfjsTask(pcPdfSource(new Uint8Array(await renderFrom()))); doc = await task.promise; }
      return doc.getPage(n);
    },
    destroy: () => (task ? task.destroy() : Promise.resolve()),
  };
}
/* The question in the status box (after a failed run of that tool). */
function pcAskPassword(st, text, name){
  const old = st.querySelector('.pc-pw');
  if(old) old.remove();
  if(text) text.textContent = pcT(pcTypedPassword ? 'pwWrong' : 'pwAsk');
  const box = document.createElement('div');
  box.className = 'pc-pw';
  const label = document.createElement('label');
  label.htmlFor = 'pc-pw-' + name;
  label.textContent = pcT('pwLabel');
  const input = document.createElement('input');
  Object.assign(input, { type: 'password', id: 'pc-pw-' + name, autocomplete: 'off', spellcheck: false, className: 'text-input' });
  if(text){ if(!text.id) text.id = st.id + '-text'; input.setAttribute('aria-describedby', text.id); }
  if(pcTypedPassword) input.setAttribute('aria-invalid', 'true'); // only a wrong one is "invalid"; the first ask just gets the focus
  pcTypedPassword = ''; // (v119 review) never tried again on another file unasked
  const retry = document.createElement('button');
  retry.type = 'button';
  retry.className = 'btn';
  retry.textContent = pcT('pwRetry');
  const go = () => {
    if(!input.value){ pcAnnounce(pcT('pwAsk'), true); input.focus(); return; }
    pcTypedPassword = input.value;
    const btn = document.getElementById('btn-' + name);
    if(btn && !btn.disabled) btn.click();
  };
  retry.addEventListener('click', go);
  input.addEventListener('keydown', e => { if(e.key === 'Enter'){ e.preventDefault(); go(); } });
  box.append(label, input, retry);
  st.appendChild(box);
  return input;
}
/* After a run that used the typed password: the result has no password. */
function pcNotePasswordGone(name){
  const info = document.getElementById('result-' + name + '-info');
  if(!info) return;
  const n = info.parentNode && info.parentNode.querySelector(':scope > .pc-note[data-for="' + info.id + '"]');
  pcShowNote(info, [n && !n.hidden ? n.textContent : '', pcT('pwRemovedNote')].filter(Boolean).join(' '));
}

/* ---------- pdf.js: always CMaps + standard fonts ---------- */
/* (v49) The CMaps (CJK and other composite fonts) and the standard fonts
   are passed explicitly on every getDocument() call below (pcPdfSource);
   patching pdfjsLib.getDocument is only a second line of defence for any
   other caller. Without them, CJK text could silently come out empty if
   the library object could not be patched. */
// (v52) cmaps and standard fonts from this site too: fetching one from a CDN
// told it which scripts/fonts the visitor's PDF uses
const PC_PDFJS_BASE = new URL('/vendor/pdfjs-4.10.38/', location.href).href;
function pcPdfSource(data){
  // (v52) isEvalSupported:false -- pdf.js 3.x compiled font outlines with
  // new Function(), which a crafted PDF could abuse to run script on this
  // page (CVE-2024-4367, fixed in pdf.js 4.2.67; v60 runs 4.10.38). Kept as
  // defence in depth: nothing on this site needs eval.
  return Object.assign(pcPdfJsDataOptions(), { data, isEvalSupported: false });
}
/* (v98) pdf.js asks for a CMap or a standard font by NAME, and that name
   says something about the file (UniJIS-UCS2-H = Japanese text). Where the
   service worker doesn't have them yet (first visit, a private window, no
   service worker), the first one asked for fetches the whole set (±1.9 MB,
   the set the service worker keeps for the tool pages anyway), so our
   server learns no more than "a PDF needed pdf.js's data". The lists must
   match the folders (build.mjs checks this, as for sw.js). */
const PC_PDFJS_CMAPS = '78-EUC-H 78-EUC-V 78-H 78-RKSJ-H 78-RKSJ-V 78-V 78ms-RKSJ-H 78ms-RKSJ-V 83pv-RKSJ-H 90ms-RKSJ-H 90ms-RKSJ-V 90msp-RKSJ-H 90msp-RKSJ-V 90pv-RKSJ-H 90pv-RKSJ-V Add-H Add-RKSJ-H Add-RKSJ-V Add-V Adobe-CNS1-0 Adobe-CNS1-1 Adobe-CNS1-2 Adobe-CNS1-3 Adobe-CNS1-4 Adobe-CNS1-5 Adobe-CNS1-6 Adobe-CNS1-UCS2 Adobe-GB1-0 Adobe-GB1-1 Adobe-GB1-2 Adobe-GB1-3 Adobe-GB1-4 Adobe-GB1-5 Adobe-GB1-UCS2 Adobe-Japan1-0 Adobe-Japan1-1 Adobe-Japan1-2 Adobe-Japan1-3 Adobe-Japan1-4 Adobe-Japan1-5 Adobe-Japan1-6 Adobe-Japan1-UCS2 Adobe-Korea1-0 Adobe-Korea1-1 Adobe-Korea1-2 Adobe-Korea1-UCS2 B5-H B5-V B5pc-H B5pc-V CNS-EUC-H CNS-EUC-V CNS1-H CNS1-V CNS2-H CNS2-V ETHK-B5-H ETHK-B5-V ETen-B5-H ETen-B5-V ETenms-B5-H ETenms-B5-V EUC-H EUC-V Ext-H Ext-RKSJ-H Ext-RKSJ-V Ext-V GB-EUC-H GB-EUC-V GB-H GB-V GBK-EUC-H GBK-EUC-V GBK2K-H GBK2K-V GBKp-EUC-H GBKp-EUC-V GBT-EUC-H GBT-EUC-V GBT-H GBT-V GBTpc-EUC-H GBTpc-EUC-V GBpc-EUC-H GBpc-EUC-V H HKdla-B5-H HKdla-B5-V HKdlb-B5-H HKdlb-B5-V HKgccs-B5-H HKgccs-B5-V HKm314-B5-H HKm314-B5-V HKm471-B5-H HKm471-B5-V HKscs-B5-H HKscs-B5-V Hankaku Hiragana KSC-EUC-H KSC-EUC-V KSC-H KSC-Johab-H KSC-Johab-V KSC-V KSCms-UHC-H KSCms-UHC-HW-H KSCms-UHC-HW-V KSCms-UHC-V KSCpc-EUC-H KSCpc-EUC-V Katakana NWP-H NWP-V RKSJ-H RKSJ-V Roman UniCNS-UCS2-H UniCNS-UCS2-V UniCNS-UTF16-H UniCNS-UTF16-V UniCNS-UTF32-H UniCNS-UTF32-V UniCNS-UTF8-H UniCNS-UTF8-V UniGB-UCS2-H UniGB-UCS2-V UniGB-UTF16-H UniGB-UTF16-V UniGB-UTF32-H UniGB-UTF32-V UniGB-UTF8-H UniGB-UTF8-V UniJIS-UCS2-H UniJIS-UCS2-HW-H UniJIS-UCS2-HW-V UniJIS-UCS2-V UniJIS-UTF16-H UniJIS-UTF16-V UniJIS-UTF32-H UniJIS-UTF32-V UniJIS-UTF8-H UniJIS-UTF8-V UniJIS2004-UTF16-H UniJIS2004-UTF16-V UniJIS2004-UTF32-H UniJIS2004-UTF32-V UniJIS2004-UTF8-H UniJIS2004-UTF8-V UniJISPro-UCS2-HW-V UniJISPro-UCS2-V UniJISPro-UTF8-V UniJISX0213-UTF32-H UniJISX0213-UTF32-V UniJISX02132004-UTF32-H UniJISX02132004-UTF32-V UniKS-UCS2-H UniKS-UCS2-V UniKS-UTF16-H UniKS-UTF16-V UniKS-UTF32-H UniKS-UTF32-V UniKS-UTF8-H UniKS-UTF8-V V WP-Symbol'; // + .bcmap
const PC_PDFJS_FONTS = 'FoxitDingbats.pfb FoxitFixed.pfb FoxitFixedBold.pfb FoxitFixedBoldItalic.pfb FoxitFixedItalic.pfb FoxitSerif.pfb FoxitSerifBold.pfb FoxitSerifBoldItalic.pfb FoxitSerifItalic.pfb FoxitSymbol.pfb LiberationSans-Bold.ttf LiberationSans-BoldItalic.ttf LiberationSans-Italic.ttf LiberationSans-Regular.ttf';
let pcPdfJsFiles = null;
// (v157) a CMap or standard font that failed to load during this run: pdf.js
// then silently leaves that text out, so the run must not end as "Done"
var pcPdfJsMissed = false; // var: pcSetProcessing (above) may run before this line in theory
function pcPdfJsDataSet(){
  if(!pcPdfJsFiles){
    const paths = PC_PDFJS_CMAPS.split(' ').map(n => 'cmaps/' + n + '.bcmap')
      .concat(PC_PDFJS_FONTS.split(' ').map(n => 'standard_fonts/' + n));
    // one result per file ({bytes} or {err}): a file that fails only fails where it is needed
    pcPdfJsFiles = new Map(paths.map(p => [p, fetch(PC_PDFJS_BASE + p, { credentials: 'same-origin' }).then(r => {
      if(!r.ok) throw new Error(p + ': HTTP ' + r.status);
      return r.arrayBuffer();
    }).then(b => ({ bytes: new Uint8Array(b) }), err => ({ err }))]));
  }
  return pcPdfJsFiles;
}
// a copy each time: pdf.js may hand the buffer over to its worker
async function pcPdfJsFile(path){
  const set = pcPdfJsDataSet();
  const p = set.get(path);
  if(!p) throw new Error('pdf.js data not on this site: ' + path);
  const r = await p;
  if(r.bytes) return r.bytes.slice();
  // the next file asks for the whole set again (never for this one alone: that would name it)
  if(pcPdfJsFiles === set) pcPdfJsFiles = null;
  pcPdfJsMissed = true;
  throw r.err;
}
// pdf.js 4.10 factory interface (it calls new X({ baseUrl, ... }) and fetch())
class PcCMapReaderFactory {
  async fetch({ name }){ return { cMapData: await pcPdfJsFile('cmaps/' + name + '.bcmap'), isCompressed: true }; }
}
class PcStandardFontDataFactory {
  async fetch({ filename }){ return pcPdfJsFile('standard_fonts/' + filename); }
}
function pcPdfJsDataOptions(){
  return { cMapUrl: PC_PDFJS_BASE + 'cmaps/', cMapPacked: true, standardFontDataUrl: PC_PDFJS_BASE + 'standard_fonts/',
    CMapReaderFactory: PcCMapReaderFactory, StandardFontDataFactory: PcStandardFontDataFactory };
}
/* (v56) Runs once, right after pcLoadPdfLibs() has loaded pdf.js (it used
   to run at start-up, when pdf.js was a <script defer> of every page). */
function pcSetupPdfJs(){
  // (v52) served from this site: the worker sees every file's bytes, and a
  // cross-site worker can't carry Subresource Integrity
  pdfjsLib.GlobalWorkerOptions.workerSrc = PC_PDFJS_BASE + 'pdf.worker.min.mjs';
  pcPatchPdfJs();
}
function pcPatchPdfJs(){
  if(typeof pdfjsLib === 'undefined' || !pdfjsLib.getDocument) return;
  const orig = pdfjsLib.getDocument;
  const patched = function(src){
    if(src instanceof ArrayBuffer || ArrayBuffer.isView(src)) src = { data: src };
    if(src && typeof src === 'object'){
      // (never eval, whatever the caller passed: see pcPdfSource)
      src = Object.assign(pcPdfJsDataOptions(), src, { isEvalSupported: false });
    }
    return orig.call(this, src);
  };
  // Three ways to install the patch, each tried only if the previous one
  // did not take; if none works, the explicit options above still apply.
  // (v60) pdf.js 4 exposes window.pdfjsLib with read-only properties, so
  // there only the third way (a patched copy) takes.
  try{ pdfjsLib.getDocument = patched; }catch(e){ /* next way below */ }
  if(pdfjsLib.getDocument !== patched){
    try{ Object.defineProperty(pdfjsLib, 'getDocument', { value: patched, configurable: true, writable: true }); }catch(e){ /* next way below */ }
  }
  if(pdfjsLib.getDocument !== patched){
    try{ window.pdfjsLib = Object.assign(Object.create(Object.getPrototypeOf(pdfjsLib)), pdfjsLib, { getDocument: patched }); }catch(e){ /* explicit options still apply */ }
  }
}

/* ---------- cancel ---------- */
const pcCancel = { requested: false };
function pcCancelError(){
  const e = new Error(pcT('cancelled'));
  e.name = 'PcCancelled';
  e.userFacing = true;
  return e;
}
function pcCheckCancel(){ if(pcCancel.requested) throw pcCancelError(); }
function pcIsCancel(err){ return !!(err && err.name === 'PcCancelled'); }
/* (v140; in app.js since perf, from app-convert.js) A conversion runs on the page and used to hold it for up to ~2 s
   at a time (4x slowed CPU): Cancel, scrolling and tab clicks waited for it.
   The long loops now give the page back to the browser every PC_SLICE_MS
   (pcYieldIfDue), and a Cancel pressed in between stops the work right
   there. Only the timing changes: every step still runs in the same order
   on the same data, so the files come out byte for byte the same. */
const PC_SLICE_MS = 40;
let pcSliceStart = 0;
function pcYieldToPage(){
  // scheduler.yield (Chrome/Edge 129+, where available) resumes before other
  // queued tasks; elsewhere (Safari, older Firefox) a MessageChannel message, which, unlike
  // setTimeout, is not slowed to once a second in a background tab
  if(typeof scheduler !== 'undefined' && scheduler && typeof scheduler.yield === 'function') return scheduler.yield();
  return new Promise(resolve => {
    const ch = new MessageChannel();
    ch.port1.onmessage = () => { ch.port1.close(); resolve(); };
    ch.port2.postMessage(0);
  });
}
/* Awaited inside long loops: a no-op until PC_SLICE_MS have passed. */
function pcYieldIfDue(){
  if(performance.now() - pcSliceStart < PC_SLICE_MS) return null;
  return pcYieldToPage().then(() => { pcSliceStart = performance.now(); pcCheckCancel(); });
}
/* Array forEach / map / filter that give the page back while they run (same
   order, same callbacks, same result). */
async function pcEachSliced(arr, fn){
  const n = arr.length;
  for(let k = 0; k < n; k++){
    await pcYieldIfDue();
    if(k in arr) await fn(arr[k], k, arr);
  }
}
async function pcMapSliced(arr, fn){
  const out = new Array(arr.length);
  await pcEachSliced(arr, (v, k, a) => { out[k] = fn(v, k, a); });
  return out;
}
async function pcFilterSliced(arr, fn){
  const out = [];
  await pcEachSliced(arr, (v, k, a) => { if(fn(v, k, a)) out.push(v); });
  return out;
}
window.PDFC_CANCEL = { check: pcCheckCancel, isCancel: pcIsCancel, error: pcCancelError, state: pcCancel };
/* (v68) Called right when Cancel is pressed (a running worker is stopped at
   once instead of at the next check). */
const pcCancelHooks = new Set();
function pcRequestCancel(){
  pcCancel.requested = true;
  pcCancelHooks.forEach(stop => stop());
}

/* ---------- (v68) background worker ----------
   Heavy work runs in pc-worker.js, which holds the same PDF code as this page
   (pc-pdfcore.js). The page stays responsive, Cancel ends the worker at once,
   and ending it releases all of its memory. A browser that can't run it
   (no Worker or OffscreenCanvas, or the worker can't load) gets the work
   done on the page, as before v68. */
const PC_WORKER_URL = '/pc-worker.js' + PC_REL;
let pcWorkerUnavailable = typeof Worker === 'undefined' || typeof OffscreenCanvas === 'undefined';
const PC_WORKER_MAX_START_FAILS = 2; // (v94) see pcStartWorker
let pcWorkerStartFails = 0;
const PC_WORKER_START_MS = 15000; // no 'ready' by then (e.g. a stalled download): the page does the work
/* (perf) No message at all from a worker with a job (it sends one every PC_WORKER_BEAT_MS)
   for this long while the page is shown: it is gone. Generous, because one long
   synchronous step (pdf-lib reading or saving a huge file) also holds back its signs. */
// (v149) 180 s, not 90: the beat is a timer inside the worker, so one long synchronous step (writing a large
// deck on a slow phone) also stays silent; ending a healthy run is worse than a longer wait for a dead worker
const PC_WORKER_SILENT_MS = 180000;
const PC_WORKER_WATCH_MS = 5000; // how often the page checks
/* Starts a worker and loads its libraries: { done, abort }. done resolves
   with the worker, or with null when it can't run here (the page then does
   the work); abort() stops a start that is still going (Cancel). */
function pcStartWorker(){
  if(pcWorkerUnavailable) return { done: Promise.resolve(null), abort(){} };
  let w = null, settle = null, timer = 0;
  const done = new Promise(resolve => { settle = resolve; });
  // (v94) permanent: this browser can't run it at all. A failed load or a
  // timeout (a slow connection) gets one more try at the next start instead
  // of switching the worker off for the whole visit.
  const end = (worker, usable, permanent) => {
    clearTimeout(timer);
    if(!settle) return;
    const s = settle; settle = null;
    if(!worker){
      if(w) w.terminate();
      if(!usable && (permanent || ++pcWorkerStartFails >= PC_WORKER_MAX_START_FAILS)) pcWorkerUnavailable = true;
    }
    s(worker);
  };
  try{ w = new Worker(PC_WORKER_URL); }
  catch(e){ pcLogUnexpected(e); end(null, false, true); return { done, abort(){} }; } // e.g. blocked by the browser
  // (v111) the page does the work then, but a broken pc-worker.js must leave a trace
  w.onerror = e => { e.preventDefault(); pcLogUnexpected(new Error('worker start: ' + (e.message || 'load error'))); end(null, false); };
  w.onmessage = e => {
    if(e.data && e.data.type === 'ready'){ w.onerror = null; w.onmessage = null; pcWorkerStartFails = 0; end(w, true); }
    else end(null, false, true); // 'unsupported' (no OffscreenCanvas): expected, not logged
  };
  timer = setTimeout(() => end(null, false), PC_WORKER_START_MS);
  w.postMessage({ type: 'init', msgs: Object.assign({}, PC_MSG.en, PC_MSG[PDFC_LANG]) });
  return { done, abort: () => end(null, true) };
}
/* The page's own kind of error again, from what the worker sent. */
function pcWorkerError(d){
  const e = d.name === 'RangeError' ? new RangeError(d.message) : new Error(d.message);
  e.name = d.name;
  if(d.userFacing) e.userFacing = true;
  if(d.field) e.field = true;
  if(d.pw) e.pw = true; // (v119)
  if(d.cause) e.cause = pcWorkerError(d.cause); // (v113) the v111 diagnostic of pcLogUnexpected
  return e;
}
/* One worker for one run of a tool. run(job, file, option, onProgress) does a
   job from PC_JOBS there; close() ends the worker. (v90) onProgress (optional)
   gets 0..1 within that file. When the worker reports a crash (an uncaught
   error or a message it can't read) that file fails with a clear message and
   the next file gets a fresh worker.
   (perf) Watchdog: a worker that disappears without any event (WebKit ends
   one silently when memory runs out) used to leave the run waiting until
   Cancel. The worker sends a sign of life while it works; after
   PC_WORKER_SILENT_MS without any message while the page is shown, the
   worker is ended and the file fails with the same message as a crash. Time
   in a hidden tab does not count (a browser may pause the worker there). */
function pcWorkerSession(){
  // (v149) silence is counted in watch ticks, not clock time: after a laptop wakes from sleep Date.now()
  // jumps ahead and a healthy run was ended; a tick only fires while the page really runs
  let worker = null, starting = null, pending = null, nextId = 0, watch = 0, silentTicks = 0;
  const alive = () => { silentTicks = 0; };
  const onVisible = () => { if(!document.hidden) alive(); };
  const unwatch = () => {
    clearInterval(watch); watch = 0;
    document.removeEventListener('visibilitychange', onVisible);
  };
  const finish = (fn, value) => {
    unwatch();
    const p = pending; pending = null;
    if(p) fn === 'resolve' ? p.resolve(value) : p.reject(value);
  };
  const stop = err => {
    if(starting) starting.abort();
    if(worker){ worker.terminate(); worker = null; }
    finish('reject', err);
  };
  const onCancel = () => stop(pcCancelError());
  pcCancelHooks.add(onCancel);
  function attach(w){
    w.onmessage = e => {
      const m = e.data || {};
      alive();
      if(m.type === 'beat') return; // (perf) only a sign of life
      if(m.type === 'log'){ pcLogUnexpected(pcWorkerError(m.error)); return; }
      if(m.type === 'pwUsed'){ pcHostPasswordUsed(); return; } // (v119)
      if(!pending || m.id !== pending.id) return;
      if(m.type === 'progress'){
        // (v113) an async progress callback (Split's) can stop on Cancel: that is handled by stop(), anything else is logged
        const p = pending.onProgress && pending.onProgress(m.value);
        if(p && p.catch) p.catch(err => { if(!pcIsCancel(err)) pcLogUnexpected(err); });
        return;
      }
      if(m.type === 'done') finish('resolve', m.result); else finish('reject', pcWorkerError(m.error));
    };
    w.onerror = e => {
      e.preventDefault();
      // the visitor gets the plain message; the cause goes to the console
      pcLogUnexpected(new Error('worker stopped: ' + (e.message || 'no reason given')));
      stop(pcUserError(pcT('workerFailed')));
    };
    w.onmessageerror = () => stop(pcUserError(pcT('workerFailed')));
  }
  // (v140) transfer: buffers in file/opt handed over to the worker instead of copied (they are unusable on the page afterwards)
  async function run(job, file, opt, onProgress, transfer){
    pcCheckCancel();
    if(!worker && !pcWorkerUnavailable){
      starting = pcStartWorker();
      worker = await starting.done;
      starting = null;
      pcCheckCancel(); // Cancel pressed while it started (close() ends it)
      if(worker) attach(worker);
    }
    if(!worker) return PC_JOBS[job](file, opt, onProgress); // this browser: on the page
    return new Promise((resolve, reject) => {
      pending = { id: ++nextId, resolve, reject, onProgress };
      watchSilence();
      const msg = { type: 'job', id: pending.id, job, file, opt };
      if(pcHostPassword()) msg.pw = pcHostPassword(); // (v119) the typed password, only when there is one
      worker.postMessage(msg, transfer || []);
    });
  }
  function watchSilence(){
    alive();
    document.addEventListener('visibilitychange', onVisible);
    watch = setInterval(() => {
      if(document.hidden || ++silentTicks * PC_WORKER_WATCH_MS < PC_WORKER_SILENT_MS) return;
      pcLogUnexpected(new Error('worker silent for ' + PC_WORKER_SILENT_MS / 1000 + ' s: ended'));
      stop(pcUserError(pcT('workerFailed')));
    }, PC_WORKER_WATCH_MS);
  }
  function close(){
    unwatch();
    pcCancelHooks.delete(onCancel);
    if(worker){ worker.terminate(); worker = null; }
  }
  return { run, close };
}
/* When a tool starts, the finished results of the OTHER tools are released:
   each one is a full file kept in memory until the page closes, and on a
   big job that memory is needed (in testing, image decoding started to
   fail with two earlier 236 MB results still held). Their result boxes
   are hidden, so no dead download link is left behind. */
/* (v90) The tool's OWN previous result too: its box is already hidden at the
   start, but the file stayed in memory during the new run (and after a
   cancel). Only its status box is left alone (it shows the new run). */
function pcReleaseOtherResults(activeStatus){
  const active = (activeStatus.id || '').replace(/^status-/, '');
  pcForgetShare(active); // (v73) the separate files of this tool's previous result are not needed during the new run
  document.querySelectorAll('a[id^="download-"]').forEach(a => {
    const name = a.id.slice(9);
    if(!a.href || a.href.indexOf('blob:') !== 0) return;
    try{ URL.revokeObjectURL(a.href); }catch(e){ /* already released */ }
    a.removeAttribute('href');
    pcForgetNextSteps(name); // (v62) its "What next?" copy of the result goes too
    if(name === active) return;
    const res = document.getElementById('result-' + name);
    if(res) res.classList.remove('show');
    const st = document.getElementById('status-' + name);
    if(st) st.classList.remove('show', 'done', 'error');
  });
}
/* (v65) The name of the chosen picture next to our own file button (see
   .pc-file-native in style.css); textContent, so a file name is never HTML. */
(function fileButtons(){
  function start(){
    pcEachPanel(panel => panel.querySelectorAll('input[type="file"].pc-file-native').forEach(inp => { // (v116) also panels made later
      const out = document.getElementById(inp.id + '-name');
      if(!out) return;
      inp.addEventListener('change', () => { out.textContent = inp.files && inp.files[0] ? inp.files[0].name : (out.dataset.empty || ''); });
    }));
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
/* A Cancel button appears inside any tool's status box while it is working. */
(function cancelButtons(){
  function sync(st){
    let b = st.querySelector(':scope > .pc-cancel');
    const working = st.classList.contains('working');
    if(working){
      if(!b){
        pcCancel.requested = false;
        pcReleaseOtherResults(st);
        b = document.createElement('button');
        b.type = 'button';
        b.className = 'pc-cancel';
        b.textContent = pcT('cancel');
        b.style.cssText = 'margin-top:8px;padding:4px 12px;font:inherit;font-size:0.85rem;border:1px solid currentColor;border-radius:6px;background:transparent;color:inherit;cursor:pointer';
        // (v115) aria-disabled, not disabled: a disabled button under the focus threw keyboard users back to the top of the page
        b.addEventListener('click', () => { if(b.getAttribute('aria-disabled') === 'true') return; b.setAttribute('aria-disabled', 'true'); pcRequestCancel(); });
        // (v49) focus moves here after Start: a held-down (repeating) Enter
        // from the Start button must not press Cancel as well
        b.addEventListener('keydown', e => { if(e.repeat) e.preventDefault(); });
        st.appendChild(b);
      }
    }else if(b){
      if(document.activeElement === b){ st.tabIndex = -1; st.focus(); } // (v115) the focus stays at the result instead of falling to the page top
      b.remove(); pcCancel.requested = false;
    }
  }
  function start(){
    const obs = new MutationObserver(ms => ms.forEach(m => { if(m.target.classList) sync(m.target); }));
    const watchIn = root => root.querySelectorAll('.status, [id^="status-"]').forEach(st => {
      if(/-text$/.test(st.id)) return;
      obs.observe(st, { attributes: true, attributeFilter: ['class'] });
      sync(st);
    });
    watchIn(document);
    document.addEventListener('pc-panel', e => watchIn(e.detail)); // (v116)
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* ---------- (v49) accessibility of the tool panels ----------
   Done in one place for all tools, so no tool's own code had to change:
   - option cards (<button class="quality-opt">): one delegated handler keeps
     the "selected" look and aria-pressed in step (the tools' own click
     handlers still read the choice);
   - progress bars (role="progressbar"): aria-valuenow follows the width
     the tools set;
   - status box: when a tool starts, focus goes to its Cancel button; when
     the result is ready, to the download button (and the result summary is
     read out); after an error or a cancel, back to the start button (or the
     status message when that button is disabled). Errors are also read out
     at once through the assertive live region.
   Focus is only moved when it was inside that tool's panel or had been
   lost (on <body>), never away from something the visitor chose meanwhile. */
const PC_DONE_FOCUS_DELAY_MS = 300;
(function pcA11yPanels(){
  // (v115) a download button says WHICH file it gives ("Download: report-merged.pdf"),
  // not only "Download": the name is set by each tool on the download attribute
  const nameDownload = a => {
    if(!a.download) { a.removeAttribute('aria-label'); return; }
    a.setAttribute('aria-label', a.textContent.trim() + ': ' + a.download);
  };
  const dlObs = new MutationObserver(ms => ms.forEach(m => nameDownload(m.target)));
  pcEachPanel(panel => panel.querySelectorAll('a[id^="download-"]').forEach(a => dlObs.observe(a, { attributes: true, attributeFilter: ['download'] })));
  document.addEventListener('click', e => {
    const opt = e.target.closest && e.target.closest('.quality-opt');
    if(!opt || !opt.parentElement) return;
    opt.parentElement.querySelectorAll(':scope > .quality-opt').forEach(o => {
      const on = o === opt;
      o.classList.toggle('selected', on);
      o.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  });

  const PERCENT = /(\d+(?:\.\d+)?)%/;
  function syncProgress(fill){
    const bar = fill.parentElement;
    if(!bar || bar.getAttribute('role') !== 'progressbar') return;
    const m = PERCENT.exec(fill.style.width || '');
    const v = String(m ? Math.max(0, Math.min(100, Math.round(parseFloat(m[1])))) : 0);
    if(bar.getAttribute('aria-valuenow') !== v) bar.setAttribute('aria-valuenow', v);
    pcTitleProgress(v); // (v95)
  }
  const progressObs = new MutationObserver(ms => ms.forEach(m => syncProgress(m.target)));
  pcEachPanel(panel => panel.querySelectorAll('.progress-fill').forEach(f => { // (v116) also panels made later
    progressObs.observe(f, { attributes: true, attributeFilter: ['style'] });
    syncProgress(f);
  }));

  function pcFocusIsOnField(panel, st){
    const a = document.activeElement;
    return !!(a && panel && panel.contains(a) && !st.contains(a) && a.matches('input, select, textarea, canvas, [tabindex]'));
  }
  function focusLost(){
    const a = document.activeElement;
    return !a || a === document.body || a === document.documentElement || !a.isConnected;
  }
  function mayMoveFocus(panel){ return focusLost() || !!(panel && panel.contains(document.activeElement)); }
  function focusBox(el){
    if(!el) return;
    if(!/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(el.tagName) && !el.hasAttribute('tabindex')) el.tabIndex = -1;
    el.focus();
  }
  // the tables write "Terminé !" with different (no-break) spaces
  function pcSameText(a, b){ return a.replace(/\s/g, '') === b.replace(/\s/g, ''); }
  function stateOf(st){
    if(st.classList.contains('working')) return 'working';
    if(st.classList.contains('error')) return 'error';
    if(st.classList.contains('done')) return 'done';
    return '';
  }
  function watch(st){
    const name = st.id.replace(/^status-/, '');
    const panel = st.closest('.panel');
    const text = document.getElementById(st.id + '-text');
    const btn = document.getElementById('btn-' + name);
    const result = document.getElementById('result-' + name);
    const download = document.getElementById('download-' + name);
    const resultReady = () => !!(result && result.classList.contains('show') && download && download.getAttribute('href'));
    function react(now){
      if(stateOf(st) !== now) return; // changed again in the meantime
      if(now === 'working'){
        const pw = st.querySelector('.pc-pw');
        if(pw) pw.remove(); // (v119)
        pcAnnounce('', true); // an old error must not linger in the alert region
        const cancel = st.querySelector('.pc-cancel');
        if(cancel && mayMoveFocus(panel)) cancel.focus();
      }else if(now === 'error'){
        const pwInput = pcPasswordAsked && !PC_PW_OWN_FIELD.has(name) ? pcAskPassword(st, text, name) : null; // (v119)
        if(!pcPasswordAsked) pcTypedPassword = ''; // (v119 review) failed for another reason: the password is not kept
        pcPasswordAsked = false;
        const msg = (text || st).textContent.trim();
        if(msg && msg !== pcT('cancelled')) pcAnnounce(msg, true);
        if(!mayMoveFocus(panel)) return;
        // (v65) a field to correct (a page list, a password) gets the
        // focus; a field the tool itself pointed to (the signature box
        // when there is no signature yet) keeps it. Only a field that can
        // be seen: an old mark on a hidden field would lose the focus.
        const invalid = panel && [...panel.querySelectorAll('[aria-invalid="true"]')]
          .find(el => el.getClientRects().length && !el.closest('[hidden]'));
        if(invalid){ focusBox(invalid); return; }
        if(pwInput){ pwInput.focus(); return; }
        if(pcFocusIsOnField(panel, st)) return;
        focusBox(btn && !btn.disabled ? btn : st);
      }else if(now === 'done'){
        if(pcPasswordUsedRun && !PC_PW_OWN_FIELD.has(name)) pcNotePasswordGone(name); // (v119)
        pcTypedPassword = ''; // (v119 review) used for this run only
        // normally the result box takes focus (below); if a tool finished
        // without one, the status message gets it instead of <body>
        setTimeout(() => { if(focusLost()) focusBox(resultReady() ? download : st); }, PC_DONE_FOCUS_DELAY_MS);
      }
    }
    let last = stateOf(st);
    new MutationObserver(() => {
      const now = stateOf(st);
      if(now === last) return;
      last = now;
      if(now === 'working'){ pcPasswordAsked = false; pcPasswordUsedRun = false; } // (v119) at once: the run may report either soon
      // (v121) a plain "Done!" says what the result box below already says: the
      // CSS hides it once that box is shown ("Done, but skipped: …" stays).
      // (v122) here, before the next paint: in react() it flashed for ±50 ms
      if(now === 'done') st.classList.toggle('pc-plain', !!text && pcSameText(text.textContent, pcT('stDone')));
      // after the tool's own code (button re-enabled, Cancel button removed)
      setTimeout(() => react(now), 0);
    }).observe(st, { attributes: true, attributeFilter: ['class'] });

    if(!result) return;
    let shown = result.classList.contains('show');
    new MutationObserver(() => {
      const now = result.classList.contains('show');
      if(now === shown) return;
      shown = now;
      if(!now) return;
      setTimeout(() => {
        if(!result.classList.contains('show')) return;
        const info = result.querySelector('.info');
        // (v57) innerText keeps the break between the summary and a note
        // below it ("editable text. This PDF..." instead of "textThis PDF");
        // the status word is left out when the summary already starts with it
        // ("Done — 3 pages", not "Done! – Done — 3 pages")
        const parts = [text ? text.textContent : '', info ? (info.innerText || info.textContent) : '']
          .map(x => x.replace(/\s+/g, ' ').trim());
        // (v59) punctuation at both ends is ignored: Spanish opens with "¡"
        // ("¡Listo!" is the same word as "Listo – 3 páginas")
        const lead = parts[0].replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu, '');
        if(lead && parts[1].startsWith(lead)) parts[0] = '';
        const said = parts.filter(Boolean).join(' – ');
        if(said) pcAnnounce(said);
        if(resultReady() && mayMoveFocus(panel)){
          download.focus();
          // (v119, k7-download) and really in view: on a phone a preview that
          // grows after the result (Crop) pushed the button below the screen
          setTimeout(() => pcKeepInView(download), PC_RESULT_SETTLE_MS);
        }
      }, 0);
    }).observe(result, { attributes: true, attributeFilter: ['class'] });
  }
  pcEachPanel(panel => panel.querySelectorAll('.status[id^="status-"]').forEach(watch)); // (v116) also panels made later
  function pcKeepInView(el){
    if(!el.isConnected || document.activeElement !== el) return; // the visitor moved on
    const r = el.getBoundingClientRect();
    if(r.top < 0 || r.bottom > window.innerHeight) el.scrollIntoView({ block: 'center' });
  }
})();

/* ---------- memory warning on phones ---------- */
function pcIsPhone(){
  try{
    // (v111) an Android tablet reports mobile:false but has phone-class memory
    if(navigator.userAgentData && typeof navigator.userAgentData.mobile === 'boolean') return navigator.userAgentData.mobile || navigator.userAgentData.platform === 'Android';
  }catch(e){ /* no client hints: fall back to the user agent below */ }
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent || '') || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}
/* (v94) The memory a tool needs, as a multiple of the size of its files.
   Rough figures: Word/PowerPoint/Excel keep the parsed document plus page
   renders, Compress decodes pictures, Merge/Split hold the files and the
   result. A phone gets a warning above PC_PHONE_MEM_WARN and the job is not
   started above PC_PHONE_MEM_STOP (the tab would be closed), like the
   PDF→JPG budget (checkJpgBudget, tools-more.js).
   ponytail: fixed factors per tool, not measured per file; measure if
   refusals turn out too strict or too loose. */
// Merge holds every file and the result at once; the other tools work file by
// file and free each one, so there the largest file counts
const PC_MEM_ALL_AT_ONCE = new Set(['merge']);
function pcMemEstimate(tool, files){
  const size = PC_MEM_ALL_AT_ONCE.has(tool) ? files.reduce((s, f) => s + f.size, 0) : files.reduce((m, f) => Math.max(m, f.size), 0);
  return size * (PC_MEM_FACTOR[tool] || PC_MEM_FACTOR_DEFAULT);
}
/* Called when a tool starts: on a phone a job over the stop budget is refused. */
function pcCheckPhoneMemory(tool, files){
  if(!pcIsPhone()) return;
  const need = pcMemEstimate(tool, files);
  if(need > PC_PHONE_MEM_STOP) throw pcUserError(pcT('mobileMemStop', fmtSize(need)));
}
function pcMobileMemoryWarning(warningEl, files){
  if(!warningEl) return;
  if(!files.length || !pcIsPhone()){ pcDropMobileWarning(warningEl); return; }
  const tool = (warningEl.id || '').replace(/-large-warning$/, '');
  const need = pcMemEstimate(tool, files);
  if(need <= PC_PHONE_MEM_WARN){ pcDropMobileWarning(warningEl); return; }
  let n = pcMobileWarningOf(warningEl);
  if(!n){
    n = document.createElement('div');
    n.className = (warningEl.className || '') + ' pc-mobile-warn';
    n.setAttribute('data-for', warningEl.id);
    n.setAttribute('role', 'note');
    warningEl.insertAdjacentElement('afterend', n);
  }
  n.style.display = 'block';
  n.textContent = pcT(need > PC_PHONE_MEM_STOP ? 'mobileMemTooBig' : 'mobileMemWarn', fmtSize(need));
}
function pcMobileWarningOf(warningEl){
  return warningEl.parentNode && warningEl.parentNode.querySelector(':scope > .pc-mobile-warn[data-for="' + warningEl.id + '"]');
}
function pcDropMobileWarning(warningEl){ const n = pcMobileWarningOf(warningEl); if(n) n.remove(); }

/* (v68) The PDF core (crypto kit, opening/decrypting with pdf-lib, merge
   helpers, image recompression) lives in pc-pdfcore.js: the build puts it in
   front of this file AND into the background worker (pc-worker.js). */
window.PDFC_OPEN = openPdfForEdit;
/* ---------- JPEG dpi ---------- */
/* Writes the resolution into a JPEG's JFIF header (or adds one), so Word,
   print dialogs and image editors know the intended physical size. */
function pcJpegSetDpi(u8, dpi){
  dpi = Math.max(1, Math.min(65535, Math.round(dpi)));
  if(u8[0] !== 0xFF || u8[1] !== 0xD8) return u8;
  if(u8[2] === 0xFF && u8[3] === 0xE0 && u8[6] === 0x4A && u8[7] === 0x46 && u8[8] === 0x49 && u8[9] === 0x46 && u8[10] === 0){
    const out = u8.slice();
    out[13] = 1; out[14] = dpi >> 8; out[15] = dpi & 255; out[16] = dpi >> 8; out[17] = dpi & 255;
    return out;
  }
  const app0 = new Uint8Array([0xFF,0xE0,0x00,0x10,0x4A,0x46,0x49,0x46,0x00,0x01,0x01,0x01,dpi>>8,dpi&255,dpi>>8,dpi&255,0x00,0x00]);
  return pcConcat(u8.subarray(0, 2), app0, u8.subarray(2));
}
